import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Http } from '@angular/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isEqual } from 'lodash';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Modal } from 'ngx-modal';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '../../../../../node_modules/@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { ApiUrlConstants } from '../../../common/constants/api.constants';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { CurrencyTransformPipe } from '../../../common/pipes/currency-format.pipe';
import { TitleCasePipe } from '../../../common/pipes/title-case.pipe';
import { AppCountryConfig } from '../../../customerservice/interface/app-config';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../../shared/constants/common.constants';
import { Country } from '../../../shared/interface/country.interface';
import { DisplayPriceConfig } from '../../../shared/interface/display-price-config.interface';
import { Member } from '../../../shared/interface/member.interface';
import { StoreConfig } from '../../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService } from '../../../shared/services/common.service';
import { MemberDisplayPriceConfigService } from '../../../shared/services/member-display-price-config.service';
import { MessageService } from '../../../shared/services/message.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { Constants, DelivaryOptionType, IsoCodeThree, MemberType, ProductSource } from '../../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PurchaseFlow, PromotionOrderType } from '../../common/enumerations';
import { DateConstants } from '../../constants/date.constants';
import { MemberTypeId } from '../../constants/member-type-id.enum';
import { PaymentMethodTypeConstants } from '../../constants/payment-method-types.constants';
import { PaymentConstants } from '../../constants/payment.constants';
import { PhoneCodesConstants } from '../../constants/phone-codes.constant';
import { PortalDisplayPage } from '../../constants/portal-display-page.enum';
import { Translations } from '../../constants/translations.constants';
import { EcheckPhoneNumberValidation } from '../../directive/echeck-phone-validation';
import { CartTypes } from '../../enums/cart-type.enum';
import { AccountType } from '../../enums/echeck-accounttypes.enum';
import { EcheckPortalTypes } from '../../enums/echeck-portal-types.enum';
import { ImageType } from '../../enums/image-type.enum';
import { MemberOrderType } from '../../enums/member-order-type.enum';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { MessageTypeEnum } from '../../enums/message-type.enums';
import { NotificationType } from '../../enums/notification-types.enum';
import {
    AddressType,
    OrderSourceType,
    OrderStatus, OrderStatus as OrderStatusEnums, PaymentMethodTypes,PaymentStatusId,PaymentType,
    PriceType, ProductWeightMetric, PurchaseFlows, PurchaseFlowType, ShippingOrderType, ShippingType, Source
} from '../../enums/order-source-type';
import { OrderSourceValue } from '../../enums/order-source.enum';
import { PaymentCardTypes } from '../../enums/payment-card-types.enum';
import { PriceTier } from '../../enums/price-tier.enum';
import { ProductMetatDataValue } from '../../enums/product-metadata.enum';
import { SelectEnum } from '../../enums/selection.enum';
import { ShippingMemberTitle } from '../../enums/shipping-member-title.enum';
import { ShippingMemberType } from '../../enums/shipping-member-type.enum';
import { ValueType } from '../../enums/value-type.enum';
import { PersonalAch } from '../../interface/ach-payment/payment-achrequest.interface';
import { Address } from '../../interface/address';
import { BankDetails } from '../../interface/bank-details.interface';
import { CheckoutConfig } from '../../interface/checkout-config.interface';
import { DiscountPercentageResponse } from '../../interface/discount-percentage.response.interface';
import { PersonalCheck } from '../../interface/eCheck/payment-echeckrequest.interface';
import { TokenResponse } from '../../interface/eCheck/token-response.interface';
import { ValidateEcheckRequest } from '../../interface/eCheck/validate-echeck-request.interface';
import { ValidateEcheckResponse } from '../../interface/eCheck/validate-echeck-response.interface';
import { MemebrCCOverrideResponse } from '../../interface/member-ccoverride-response.interface';
import { MemberOrderCCInfo } from '../../interface/member-order-cc-info';
import { OrderRulesRequest } from '../../interface/order-rules-request.interface';
import { OrderRulesResponse } from '../../interface/order-rules-response.interface';
import { PayvisionSavedCardResponse } from '../../interface/payvision/payvision-saved-card-response.interface';
import { PayvisionSavedCard } from '../../interface/payvision/payvision-saved-card.interface';
import { Product, ProductAssociation } from '../../interface/product-info';
import { ProductModel, ProductRestrictionModel } from '../../interface/product-restriction.interface';
import { RestrictedProduct } from '../../interface/restricted-product.interface';
import { ShippingMethod } from '../../interface/ship-method';
import { ShippingOptionsRequest } from '../../interface/shipping-options-request';
import { ShippingOptionsResponse } from '../../interface/shipping-options-response';
import { ShippingProductModel } from '../../interface/shipping-product.interface';
import { TaxRequest } from '../../interface/tax-request';
import { TaxType } from '../../interface/tax-type.interface';
import { OrderPayment, UnTouchedOrderRequest } from '../../interface/untouched-order-request';
import { Cart } from '../../models/cart.model';
import { DeleteModal } from '../../models/delete-modal';
import { Item } from '../../models/item.model';
import { PaymentComponentSettings } from '../../models/payments/payment.model';
import { AchService } from '../../services/ach.service';
import { AppConfigService } from '../../services/app-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { CustomerService } from '../../services/customer.service';
import { EcheckService } from '../../services/echeck.service';
import { OrderMapperService } from '../../services/order-mapper.service';
import { OrderService } from '../../services/order.service';
import { PayvisionService } from '../../services/payvision.service';
import { AddressService } from '../../services/address.service';
import { CustomValidator } from '../customvalidation.component';
import { Promotion } from '../../interface/promotion';
import { StockQuantity } from '../../interface/stock-quantity';
import { EnrollmentCommonService } from '../../../shared/services/enrollment-common.service';
import { EnrollService } from '../../services/enrollment.service';
import { PaymentModeConstants } from '../../constants/payment-mode.constants';
import { CustomerServiceConstants } from '../../../common/constants/customer-service.constants';
import { StoreMetaDataConstants } from '../../constants/store-metadata.constants';
import { PersonalInfoConfigService } from '../../services/personal-info-config.service';
import { ShippingAddressInfoConfig } from '../../interface/shipping-address-info-config.interface';
import { ShippingAddressInfoConfigService } from '../../services/shipping-config.service';
import { MemberMetaDataEnum } from '../../enums/member-meta-data.enum';
import { ConfigurationService } from '../../services/configuration.service';
import { BonusConstants } from '../../constants/bonus-status.constants';
import { PaymentProcessorAlias } from '../../enums/payment-processor-alias.enum';
import { CollectionPoint, GeoPoint } from '../../interface/pudo-location.interface';
import { BusinessHour, SplitHour } from '../../interface/business-hour.interface';
import { PudoLocationRequest } from '../../interface/pudo-location-request.interface';
import { BankWireTransferConstants } from '../../constants/bank-wire-transfer-configuration.constants';
import { OrderLineItemTypeEnum } from '../../../shared/enums/order-lineitem-type.enum';
@Component({
    selector: 'order-edit',
    templateUrl: '../../templates/template1/views/orders/order-edit.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/order-promotion.less'
    ],
    providers: [TitleCasePipe]
})
export class OrderEditComponent implements OnInit {
    @Input() webOrderId: string;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    orderInformation: any;
    orderStatuses: Array<any> = [];
    storeInfo: any;
    showAddressFormValidations = false;
    memberInfo: any;
    memberTypeId: any;
    deliveryPreference: any = DeliveryPreference;
    orderFormGroup: FormGroup;
    items: any[] = [];
    countries: any[] = [];
    states: any[] = [];
    memberAddressDetails: any[] = [];
    memberShippingDetails: any[] = [];
    shippingAddressInfo: any;
    displayUserName: Boolean = false;
    address: any;
    shipMethodValidation: any = '';
    subTotal = 0.0;
    retailSubTotal = 0.0;
    total = 0.0;
    outOfStockItems: Product[];
    totalCommissionableVolume = 0;
    selectedIsoCountryCode: any = '';
    selectedCountryCodeTwo = '';
    currentCountryObj: any;
    shipMethods: ShippingOptionsResponse;
    shippingMethods: ShippingMethod[] = [];
    selectedPaymentMethod: any;
    isPaymentWithSavedCard = false;
    deleteModal: DeleteModal;
    products: any[] = [];
    orderSubmitted = false;
    statesByCountry: any[] = [];
    orderTaxResponse: any;
    taxableAmount = 0;
    moneyOrderAmount = 0;
    shippingCost = 0;
    importFeeEnabled = false;
    orginalShippingCost = 0;
    shipMethod: any = {};
    countryTaxInclusive: boolean;
    showSelectedShipMethod = false;
    languageCode = 'en-US';
    languageShortCode = 'en';
    disableDelivery = false;
    pollCount = 0;
    maxPollCount = 15;
    importFeeValue = 0;
    selectEnum = SelectEnum;
    userInfo: UserInfo;
    isUpdated = false;
    storeId: number;
    credit_Card_show: boolean;
    createdDate_show: boolean;
    gstTax: number;
    pstTax: number;
    storeDefaultLanguage: string;
    isOrderedTax = true;
    displayPriceConfig: DisplayPriceConfig;
    accountMemberInfo: any;
    ach_show:boolean;
    achRequest: PersonalAch;
    addNewAch:boolean;
    selectedAchInfo:PersonalAch;
    achToken:string;
    disableUpdateQuanitity = [];
    promotionIds = [];
    isNexioPayment: boolean;
    NexioPayment: boolean;
    storeMetadata:any;
    orderStatusShippedORPickUP:any;
    paymentStatusEnum = PaymentStatusId;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    displayDropAddress: boolean;
    showDropShipPersonAddressForm: boolean = false;
    displayPudoAddress: boolean;
    skipAddressVerification: boolean;
    formPickupPersonAddressValid: boolean;
    selectedPudoCollectionPoint: CollectionPoint = null;
    dropLoactionSelected = false;
    cityList: any = [];

    @ViewChild('payvisionPayment') payvisionPayment: Modal;
    @ViewChild('showNexioPopup') showNexioPayment: Modal;
    @ViewChild('eCheckPaymentPopup') eCheckPaymentPopup: Modal;
    @ViewChild('showWorldPayXMLPopup') showWorldPayXMLPopup: Modal;
    @ViewChild('showAdyenPaymentPopup') showAdyenPaymentPopup: Modal;
    @ViewChild('showNIPopup') showNIPopup: Modal;
    @ViewChild('showRestrictedProducts') showRestrictedProducts: Modal;
    @ViewChild('orderMessage') orderMessage: Modal;

    @ViewChild('shipMethodId') shipMethodId: ElementRef;
    @ViewChild('creditCardPayment') creditCardPayment: ElementRef;
    @ViewChild('paymentFormBtn') paymentFormBtn: ElementRef;
    @ViewChild('eCheckPayment') eCheckPayment: ElementRef;
    @ViewChild('savedCardsDdl') savedCardsDdl: ElementRef;
    @ViewChild('savedEcheckDdl') savedEcheckDdl: ElementRef;
    @ViewChild('suggestedRadioBtn') suggestedRadioBtn: ElementRef;
    @ViewChild('routerNumberInput') routerNumberInput: ElementRef;
    @ViewChild('billAddressVerifyBtn') billAddressVerifyBtn: ElementRef;
    @ViewChild('shipAddressVerifyBtn') shipAddressVerifyBtn: ElementRef;
    @ViewChild('saveEcheckFormBtn') saveEcheckFormBtn: ElementRef;
    @ViewChild('itemLevelSearch') itemLevelSearchInput: ElementRef;
    @ViewChild('addItemInput') addItemInput: ElementRef;
    @ViewChild('achPaymentPopup') achPaymentPopup: Modal;
    @ViewChild('outOfStockModal') outOfStockModal: Modal;

    paymentMethodTypes = PaymentMethodTypes;
    billingAddressInfo: any;
    imageTypes: any = ImageType;
    paymentComponentSettings: PaymentComponentSettings = new PaymentComponentSettings();
    memberId: number;
    countryCode: string;
    addNewpayvisionCard: boolean;
    selectedpayvisionCardInfo: any;
    orderSession: any = {};
    isOrderSessionInfo: boolean;
    orderType: any = OrderType;
    isOrderFormLoad: boolean;
    payvisionCardId: string;
    verifiedShippingAddressId: number;
    verifiedBillingAddressId: number;
    addNeweCheck: boolean;
    selectedECheckInfo: PersonalCheck;
    echeckForm: FormGroup;
    accountTypes: Array<string>;
    echeckRequest: PersonalCheck;
    eCheckTokenRes: string;
    savedEChecks: string;
    IsoCountryCode = IsoCodeThree;
    echeckSubmitted: boolean;
    eCheckValidationMessages: Array<string>;
    isWorldpayPayment: boolean;
    isAdyenPayment:boolean;
    isNIPayment: boolean;
    showNIPayment: boolean;
    showWorldpayXml: boolean;
    showAdyenPayment:boolean;
    restrictedProducts: Array<string>;
    memberTypeEnums = MemberTypeEnum;
    shippingDeliveryOptionAvailable: boolean;
    pickupDeliveryOptionAvailable: boolean;
    showShippingData: boolean;
    shippingSchemaUrl: string;
    billingSchemaUrl: string;
    showSavedAddress: boolean;
    showAddressForm: boolean;
    savedAddressId: number;
    paymentMethodTypeConstants = PaymentMethodTypeConstants;
    money_Order_show: boolean;
    orange_Money_show: boolean;
    wire_Transfer_show: boolean;
    echeck_show: boolean;
    backDateOrderPermission = false;
    enableBackDateOrder = false;
    isReviewWindow = false;
    isOrderBackdated = false;
    thresholdCrossed: boolean;
    memberCCLimitExceeded: boolean;
    orderRules: OrderRulesResponse;
    memberOrderCCInfo: MemberOrderCCInfo;
    taxCalculationStatus: boolean;
    personalDiscountPercentage: number;
    productErrorMsg: string;
    isRestrictedProduct: boolean;
    isFocused: boolean;
    unTouchedOrderRequest: UnTouchedOrderRequest;
    savePaymentMethod: boolean;
    monthlyCCValue: number;
    isPaymentChanged = false;
    isNewPayment: boolean;
    isNewCard: Boolean = false;
    memberCCOverrideLimitExceeded: boolean;
    memberCCOverride: MemebrCCOverrideResponse;
    isRestrictionPopupOpened: boolean;
    hasReleaseMoPermission: boolean;
    hasReleaseWTPermission: boolean;
    memberDiscountPercentage: DiscountPercentageResponse;
    showShippingAddress = true;
    appConfig: AppCountryConfig;
    orderStatusId: any = OrderStatusEnums;
    stores: any[] = [];
    bank_transfer_show: boolean;
    cash_on_delivery_show: boolean;
    paymentTypeEnum = PaymentType;
    defaultCurrency = CommonConstant.Default_Currency;
    memberCart: Cart;
    shoppingBagClicked: boolean;
    existingItemCount = 0;
    shoppingCartCount = 0;
    memberCartInfo: Cart;
    memberCartSessionGuid: string;
    itemCount = 0;
    viewShoppingBagPermission: boolean;
    createShoppingBagPermission: boolean;
    shippingTax = 0;
    originalShippingTax: number;
    bankDetailsList = [];
    currentMemberTypeID: any;
    hasReleaseBFPermission: boolean;
    hasReleaseCODPermission:boolean;
    isEnableStatus ?: boolean;
    checkoutConfig: CheckoutConfig;
    shippingAddressChanged: boolean;
    achPaymentInfo:any;
    paymentAchForm: FormGroup;
    savedAch:string;
    bankDetailsCountryList: BankDetails[];
    banContact_misterCash_and_maestro_show:boolean;
    misterCash_and_maestro_show:boolean;
    isEditOrder: boolean;
    isCloneOrder: boolean;
    taxType = TaxType;
    addressSearchResult: any[] = [];
    phoneNumberFormat : string;
    promotionModels = [];
    hasManageOrderUpdatePermission: boolean;
    storeLanguageCultureId: number;
    changeOrderStatus: any = CustomerServiceConstants.ORDER__SHIPPED_STATUS ;
    isOrderStatusUpdateEnableStatus ?: boolean;
    selectedCardId: number;
    totalOrderCost : any;
    validateEnteredAmount : boolean = true;
    isMoneyOrderAmountUpdate? : boolean = false;
    translateOptions = {
        translateText: "checkout.Forever Living Products {{countryName}} GmbH",
        translateParams: { countryName: '' }
    };
    itemTotal:number;
    itemShippingCost : number;
    setPickupAddress:Address;
    setShippingAddress: Address;
    setOrderType: number;
    deliveryPreferenceType:any = this.deliveryPreference.DELIVERY;
    productAssociationInfo: ProductAssociation[] = [];
    ServiceOrderPermissions: number[] = [
        Permission.REPLACEMENT_ORDER_CREATE,
        Permission.REPLACEMENT_ORDER_MANAGE,
        Permission.REPLACEMENT_ORDER_CANCEL
    ];
    orderLevelDiscount = 0;
    isBWPEnabledProduct :boolean= false;
    isBWPEnabledMember: boolean =false;
    hasServiceOrderUpdatePermission: boolean;
    retailDeliveryFee: number;
    isWorldPayEnabledCountry: boolean;
    sessionGuid: any;
    deliveryOptionPurchaseFlow:string;
    dropshipDeliveryOptionAvailable: boolean;
    pudoAddressSubmitted: boolean;
    pudoAddress: any;
    pudoShippingAddressInfo:Address=null;
    pudoLocationSearchForm:FormGroup;
    zipPattern: any;
    pudoShippingMethod: ShippingMethod = null;
    pudoLocationsNotFound: boolean = false;
    pudoCollectionPoints: CollectionPoint[] = null;
    loadingPudoPickupLocations: boolean;
    dropShipAddress:any;
    hidePudoPickupLocationsButton: boolean = true;
    customBankTransferDetailsConfiguration = BankWireTransferConstants.BankTransferCountries;
    customWireTransferDetailsConfiguration = BankWireTransferConstants.WireTransferCountries;
    showCustomerBankTransferDetails = false;
    showCustomerWireTransferDetails = false;
    pay_by_link_show: boolean;
    emailForm: FormGroup;
    isPayByLinkValid = true;
    dropshipPudoShippingMethod: ShippingMethod = null;
    isPickUpOptionExist = false;
    isDropShipOptionExist = false;
    scandinavianCountry: boolean = false;
    showDistance: boolean = false;
    constructor(private messageService: MessageService, private _orderservice: OrderService, private _commonService: CommonService,
        private _translatePipe: TranslateService, private _orderService: OrderService, private _echeckService: EcheckService,
        private _sanitizer: DomSanitizer,
        private _formbuilder: FormBuilder,
        private _http: Http,
        private router: Router,
        private _currencyPipe: CurrencyTransformPipe,
        private _cacheService: CacheService,
        private _customerService: CustomerService,
        private _payvisionService: PayvisionService,
        private _orderMapperService: OrderMapperService,
        private _titleCase: TitleCasePipe,
        private _appConfigService: AppConfigService,
        private _maskPipe: MaskPipe,
        private _translateService: TranslateService,
        private _memberDisplayPriceConfigService: MemberDisplayPriceConfigService,
        private _checkoutConfigService: CheckoutConfigService,
        private _configurationService: ConfigurationService,
        private _achService: AchService,
        private _enrollmentCommonService: EnrollmentCommonService,
        private _enrollService: EnrollService,
        private _shippingAddressInfoConfigService:ShippingAddressInfoConfigService,
        private _addressService: AddressService

        ) { }
    ngOnInit() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.orderSession = this._cacheService.get('UpdateOrderInfo');
        this._cacheService.remove('UpdateOrderInfo');
        this.isOrderSessionInfo = this.orderSession ? true : false;
        this.getZipCodePatterns();
        this.isOrderedTax = !this.isOrderSessionInfo;
        this.getOrderStatuses();
        this.showDistance =  environment.restrictGoogleMapNavigation;
        this.backDateOrderPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.ORDER_BACKDATE + ']'), AccessLevel.Customer_Service);
        this.hasReleaseMoPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_MO + ']'), AccessLevel.Customer_Service);
        this.hasReleaseWTPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_WIRE_TRANSFER + ']'), AccessLevel.Customer_Service);
        this.hasReleaseBFPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_BF + ']'), AccessLevel.Customer_Service);
        this.hasReleaseCODPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.RELEASE_COD + ']'), AccessLevel.Customer_Service);
        this.viewShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.VIEW_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.createShoppingBagPermission = this._commonService.checkPermissionByAccessLevel(
            JSON.parse('[' + Permission.CREATE_SHOPPING_BAG + ']'), AccessLevel.Customer_Service);
        this.deleteModal = new DeleteModal(this.clearData.bind(this),
            this.closeDeleteMessage.bind(this), this.closeDeleteMessage.bind(this));
        this.deleteModal.viewActionButtons = true;
        this.getCountries();
        this.getStates();
        if (this.orderSession) {
            this.shoppingBagClicked = this.orderSession && this.orderSession.shoppingBagClicked ? true : false;
            this.memberCartSessionGuid = this.orderSession.memberCartSessionGuid;
            this.orderFormGroup.patchValue({
                originalShippingCost : this.orderSession.originalShippingCost,
            });
        }
        this.paymentComponentSettings.webOrderId = this.webOrderId;
        this.isOrderFormLoad = this.isOrderSessionInfo ? false : true;
        this.selectedPaymentMethod = PaymentMethodTypes.Credit_Card.toString();
        this.setElementsFocus();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.accountTypes = [AccountType.Checking, AccountType.Savings];
        this.subscribeSaveAddress();
        
    }
    /*
      get different order statuses
       */
    getOrderStatuses() {
        this._orderservice.getOrderStatuses().subscribe((response) => {
            if (response) {
                this.orderStatuses = response;
                this.getOrderDetails();
            }
        });
    }

    getOrderStatusUpdateOptions() {
        if(this.orderInformation && this.orderInformation.orderStatusId && this.orderInformation.orderShippings) {
            if( this.orderInformation.orderStatusId === OrderStatusEnums.Processing) {
                this.changeOrderStatus = this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.DELIVERY ?
                CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(status => (status.id === OrderStatusEnums.Shipped)) :  CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(status => (status.id === OrderStatusEnums.Ready_For_Pickup));
            }
             else if(this.orderInformation.orderStatusId === OrderStatusEnums.Shipped || this.orderInformation.orderStatusId === OrderStatusEnums.Ready_For_Pickup) {
                this.changeOrderStatus = CustomerServiceConstants.ORDER__SHIPPED_STATUS.filter(status => (status.id === OrderStatusEnums.Completed));
            }
        }
    }


    /**
     * get order information
     */
    getOrderDetails() {
        this._orderservice.getRecentOrderInformation(this.webOrderId.toUpperCase()).subscribe(response => {
            if (response) {
                this.orderInformation = response;    
                this.setOrderType = this.orderInformation.orderGroupId;
                this.getOrderStatusUpdateOptions();
                if (this.orderInformation && this.orderInformation.userName && (this.orderInformation.source === Constants.CUSTOMER_SERIVCE || this.orderInformation.source === Constants.POS_ORDER || this.orderInformation.source === Constants.SERVICE_ORDER)) {
                    this.displayUserName = true;
                }
                this.getOrderPaymentInfoUsingWebOrderId(this.webOrderId, this.orderInformation.id);
                const orderStatus = this.orderStatuses.find((status: any) => status.id === this.orderInformation.orderStatusId);

                this.isReviewWindow = orderStatus
                    && (orderStatus.id === OrderStatus.Review_Window || (orderStatus.id === OrderStatus.Pending && this.orderInformation.orderPayments.length > 0 &&
                    (this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Wire_Transfer || this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Money_order  || this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Orange_Money))) ? true : false;
                // if (orderStatus.id !== OrderStatus.Pending  &&
                //     (this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Money_order ||
                //     this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Bank_Transfer)) {
                //     const updatedOrderInfo = {
                //         webOrderId: this.orderInformation.webOrderId,
                //         countryCode: this.orderInformation.countryCode
                //     };
                //     this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
                //     this.router.navigate(['/customerservice/orders']);
                // }
                if (this.orderInformation && this.orderInformation.orderStatusId == this.orderStatusId.Failed) {
                    this.isOrderBackdated = false;
                } else {
                    this.isOrderBackdated = response.backDateOrder ? true : false;
                }
                if(this.orderInformation  &&   this.orderInformation.orderStatusId !== this.orderStatusId.Failed) {
                        this.isEditOrder = true;
                    } else if (this.orderInformation.orderStatusId === this.orderStatusId.Failed){
                        this.isCloneOrder = true;
                    }
                this.orderInformation.orderStatus = orderStatus ? orderStatus.description : '';
                const distributor = this.orderInformation.distrubutorId ? this.orderInformation.distrubutorId : this.orderInformation.email;
                this.getMemberInfo(distributor, this.orderInformation.countryCode);
                this.selectedCountry(this.orderInformation.countryCode);
                if (this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Bank_Transfer) {
                    this.isEnableStatus = this.hasReleaseBFPermission;
                } else if (this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Money_order) {
                    this.isEnableStatus = this.hasReleaseMoPermission;
                } else if (this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Orange_Money) {
                    this.isEnableStatus = this.hasReleaseMoPermission;
                } else if (this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Wire_Transfer) {
                    this.isEnableStatus = this.hasReleaseWTPermission;
                } else if (this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 &&this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Cash_On_Delivery) {
                    this.isEnableStatus = this.hasReleaseCODPermission;
                }
                this.buildForm();
                this.buildPayByLinkForm();
                this.orderFormGroup.controls['backDateOrder'].setValue(this.isOrderBackdated);
                this.deliveryPreferenceOnChange();
                if (this.orderInformation.orderGroupId === OrderType.POS) {
                    this.disableDelivery = true;
                } else {
                    this.disableDelivery = false;
                }
                this.unTouchedOrderRequest = this.mapOrderResponseToUntouchedOrder(response);
            }
        });
    }

    /**
     * @description
     *  set focus for country and memberInfo elements
     *  based on orderSessionInfo
     * @date 2020-05-19
     * @memberof OrderEditComponent
     */
    setElementsFocus(): void {
        const country = document.getElementById('country');
        const memberInfo = document.getElementById('memberInfo');
        if (this.isOrderSessionInfo) {
            country ? country.focus() : null;
        } else {
            memberInfo ? memberInfo.focus() : null;
        }
    }

    /**
     * @description map order request
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapOrderResponseToUntouchedOrder(response: any) {
        const unTouchedOrderRequest: UnTouchedOrderRequest = {
            shippingCost: response.shippingCost,
            addresses: this._orderMapperService.mapAddressDetails(response.addresses),
            orderLineItems: this._orderMapperService.mapOrderLineItems(response.orderLineItems),
            orderShippings: this._orderMapperService.mapOrderShippingDetails(response.orderShippings),
            orderPayments: this._orderMapperService.mapOrderPaymentDetails(response.orderPayments),
            orderStatusId : response.orderStatusId
        };
        return unTouchedOrderRequest;
    }

    /**
     * @description map the modified order payment details
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapModifiedOrderPaymentDetails(): OrderPayment[] {
        const orderPaymentsMapper: OrderPayment[] = [];
        const orderLineItem = {
            paymentMode: this.getSelectedPaymentType(),
            isPaymentChanged: this.isPaymentChanged
        };
        orderPaymentsMapper.push(orderLineItem);

        return orderPaymentsMapper;
    }

    /**
     * @description map modified order request
     * @date 2019-05-03
     * @param {*} response
     * @memberof OrderEditComponent
     */
    mapModifiedOrderResponse() {
        const modifiedOrderRequest: UnTouchedOrderRequest = {
            shippingCost: this.shippingCost,
            addresses: this._orderMapperService.mapAddressDetails(this.getAddresses()),
            orderLineItems: this._orderMapperService.mapOrderLineItems(this.products, true),
            orderShippings: this._orderMapperService.mapModifiedOrderShippingDetails(this.orderFormGroup),
            orderPayments: this.mapModifiedOrderPaymentDetails(),
            orderStatusId : this.orderFormGroup.controls['shippedOrderStatus'].value ||   (this.orderFormGroup.value.enableStatus ? OrderStatus.Accepted : OrderStatus.Pending)
        };
        return modifiedOrderRequest;
    }

    /**
     * Get State Info by Code or Id
     * @param stateId
     *
     */
    private getStateByStateId(stateId: number): any {
        let stateObj = null;
        if (stateId) {
            stateObj = this.states.find((x: any) => x.id === stateId);
        }
        return stateObj;
    }

    /**
     * Get Country Info by Code or Id
     * @param countryId
     *
     */
    private getCountryByCountryId(countryId: number): any {
        let countryObj = null;
        if (countryId) {
            countryObj = this.countries.find((x: any) => x.countryId === countryId);
        }
        return countryObj;
    }

    clearData(): void {
    }

    getFormControls() {
        const items: any = this.orderFormGroup.get('items');
        return items.controls;
    }

    closeDeleteMessage(): void {

    }

    //#region #Start Build Forms Section

    /**
     * build Form
     */
    buildForm() {
        this.orderFormGroup = this._formbuilder.group({
            orderType: [this.orderInformation.orderGroupId],
            memberInfo: [this.orderInformation.distrubutorId],
            items: this._formbuilder.array(this.items),
            countryId: [''],
            deliveryPreference: [this.orderInformation.orderShippings[0].deliveryPreferenceId],
            shippingAddressId: [''],
            shipMethodId: ['', [Validators.required]],
            originalShippingCost: [0, [Validators.required]],
            moneyOrderAmount: [0, [Validators.required]],
            shippingCost: [''],
            shippingCostPercentage: [''],
            itemSearch: [''],
            itemLevelSearch: [''],
            shippingCostSelector: [this.selectEnum.secondOption.toString()],
            paymentInstrumentId: ['', [Validators.required]],
            paymentSelector: [this.selectEnum.firstOption.toString()],
            enableStatus: [{value: false, disabled: !this.isEnableStatus}],
            backDateOrder: [{value: false, disabled: this.isOrderBackdated }],
            saveForFutureUse: [false],
            isShippingDiscountApplied: [false],
            originalShippingTax: [0, [Validators.required]],
            shippedOrderStatus: [],
        });
        setTimeout(() => {
            if (this.addItemInput && this.addItemInput.nativeElement) {
                this.addItemInput.nativeElement.focus();
            }
        }, 500);
        this.buildPudoLocationSearchForm();
    }
    onKeydown(event: any) {
        if (event.code === 'Space') {
            event.preventDefault();
        }
    }
    /**
     * create item number
     * @returns FormGroup
     */
    createItemNumberGroup(): FormGroup {
        return this._formbuilder.group({
            itemNumber: [''],
            quantity: [''],
            productId: [''],
            productItem: [{}],
            productNumber: [''],
            productName: [''],
            productImage: [[]],
            disableIncrement: [false],
            disableDelete:[],
            isDepositFeeProduct: [false],
            depositFeeEnabled:[false]
        });
    }
    /**
    * ShippingAddressForm Intialize
    */
    createNewShippingAddress(): FormGroup {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    }
    /**
    * BillingAddressForm Intialize
    */
    createNewBillingAddress(): FormGroup {
        return this._formbuilder.group({
            name: [''],
            addressLine1: [''],
            addressLine2: [''],
            addressLine3: [''],
            addressLine4: [''],
            city: [''],
            stateId: [''],
            countryId: [''],
            postalCode: [''],
            phone: ['']
        });
    }
    //#region #Start Countries/ Store and States Section
    /**
    * get Countries
    */
    getCountries() {
        this._customerService.getCountriesLookup().subscribe(response => {
            if (response) {
                this.countries = response;
                this.stores = this.countries.filter(country => country.titanPlatformEnabled && country.shopEnabled);
            }
        });
    }
    /**
     * Get States By Country
     */
    getStatesByCountry() {
        this.statesByCountry = [];
        const shippingForm: any = this.orderFormGroup.get('shippingAddressForm');
        this.states.forEach(state => {
            if (state.countryId === shippingForm.controls[0].controls['countryId'].value) {
                this.statesByCountry.push(state);
            }
        });
    }
    /**
     * get States
     */
    getStates() {
        this._customerService.getStates().subscribe(response => {
            if (response) {
                this.states = response;
            }
        });
    }

    /**
     * Get Country Info by Code or Id
     * @param countryId
     * @param countryCode
     */
    private getCountryDetailsByCountryIdOrCode(countryId: number, countryCode: string): any {
        let countryObj = {};
        if (countryId) {
            countryObj = this.countries.filter((x: any) => x.countryId === countryId)[0];
        }
        if (countryCode) {
            countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
        }
        return countryObj;
    }

    /**
     * Get State Info by Code or Id
     * @param stateId
     * @param stateCode
     */
    private getStateDetailsByStateIdOrCode(stateId: number, stateCode: string, countryCode?: string): any {
        let stateObj = {};
        if (stateId) {
            stateObj = this.states.filter((x: any) => x.id === stateId)[0];
        }
        if(stateCode && countryCode){
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode && x.countryCode === countryCode)[0];
        } else if (stateCode) {
            stateObj = this.states.filter((x: any) => x.stateCode === stateCode)[0];
        }
        return stateObj;
    }

    getCitiesByStates() {
        const countryId = this._cacheService.get(CacheKey.COUNTRY_ID);
        this._addressService.getCitiesList(countryId).subscribe((response: any) => {         
          if (response) {
            this.cityList = response;
            this._cacheService.set(CacheKey.Cities, response)
          }
        }
        );
      }

    /**
     * Checks Whether Order Can be BackDated or Not
     * @param timeZoneOffset
     */
    isBackDateOrderAvailable = (timeZoneOffset: number, operatingCountry: string) => {
        this.enableBackDateOrder = false;
        let processingMonth;
        let processingYear;
        var date = new Date();
        if (date.getMonth() === 0) {
            processingMonth = 12;
            processingYear = date.getFullYear() - 1;
        } else {
            processingMonth = date.getMonth();
            processingYear = date.getFullYear();
        }
        if (operatingCountry && processingMonth && processingYear) {
            this._customerService.getBonusRunStatusDetails(operatingCountry, processingMonth, processingYear).subscribe((response) => {
                if (response && response.success && response.bonusStatus && response.validations.length === 0) {
                    if ((response.bonusStatus.toLowerCase() === BonusConstants.Open.toLowerCase())
                        || (response.bonusStatus.toLowerCase() === BonusConstants.Restricted.toLowerCase())) {
                        this._orderService.isBackDateOrderAllowed(timeZoneOffset, this.countryCode).subscribe(response => {
                            if (response && response.success) {
                                this.enableBackDateOrder = true;
                            } else {
                                this.enableBackDateOrder = false;
                            }
                        }, (error) => {
                            this.enableBackDateOrder = false;
                        });
                    }
                }
            }, (error) => {
                this.enableBackDateOrder = false;
            });
        }
    }

    /**
     * event for OrderBackDate CheckBox change
     */
    backDateOrderChange(event) {
        this.orderFormGroup.controls['backDateOrder'].setValue(event.target.checked);
    }


    /**
     * On Country Select
     */
    selectedCountry(countryCode: string) {
        const countryObj = this.countries.filter((x: any) => x.isocodeThree === countryCode)[0];
        if (countryObj) {
            this.translateOptions.translateParams.countryName = countryObj.name;
            if (this.memberInfo) {
                this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
            }
            this.selectedIsoCountryCode = countryObj.isocodeThree;
            this.getZipCodePatterns();
            this.checkoutConfig = this._checkoutConfigService.getSettings(countryObj.isocodeThree, this.memberInfo);
            if(this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState){
                this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                this._cacheService.set(CacheKey.COUNTRY_ID,countryObj.countryId);
                this.getCitiesByStates();
            }else{
                this._cacheService.remove(CacheKey.COUNTRY_CODE);
                this._cacheService.remove(CacheKey.COUNTRY_ID);
            }
            this.skipAddressVerification = this.checkoutConfig.skipAddressVerification;
            if(this.checkoutConfig && this.checkoutConfig.displayCityBasedOnState){
                this._cacheService.set(CacheKey.COUNTRY_CODE, this.selectedIsoCountryCode);
                this._cacheService.set(CacheKey.COUNTRY_ID,countryObj.countryId);
                this.getCitiesByStates();
            }else{
                this._cacheService.remove(CacheKey.COUNTRY_CODE);
                this._cacheService.remove(CacheKey.COUNTRY_ID);
            }
            // this.isWorldPayEnabledCountry = this._configurationService.checkWorldPayEnabledCountry(countryObj.isocodeThree);
            // this.isWorldpayPayment = this.checkoutConfig.isWorldpayPayment;
            // this.isAdyenPayment = this.checkoutConfig.isAdyenPayment;
            // this.isNIPayment = this.checkoutConfig.isNIPayment;
            // this.NexioPayment = this.checkoutConfig.isNexioPayment;
            if (this.IsoCountryCode.CAN === this.selectedIsoCountryCode) {
                this.languageCode = 'en-CA';
            }
            this.countryCode = countryObj.isocodeThree;

           // this.selectedIsoCountryCode =countryObj.isoCodeThree;
            this.shippingSchemaUrl = countryObj.isocodeThree.toLowerCase() + '-schema-form.json?templateVersion='
                + environment.templateVersion;
            this.billingSchemaUrl = countryObj.isocodeThree.toLowerCase() + '-billing-schema-form.json?templateVersion='
                + environment.templateVersion;
            this.showShippingData = true;
            this.selectedCountryCodeTwo = countryObj.isocodeTwo;
            this.paymentComponentSettings.isoCountryCode = countryObj.isocodeThree;
            this.paymentComponentSettings.isoTwoletterCountryCode = countryObj.isocodeTwo;
            this.currentCountryObj = countryObj;
            this.isDropShipOptionExist = false;
            this.isPickUpOptionExist = false;

           // this.getZipCodePatterns();
            setTimeout(() => {
                this.address = this.address;
                this.showAddressForm = true;
            }, 5000);
        }
    }


    savedCardInfo(savedcardDetails: any) {
        this._cacheService.remove(CacheKey.IsRefreshed);
        sessionStorage.removeItem(CacheKey.OrderInfo);
        if (savedcardDetails) {
            this.paymentComponentSettings.savedCards.unshift(savedcardDetails);
            this.showNexioPayment.close();
            this.isNexioPayment = false;
            if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length) {
                const savedCard = this.paymentComponentSettings.savedCards[0];
                if (savedCard && savedCard.id === savedcardDetails.id) {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(savedCard.id);
                }  else {
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedCards[0].id);

                }
                this.selectedpayvisionCardInfo= savedcardDetails;
            }
        }
    }


    ngOnDestroy() {
        this._cacheService.remove(CacheKey.COUNTRY_CODE);
        this._cacheService.remove(CacheKey.COUNTRY_ID);
    }

    /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(countryCode: string) {
        if (countryCode) {
            this._orderService.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    this.storeInfo = response;
                    if (this.memberInfo) {
                    this.memberInfo = {... this.memberInfo, displayMiddleName :this.storeInfo.displayMiddleName};
                    }
                    if(this.storeInfo){
                        this.getStoreMetaData(this.storeInfo.id);
                    }
                    this.storeId = response.id;
                       this.getOrderRules();
                    if ( response.languages && response.languages.length > 0) {
                        this.storeDefaultLanguage = response.languages.find((languageCulture: any) => languageCulture.default).cultureName;
                    } else {
                        this.storeDefaultLanguage = this.languageCode;
                    }
                    if(this.customBankTransferDetailsConfiguration && this.customWireTransferDetailsConfiguration && this.selectedIsoCountryCode) {
                        let language = this._cacheService.get(CacheKey.Language);
                        this.showCustomerBankTransferDetails = this.customBankTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                        this.showCustomerWireTransferDetails = this.customWireTransferDetailsConfiguration.includes(this.selectedIsoCountryCode) && language.toLowerCase() == this.storeDefaultLanguage.toLowerCase();
                    }
                    // tslint:disable-next-line:max-line-length
                    const shipAddress = this.orderInformation ? this.orderInformation.addresses : null;
                    if (shipAddress && shipAddress.length > 0 && this.countries && this.countries.length > 0) {
                        if (shipAddress[0]) {
                            const countryCode = shipAddress[0].countryCode;
                            const country = this.countries.find(x => x.isocodeThree === countryCode);
                            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
                        }
                    }
                    this.appConfig = this._appConfigService.getSettings(this.countryCode, this.memberInfo);
                    if(this.appConfig.isWireTransferLabelWithoutGmbh){
                        this.translateOptions.translateText = "checkout.Forever Living Products {{countryName}}";
                    }
                    if (this.orderInformation.createdDate && (this.orderInformation.storePostedOffset || this.orderInformation.storePostedOffset === 0)) {
                        this.orderInformation.createdDate = moment.utc(this.orderInformation.createdDate)
                            .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if (this.orderInformation.orderPostedDate && (this.orderInformation.storePostedOffset || this.orderInformation.storePostedOffset === 0)) {
                        this.orderInformation.orderPostedDate = moment.utc(this.orderInformation.orderPostedDate)
                            .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if(this.orderInformation && this.orderInformation.addresses){
                        this.pudoShippingAddressInfo= this.orderInformation.addresses.find(z=>z.addressType == AddressType.PICKUP_PERSON);
                            if(this.pudoShippingAddressInfo && this.orderInformation && this.orderInformation.orderShippings && this.orderInformation.orderShippings.length ){
                               let  externalId=this.orderInformation.orderShippings[0].pudoExternalId;
                                this.pudoLocationSearchForm.controls['externalId'].setValue(externalId);
                                this.buildPudoLocationSearchForm(this.pudoShippingAddressInfo.postalCode,this.pudoShippingAddressInfo.city,
                                    this.pudoShippingAddressInfo.addressLine1,this.pudoShippingAddressInfo.countryCode,externalId);
                               this.getPudoLocations();
                            }


                    }
                    this.createdDate_show = true;
                    this.storeInfo.ccNumberDecimals = 3;
                    this.storeInfo.ccNumberFormat = 'CR';
                    this.storeInfo.ccSymbol = 'CC';
                    this.paymentComponentSettings.languageCode = this.languageCode;
                    this.paymentComponentSettings.storeId = this.storeInfo.id;
                    this.paymentComponentSettings.currencyCode = this.storeInfo.currencyCode;
                    this.paymentComponentSettings.numberDecimals = this.storeInfo.numberDecimals;
                    this.countryCode = countryCode;
                    this.memberId = this.memberInfo.memberId;
                    this.getProducts();
                    this.getSavedEchecks();
                  //  this.getZipCodePatterns();
                    this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(this.countryCode);
                    let memberType: string;
                    const memberTypeID = this.currentMemberTypeID ? this.currentMemberTypeID : +this.memberInfo.memberTypeId;
                    if (memberTypeID === MemberTypeEnum.GUEST) {
                        memberType = MemberType.GUEST;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    } else if (memberTypeID === MemberTypeEnum.DISTRIBUTOR) {
                        memberType = MemberType.Distributor;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (memberTypeID === MemberTypeEnum.FPC) {
                        memberType = MemberType.PREFERRED_CUSTOMER;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.PERSONAL;
                    } else if (memberTypeID === MemberTypeEnum.RETAIL) {
                        memberType = MemberType.RETAIL;
                        this.deliveryOptionPurchaseFlow = PurchaseFlows.RETAIL;
                    }
                    if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                        this.getShoppingCartCount(this.storeInfo);
                    }
                    const getDeliveryOptionsRequest: any = {
                        memberTypeId: this.orderInformation
                            && this.orderInformation.memberTypeId ? this.orderInformation.memberTypeId : this.memberInfo ? this.memberInfo.memberTypeId : null,
                        memberType: memberType.toUpperCase(),
                        source: Source.CSP,
                        countryCode: countryCode,
                        purchaseFlow:this.deliveryOptionPurchaseFlow,
                        storeId: this.storeId
                    };
                    this.isBackDateOrderAvailable(response.timeZoneOffset, response.operatingCountry);
                    this.shippingDeliveryOptionAvailable = false;
                    this.pickupDeliveryOptionAvailable = false;
                    this.dropshipDeliveryOptionAvailable = false;
                    this.getMemberDiscountPercentages();
                    this._orderService.getDeliveryOptions(countryCode, getDeliveryOptionsRequest).subscribe(res => {
                        if (res) {
                            res.forEach(option => {
                                if (option.optionValue === DelivaryOptionType.Delivery) {
                                    this.shippingDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Pickup) {
                                    this.pickupDeliveryOptionAvailable = true;
                                }
                                if (option.optionValue === DelivaryOptionType.Dropship) {
                                    this.dropshipDeliveryOptionAvailable = true;
                                }
                            });
                            const isDropShip = res.find((x)=> x.optionValue == DelivaryOptionType.Dropship);
                            const isPickUp = res.find((x)=> x.optionValue == DelivaryOptionType.Pickup);
                            if (environment.scandinavianCountries && this.countryCode) {
                                let scandinavianCountries = environment.scandinavianCountries;
                                this.scandinavianCountry = scandinavianCountries.split(",").find(country => country === this.countryCode);
                            }
                            // For Scandian country checking for Pickup
                            if (this.scandinavianCountry && isPickUp) {
                                this.isPickUpOptionExist = true;
                            }
                            // For Non-Scandian country checking for DropShip
                            if (!this.scandinavianCountry && isDropShip && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && !this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                this.isDropShipOptionExist = true;
                            }
                            // For Non-Scandian country checking for PickUp
                            if (!this.scandinavianCountry && isPickUp && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
                                this.isPickUpOptionExist = true;
                            }
                            if (!this.scandinavianCountry && isPickUp && !this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
                                this.isPickUpOptionExist = true;
                            }
                        }
                    });
                 this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
                 this.getStorePromotions(memberTypeID);
                }
                this.getPaymentMethodsByStore();
                if(this.orderSession && this.orderSession.deliveryPreference === this.deliveryPreference.DROPSHIP
                    && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                        this.getPudoLocations();
                }
            },
                error => {
                    const notification: any = this._translatePipe.get('order. Unable to fetch Store Details');
                    this._commonService.createNotification('', notification.value, 'error');
                });
        }

    }

     /**
     * @description
     * @date 2019-10-21
     * @private
     * @memberof OrderPromotionComponent
     */
    private getMemberDiscountPercentages(): void {
        let wholesaleQualified: boolean = this.orderInformation ? this.orderInformation.wholesaleQualified : null;
        if (wholesaleQualified == null) {
            wholesaleQualified = false;
        }
        if (this.orderInformation) {
            this.memberInfo.transactionalWholesaleQualified = this.orderInformation.wholesaleQualified ? this.orderInformation.wholesaleQualified : false;
            this.memberInfo.transactionalOptin = this.orderInformation.optIn ? this.orderInformation.optIn : false;
        }
        this.loadMemberShoppingCart(this.storeInfo);
        const optin: boolean = this.orderInformation ? this.orderInformation.optIn : false;
        const memberTitleID = this.orderInformation && this.orderInformation.memberLevelId
        ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId;
        this._commonService.getDiscountPercentages(wholesaleQualified, optin, memberTitleID, this.storeId).
            subscribe(response => {
                this.memberDiscountPercentage = response;
            });
    }

    //getPaymentMethod by Store
    getPaymentMethodsByStore() {
        this._orderService.getPaymentMethodsByStore(this.storeId, this.countryCode, this.storeDefaultLanguage,
            this.memberInfo.memberTypeId, this.memberInfo.wholeSaleQualified).subscribe(response => {
            if (response) {
                const storePaymentInfo = response;
                this.initializePaymentMethods();
                if ((this.orderInformation.orderStatusId === OrderStatus.Pending && this.orderInformation.orderPayments && this.orderInformation.orderPayments.length > 0 &&
                    (this.orderInformation.orderPayments[0].paymentMode === this.paymentMethodTypes.Wire_Transfer))) {
                    this.wire_Transfer_show = true;
                    this.getBankDetailsByCountry(this.countryCode, PaymentModeConstants.Wire_Transfer);
                } else {
                    storePaymentInfo.forEach(
                        paymentMethod => {
                        paymentMethod.paymentMethodId;
                        if (paymentMethod.paymentMethodId === PaymentType.Credit_Card) {
                            this.credit_Card_show = true;
                            if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NEXIO){
                                this.NexioPayment = true;
                            }
                            else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.ADYEN){
                                this.isAdyenPayment = true;
                            }else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.NI){
                                this.isNIPayment = true;
                            }
                            else if(paymentMethod.paymentProcessor === PaymentProcessorAlias.WPAYXML){
                                this.isWorldpayPayment = true;
                            }
                        } else if (paymentMethod.paymentMethodId == PaymentType.Money_order) {
                            this.money_Order_show = true;
                             this.getBankDetailsByCountry(this.countryCode,PaymentModeConstants.Money_Order);
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Orange_Money) {
                            this.orange_Money_show = true;
                             
                        }
                        else if (paymentMethod.paymentMethodId == PaymentType.Wire_Transfer) {
                            this.wire_Transfer_show = true;
                             this.getBankDetailsByCountry(this.countryCode,PaymentModeConstants.Wire_Transfer);
                        }
                        //  else if (paymentMethod.paymentMethodId == PaymentType.eCheck) {
                        //     this.echeck_show = true;
                        // }
                        else if (paymentMethod.paymentMethodId == PaymentType.Cash_On_Delivery) {
                            this.cash_on_delivery_show = true;
                        } else if (paymentMethod.paymentMethodId == PaymentType.Bank_Transfer) {
                            this.bank_transfer_show = true;
                            this.getBankDetailsByCountry(this.countryCode);
                        }
                        else if (paymentMethod.paymentMethodId === PaymentType.eCheck) {
                            this.ach_show = true;
                        }else if(paymentMethod.paymentMethodId === PaymentType.BanContact_MisterCash_and_Maestro){
                            this.banContact_misterCash_and_maestro_show=true;
                        }else if(paymentMethod.paymentMethodId === PaymentType.MisterCash_and_Maestro){
                            this.misterCash_and_maestro_show=true;
                        }else if(paymentMethod.paymentMethodId === PaymentType.Pay_By_Link) {
                            this.pay_by_link_show = true;
                        }
                    });
                }
                    this.savePaymentMethod = this.orderSession && this.orderSession.savePaymentMethod ?
                    this.orderSession.savePaymentMethod : false;
            }

        });
    }
    initializePaymentMethods(){
        this.isWorldpayPayment = false;
        this.isAdyenPayment = false;
        this.isNIPayment = false;
        this.isNexioPayment = false;
    }
    private populateCountries(memberAllowedCountries: any) {
        if (memberAllowedCountries && memberAllowedCountries.length > 0 && this.countries && this.countries.length > 0) {
            memberAllowedCountries.forEach((allowedCountry: any) => {
                const countryObj = this.countries
                .filter((country: any) => country.titanPlatformEnabled && allowedCountry.isoCodeThree === country.isocodeThree)[0];
                if (countryObj) {
                    if (!(this.stores.findIndex((country: any) => country.isoCodeThree === countryObj.isocodeThree) >= 0)) {
                        this.stores.push({
                            id: countryObj.countryId, name: countryObj.name, isoCodeThree: countryObj.isocodeThree,
                            isoCodeTwo: countryObj.isocodeTwo, homeCountry: allowedCountry.homeCountry
                        });
                    }
                }
            });

        }
    }

    //#endregion

    // region #Start Member Function Section
    /**
   * Get Member Info by EmailID or FBOID
   */
    getMemberInfo(memberDetails: string, countryCode: string) {
        let type = '';
        type = memberDetails.indexOf('@') > -1 ? 'email' : 'fboId';
        this._orderService.getMemberInfo(memberDetails, type).subscribe(response => {
            if (response && response.memberId) {
              this.getMemberLevelInfo(response, countryCode);
            } else {
                const notification: any = this._translatePipe.get('order.Member Details Not Found');
                if (this.orderInformation.createdDate (this.orderInformation.storePostedOffset || this.orderInformation.storePostedOffset === 0)) {
                    this.orderInformation.createdDate = moment.utc(this.orderInformation.createdDate)
                        .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                }
                if (this.orderInformation.orderPostedDate (this.orderInformation.storePostedOffset || this.orderInformation.storePostedOffset === 0)) {
                    this.orderInformation.orderPostedDate = moment.utc(this.orderInformation.orderPostedDate)
                        .utcOffset(this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                }
                this.createdDate_show = true;
                this._commonService.createNotification('', notification.value, 'error');
            }
        }, error => {
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Details');
            this._commonService.createNotification('', notification.value, 'error');
        });
    }

    getMemberLevelInfo(memberResponse, countryCode: string): void {
      this.processMemberResponse(memberResponse, countryCode);
        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     if (response && response.memberLevel) {
        //         this.accountMemberInfo = Object.assign({}, memberResponse);
        //         memberResponse.memberTitle = response.memberLevel;
        //     }
        //     this.processMemberResponse(memberResponse, countryCode);
        // }, (error) => {
        //     this.processMemberResponse(memberResponse, countryCode);
        // });
    }

    processMemberResponse(response, countryCode: string): void {
        this.memberInfo = response;
        this.isBWPEnabledMember = this.memberInfo.memberMetaData.find(x => x.customKey === MemberMetaDataEnum.BWPENABLED && x.customValue === '1');
        if (response && response.memberTitle) {
            this.memberInfo.memberTitle = response.memberTitle;
        } else if (this.memberInfo && !this.memberInfo.memberTitle) {
            this.memberInfo.memberTitle =  this.accountMemberInfo.memberTitle;
        }
        if (+response.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        if(response.memberTypeId == MemberTypeEnum.DISTRIBUTOR){
            this.getMembergovernmentIdentificationsInfo(response.memberId);
        }
        if (this.memberInfo && this.memberInfo.memberTypeId && this.memberInfo.memberTypeId === this.memberTypeEnums.GUEST) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        // else if (+response.memberTypeId === MemberTypeEnum.FPC) {
        //     this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        // }
        if (this.memberInfo && this.memberInfo.memberAllowedCountries) {
            this.populateCountries(this.memberInfo.memberAllowedCountries);
        }
        this.memberTypeId = this.memberInfo.memberTypeId;
        this.selectedCountry(countryCode);
        if(this.isCloneOrder) {
            this.loadSavedCardsForMemberId(this.memberInfo.memberId, countryCode);
       }
        this.getStoreInfo(this.orderInformation.countryCode);
        if (this.memberInfo.address) {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }
        this.paymentComponentSettings.memberId = this.memberInfo.memberId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.paymentComponentSettings.distributorId = this.memberInfo? this.memberInfo.fboId : '';
        this.paymentComponentSettings.uniqueRefId = this.memberInfo.uniqueRefID? this.memberInfo.uniqueRefID : '';
        const country = this.countries.filter(x => x.countryId ===  this.memberInfo.address.countryId)[0];
        this.paymentComponentSettings.billingAddress.countryCodeTwo =  country ? country.isocodeTwo : '';
        this.paymentComponentSettings.memberTypeId = this.memberInfo.memberTypeId;
        this.paymentComponentSettings.memberEmail = this.memberInfo.email ? this.memberInfo.email : '';
        this.personalDiscountPercentage = this._commonService.getPersonalDiscount(this.orderInformation
             && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId);

        }

    /**
    *
    * @param memberId get Member Addresses
    */
    getMemberAddressByMemberId(memberId: any, countryId: any) {
        this.shippingAddressInfo = null;
        this.showAddressForm = false;
        this.billingAddressInfo = null;
        this._orderService.getMemberAddressByMemberId(memberId, countryId).subscribe(response => {
            this.memberAddressDetails = [];
            this.memberShippingDetails = [];
            if (response && response.length > 0) {
                this.memberAddressDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);
                this.memberAddressDetails = this._commonService.sortMemberAddress(this.memberAddressDetails);
                this.addressSearchResult = this.memberAddressDetails;
                if (!this.isOrderSessionInfo && (this.orderSession === null || !this.orderSession.shippingAddressId)) {
                    this.address = this.memberAddressDetails.find(x => x.defaultAddress === true);
                    if (!this.address && this.orderInformation.orderShippings.length > 0) {
                        const memberAddressDetails = [];
                        this.orderInformation.addresses.forEach((address: any) => {
                            const name = address.middleName ?
                                address.firstName + ' ' + address.middleName + ' ' + address.lastName :
                                address.firstName + ' ' + address.lastName;
                            memberAddressDetails.push({
                                id: address.id,
                                shippingAddress: {
                                    shipToName: name || address.name,
                                    addressLine1: address.addressLine1,
                                    addressLine2: address.addressLine2,
                                    addressLine3: address.addressLine3,
                                    addressLine4: address.addressLine4,
                                    addressType: address.addressType,
                                    city: address.city,
                                    stateId: address.stateId,
                                    countryId: address.countryId,
                                    postalCode: address.postalCode,
                                    addressVerified: address.addressVerified,
                                    shippingPhone: address.phone,
                                    email: address.email,
                                    firstName: address.firstName,
                                    lastName: address.lastName,
                                    middleName: address.middleName,
                                    type: address.type
                                }
                            });
                        });
                        if (memberAddressDetails.length > 0) {

                            const shippingAddressDetails = memberAddressDetails.find((address: any) =>
                                (address.shippingAddress.addressType === AddressType.SHIPPING));
                            if (shippingAddressDetails) {
                                const stateObj = this.getStateByStateId(shippingAddressDetails.shippingAddress.stateId);
                                if (stateObj) {
                                    shippingAddressDetails.shippingAddress.state = stateObj.stateId;
                                    shippingAddressDetails.shippingAddress.stateCode = stateObj.stateCode;
                                }
                                const countryObj = this.getCountryByCountryId(shippingAddressDetails.shippingAddress.countryId);
                                if (countryObj) {
                                    shippingAddressDetails.shippingAddress.country = countryObj.name;
                                    shippingAddressDetails.shippingAddress.countryCode = countryObj.isocodeThree;
                                    shippingAddressDetails.shippingAddress.countryId = countryObj.countryId;
                                }
                                shippingAddressDetails.shippingAddress.phoneNumber = shippingAddressDetails.shippingAddress.shippingPhone;
                                this.address = shippingAddressDetails.shippingAddress;
                                this.shippingAddressInfo = shippingAddressDetails.shippingAddress;
                            }
                        }
                    }
                    if (this.address) {
                        this.address.isSavedAddress = true;
                        this.address.phone = this.address.phoneNumber;
                        this.shippingAddressInfo = this.address;
                        this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        this.billingSchemaUrl = this.countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        this.showShippingData = true;
                    }
                }
                this.memberShippingDetails = response.filter(x => x.addressTypeId === AddressType.SHIPPING);

                if (this.isOrderSessionInfo) {
                    // check for shpping address when order info is in cache
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                      this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                      this.orderFormGroup.controls['shipMethodId'].setValue(this.orderSession.shipMethodId.toString());
                      this.validationsOnDeliveryPreference();
                  } else if (this.orderSession.shippingAddressId) {
                      this.address = this.orderInformation.addresses[0];
                       // this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderSession.shippingAddressId);
                        this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                        if (this.address) {
                            if(this.address.phoneNumber){
                            this.address.phone = this.address.phoneNumber;
                            }
                            this.address.isSavedAddress = true;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                        } else {
                            this.address = this.orderSession.shippingAddressInfo;
                            this.address.phone = this.address.shippingPhone;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                            this.address.isSavedAddress = this.orderSession.isSavedAddress;
                        }
                        this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                        this.billingSchemaUrl = this.countryCode.toLowerCase()
                            + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                        this.showShippingData = true;
                    } else if (this.memberShippingDetails && !this.orderSession.shippingAddressId && this.orderSession.deliveryPreference === DeliveryPreference.DELIVERY) {
                        this.orderFormGroup.controls['shippingAddressId'].setValue(AddressType.SHIPPING, { onlySelf: true });
                        this.address = this.orderSession.shippingAddressInfo;
                        this.address.phone = this.address.shippingPhone;
                        this.shippingAddressInfo = this.address;
                        this.savedAddressId = this.address.id;
                        this.address.isSavedAddress = this.orderSession.isSavedAddress;
                        this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                            + environment.templateVersion;
                            this.billingSchemaUrl = this.countryCode.toLowerCase()
                            + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                        this.showShippingData = true;
                    }

                } else if (!this.isOrderSessionInfo && this.orderInformation.orderShippings.length > 0
                    && this.orderInformation.orderShippings[0].shippingAddressId) {
                    this.orderFormGroup.controls['shippingAddressId']
                        .setValue(this.orderInformation.orderShippings[0].shippingAddressId);
                    if (this.orderInformation && this.orderInformation.addresses && this.orderInformation.addresses.length > 0) {
                        const orderShippingInfo = this.orderInformation.addresses[0];
                        // --address to change
                        this.address = this.orderInformation.addresses[0];
                      // this.address = this.memberShippingDetails.find((x: any) => x.id === this.orderInformation.orderShippings[0].shippingAddressId);
                        if (this.address) {
                            this.address.isSavedAddress = true;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                        } else {
                            this.shippingAddressInfo = orderShippingInfo;
                            this.savedAddressId = orderShippingInfo.id;
                            this.address = orderShippingInfo;
                            this.address.phoneNumber = orderShippingInfo.phone;
                        }
                        const name = orderShippingInfo.middleName ?
                            orderShippingInfo.firstName + ' ' + orderShippingInfo.middleName + ' ' + orderShippingInfo.lastName :
                            orderShippingInfo.firstName + ' ' + orderShippingInfo.lastName;
                        orderShippingInfo.shipToName = name || orderShippingInfo.name;
                        orderShippingInfo.id = this.orderInformation.orderShippings[0].shippingAddressId;

                    }
                    if (this.orderInformation.orderShippings[0].billingAddressId) {
                        const billingInfo = response
                            .find((address: any) => address.id === this.orderInformation.orderShippings[0].billingAddressId);
                        this.billingAddressInfo = billingInfo;
                    }
                } else if (!this.orderInformation.orderShippings[0].billingAddressId
                    && !this.orderInformation.orderShippings[0].shippingAddressId) {
                    if (this.orderFormGroup.controls['billingAddressId']) {
                        this.orderFormGroup.controls['billingAddressId'].setValue(this.memberAddressDetails[0].id);
                    }
                    this.billingAddressInfo = this.memberAddressDetails[0].shippingAddress;
                }
                this.appConfig = this._appConfigService.getSettings(this.countryCode, this.memberInfo); //storeConfiguration
                this.showAddressForm = true;
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY){
                    this.getShipMethods();
                }
            } else {
                this.appConfig = this._appConfigService.getSettings(this.countryCode, this.memberInfo);
                if (this.isOrderSessionInfo) {
                    // check for shpping address when order info is in cache
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(this.orderSession.saveForFutureUse);
                    if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                      this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                      if (this.orderSession.deliveryPreference === DeliveryPreference.DROPSHIP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                      }
                      this.constructSchemaFormUrl(this.countryCode);
                      this.validationsOnDeliveryPreference();
                  } else if (this.orderSession.shippingAddressId) {
                        this.address = this.orderSession.shippingAddressInfo;
                        this.orderFormGroup.controls['shippingAddressId'].setValue(this.orderSession.shippingAddressId, { onlySelf: true });
                        if (this.address) {
                            this.address.isSavedAddress = this.orderSession.isSavedAddress;
                            this.address.phone = this.address.shippingPhone;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                                + environment.templateVersion;
                            this.billingSchemaUrl = this.countryCode.toLowerCase()
                                + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                            this.showShippingData = true;
                        }

                    }
                    if (!this.orderSession.shippingAddressId && this.orderSession.shippingAddressInfo) {
                      if (this.orderSession.deliveryPreference === DeliveryPreference.PICKUP) {
                        this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
                        this.orderFormGroup.controls['shipMethodId'].setValue(this.orderSession.shipMethodId.toString());
                        this.validationsOnDeliveryPreference();
                      } else {
                        this.address = this.orderSession.shippingAddressInfo;
                        this.orderFormGroup.controls['shippingAddressId'].setValue( AddressType.SHIPPING, { onlySelf: true });
                        if (this.address) {
                            this.address.isSavedAddress = this.orderSession.isSavedAddress;
                            this.address.phone = this.address.shippingPhone;
                            this.shippingAddressInfo = this.address;
                            this.savedAddressId = this.address.id;
                            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
                                + environment.templateVersion;
                            this.billingSchemaUrl = this.countryCode.toLowerCase()
                                + '-billing-schema-form.json?templateVersion=' + environment.templateVersion;
                            this.showShippingData = true;
                        }
                     }
                  }
                } else if (!this.isOrderSessionInfo && this.orderInformation.orderShippings.length > 0) {
                    if (this.orderInformation.orderShippings[0].deliveryPreferenceId === DeliveryPreference.DELIVERY) {
                        if (this.orderInformation.orderShippings[0].shippingAddressId) {
                            this.orderFormGroup.controls['shippingAddressId']
                            .setValue(this.orderInformation.orderShippings[0].shippingAddressId);
                        }
                        if (this.orderInformation && this.orderInformation.addresses && this.orderInformation.addresses.length > 0) {
                            const orderShippingInfo = this.orderInformation.addresses[0];
                            const name = orderShippingInfo.middleName ?
                                orderShippingInfo.firstName + ' ' + orderShippingInfo.middleName + ' ' + orderShippingInfo.lastName :
                                orderShippingInfo.firstName + ' ' + orderShippingInfo.lastName;
                            orderShippingInfo.shipToName = name || orderShippingInfo.name;
                            if (this.orderInformation.orderShippings[0].shippingAddressId) {
                                orderShippingInfo.id = this.orderInformation.orderShippings[0].shippingAddressId;
                            }
                            if (this.appConfig && this.appConfig.skipAddressVerification) {
                                orderShippingInfo.addressVerified = true;
                            }
                            orderShippingInfo.shippingPhone = orderShippingInfo.phone;
                            this.shippingAddressInfo = orderShippingInfo;
                            this.savedAddressId = orderShippingInfo.id;
                            this.address = orderShippingInfo;
                        }
                    }
                }
                this.appConfig = this._appConfigService.getSettings(this.countryCode, this.memberInfo); //storeConfiguration
                this.showAddressForm =  true;
                this.shippingAddressSelectionChange();
            }
            this.setPayByLinkEmail()
        }, error => {
            this.showAddressForm = true;
            const notification: any = this._translatePipe.get('order.Unable to retrieve Member Addresses');
            this._commonService.createNotification('', notification.value, 'error');
        });

    }

    /**
     * @description constructing the schema form url
     * @date 2018-11-27
     * @memberof OrderPromotionComponent
     */
    constructSchemaFormUrl(countryCode: string): void {
        this.shippingSchemaUrl = countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        this.billingSchemaUrl = countryCode.toLowerCase() + '-billing-schema-form.json?templateVersion='
            + environment.templateVersion;
        setTimeout(() => {
            this.address = this.address;
            this.showAddressForm = true;
        }, 500);
    }

    // endregion
    /**
    * Delivery Preference On Change
    * @param value delivery preference
    */
    deliveryPreferenceOnChange() {
        this.deliveryPreferenceType = this.orderFormGroup.value.deliveryPreference;
        this.taxCalculationStatus = true;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.shippingAddressChanged = false;
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.enablePudoShippingSchemaUrl && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-pudo-schema-form.json?templateVersion='
            + environment.templateVersion;
        } else {
            this.shippingSchemaUrl = this.countryCode.toLowerCase() + '-schema-form.json?templateVersion='
            + environment.templateVersion;
        }
        if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
          //  this.showPudoPickupPersonAddressForm = true;
       } else {
            this.showDropShipPersonAddressForm = false;
            this.displayDropAddress = false;
        }
        this.constructSchemaFormUrl(this.countryCode);
        this.updateTotalsAndShipMethod();
        this.validationsOnDeliveryPreference();
    }
    /**
     * update validations on delivery preference
     */
    validationsOnDeliveryPreference() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.PICKUP) {
            this.shippingAddressInfo = {};
            this.orderFormGroup.controls['shipMethodId'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].setValue('');
            this.orderFormGroup.controls['shippingCostSelector'].disable();
            this.shippingCostChange(true);
        } else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY) {
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
        }
        else if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP) {
            this.orderFormGroup.controls['shippingCostSelector'].enable();
            this.shippingAddressSelectionChange();
            this.shipMethod = {};
        }
        else if(this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP){
          if(this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
          }
          if( this.orderSession && this.orderSession.buildPudoLocationSearchForm){
            this.pudoLocationSearchForm.controls['zipCode'].setValue(this.orderSession.buildPudoLocationSearchForm.zipCode);
            this.pudoLocationSearchForm.controls['city'].setValue(this.orderSession.buildPudoLocationSearchForm.city);
            this.pudoLocationSearchForm.controls['externalId'].setValue(this.orderSession.buildPudoLocationSearchForm.externalId);
            this.pudoLocationSearchForm.controls['zipCode'].updateValueAndValidity();
            this.pudoLocationSearchForm.controls['city'].updateValueAndValidity();
            this.pudoLocationSearchForm.controls['externalId'].updateValueAndValidity();
          if(this.shippingAddressInfoConfig.pudoLocationsEnabled){
           // this.showPudoPickupPersonAddressForm = true;
            this.displayPudoAddress = true;
          }else if(this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
            this.showDropShipPersonAddressForm = true;
            this.displayDropAddress = true;
          }
           this.shippingAddressSelectionChange();
           this.updateTotalsAndShipMethod();
          // this.getPudoLocations();
        }
    }
    }

    /**
     * On Shipping Address Selected
     */
    selectedShippingAddress(address: Address) {
        this.addressSearchResult = this.memberAddressDetails;
        const addressDetailId = address.id;
        address.isSavedAddress = true;
        if (addressDetailId && this.memberShippingDetails) {
            const shippingAddress = this.memberShippingDetails.filter((x: any) => x.id === addressDetailId);
            if (shippingAddress && shippingAddress[0]) {
                this.shippingAddressInfo = shippingAddress[0].shippingAddress;
            }
        }
        this.savedAddressId = address.id;
        address.phone = address.phoneNumber;
        address.email = address.email ? address.email : null;
        this.shippingAddressInfo = address;
        this.address = address;
        this.showSavedAddress = false;
        this.updateTotalsAndShipMethod();
    }
    /**
    *
    * @param enableValidation
    */
    updateShippingAddressFormValidations(enableNewAddressValidation: boolean, removeAllValidations?: boolean) {
        const shippingAddressForm: any = this.orderFormGroup.get('shippingAddressForm');
        if (shippingAddressForm && shippingAddressForm.length > 0) {
            if (enableNewAddressValidation) {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine1'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['name'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['city'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['stateId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['countryId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['postalCode'].setValidators([Validators.required]);
            } else {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([Validators.required]);
                shippingAddressForm.controls[0].controls['addressLine1'].setValidators([]);
                shippingAddressForm.controls[0].controls['name'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine2'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine3'].setValidators([]);
                shippingAddressForm.controls[0].controls['addressLine4'].setValidators([]);
                shippingAddressForm.controls[0].controls['city'].setValidators([]);
                shippingAddressForm.controls[0].controls['stateId'].setValidators([]);
                shippingAddressForm.controls[0].controls['countryId'].setValidators([]);
                shippingAddressForm.controls[0].controls['postalCode'].setValidators([]);
            }
            if (removeAllValidations) {
                this.orderFormGroup.controls['shippingAddressId'].setValidators([]);
            }
            shippingAddressForm.controls[0].controls['name'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine1'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine2'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine3'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine4'].setValue('');
            shippingAddressForm.controls[0].controls['city'].setValue('');
            shippingAddressForm.controls[0].controls['phone'].setValue('');
            shippingAddressForm.controls[0].controls['postalCode'].setValue('');
            shippingAddressForm.controls[0].controls['addressLine1'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['name'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['city'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['stateId'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['stateId'].setValue('');
            shippingAddressForm.controls[0].controls['countryId'].updateValueAndValidity();
            shippingAddressForm.controls[0].controls['countryId'].setValue('');
            shippingAddressForm.controls[0].controls['postalCode'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingAddressId'].setValue('');
            this.orderFormGroup.controls['shippingAddressId'].updateValueAndValidity();
            if (this.currentCountryObj) {
                shippingAddressForm.controls[0].controls['countryId'].setValue(this.currentCountryObj.countryId);
                this.getStatesByCountry();
            }
        }
    }
    prepareNewAddress(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(+address.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(+address.stateId, null);

            const addressObj = {
                name: address.name,
                phone: address.phone,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                city: address.city,
                state: stateObj.stateCode || '',
                stateId: address.stateId,
                postalCode: address.postalCode,
                country: countryObj.isocodeThree || '',
                countryCodeThree: countryObj.isocodeThree || '',
                countryId: address.countryId,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                type: address.type,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
            };
            return addressObj;
        }
    }

    addressChangedByUser(changed: boolean): void {
        this.shippingAddressChanged = changed;
    }

    /**
       * verified Address Mapping
       * @param  {any}  address
       * @returns any
       */
    private mapVerifiedAddressToFormFields(address: any): any {
        if (address) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, address.country);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, address.state, address.country);
            const mapAddressToFields = {
                name: address.name,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                postalCode: address.postalCode,
                city: address.city,
                stateId: stateObj.id,
                stateCode: stateObj.stateCode,
                countryCode: countryObj.countryCode || countryObj.isocodeThree,
                countryId: countryObj.countryId,
                phone: address.phone ? address.phone.replace(/[^a-zA-Z0-9]/g, ''): null,
                addressVerified: (this.appConfig && this.appConfig.skipAddressVerification) ? true : address.addressVerified,
                id: address.id,
                phoneType: address.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction:  address.deliveryInstruction,
                email: address.email ? address.email : null
            };
            return mapAddressToFields;
        }
    }

    /**
    * Add new Shipping Address
    * @param shippingAddressForm
    */
    useNewShippingAddress(addressInfo: any) {
        if (addressInfo) {
            const countryObj = this.getCountryDetailsByCountryIdOrCode(addressInfo.countryId, null);
            const stateObj = this.getStateDetailsByStateIdOrCode(addressInfo.stateId, null);
            const name = addressInfo.middleName ?
                addressInfo.firstName + ' ' + addressInfo.middleName + ' ' + addressInfo.lastName :
                addressInfo.firstName + ' ' + addressInfo.lastName;
            this.shippingAddressInfo = {
                shipToName: name || addressInfo.name,
                addressLine1: addressInfo.addressLine1,
                addressLine2: addressInfo.addressLine2,
                addressLine3: addressInfo.addressLine3,
                addressLine4: addressInfo.addressLine4,
                city: addressInfo.city,
                stateId: stateObj.id,
                stateName: stateObj.stateName || '',
                state: stateObj.stateCode || '',
                stateCode: stateObj.stateCode || '',
                countryId: countryObj.countryId,
                countryName: countryObj.name || '',
                country: countryObj.isocodeThree || '',
                countryCode: countryObj.isocodeThree || '',
                postalCode: addressInfo.postalCode || addressInfo.zip,
                zip: addressInfo.postalCode || addressInfo.zip,
                phone: addressInfo.phone,
                addressVerified: addressInfo.addressVerified,
                firstName: addressInfo.firstName,
                lastName: addressInfo.lastName,
                middleName: addressInfo.middleName,
                type: addressInfo.type,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction: addressInfo.deliveryInstruction,
                email: addressInfo.email ? addressInfo.email : null
            };
            this.isNewCard = false;
            this.updateTotalsAndShipMethod();
        } else {
            this.showAddressFormValidations = true;
        }
    }
    /**
     * save address method
     */
    private saveAddress(addressDetails: any) {
        const name = addressDetails.middleName ?
            addressDetails.firstName + ' ' + addressDetails.middleName + ' ' + addressDetails.lastName :
            addressDetails.firstName + ' ' + addressDetails.lastName;
        const saveAddressRequest: any = {
            id: null,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            addressLine1: addressDetails.addressLine1,
            addressLine2: addressDetails.addressLine2,
            addressLine3: addressDetails.addressLine3,
            addressLine4: addressDetails.addressLine4,
            shipToName: name || addressDetails.name,
            city: addressDetails.city,
            stateId: addressDetails.stateId,
            countryId: addressDetails.countryId,
            postalCode: addressDetails.postalCode || addressDetails.zip,
            contactTypeID: 1,
            defaultAddress: false,
            addressVerified: addressDetails.addressVerified,
            addressTypeId: 40,
            loggedInUserId: this.memberInfo.userId,
            responseCodes: addressDetails.responseCodes ? addressDetails.responseCodes : null,
            phone: addressDetails.phone,
            phoneNumber: addressDetails.phone,
            firstName: addressDetails.firstName,
            lastName: addressDetails.lastName,
            middleName: addressDetails.middleName,
            type: addressDetails.type,
            saveForFutureUse: this.orderFormGroup.value.saveForFutureUse
        };

        this._orderService.saveVerifiedAddress(saveAddressRequest).subscribe(response => {
            if (response && response.addressDetail) {
                this.verifiedShippingAddressId = response.addressDetail.id;
                this.address = addressDetails;
                this.address.phone = this.address.phoneNumber;
                this.address.id = response.addressDetail.id;
                this.orderFormGroup.controls['shippingAddressId'].setValue(response.addressDetail.id, { onlySelf: true });
                this.savedAddressId = response.addressDetail.id;
                if (saveAddressRequest.saveForFutureUse) {
                    this.messageService.setAddressSaved(true);
                    this.orderFormGroup.controls['saveForFutureUse'].setValue(false);
                }
            }
        }, error => {
            const notification: any = this._translatePipe.get('order. Unable to Save Member Address');
            this._commonService.createNotification('', notification.value, 'error');
        });
    }
    reEnterShippingAddress() {
        this.orderFormGroup.get('shippingAddressForm').reset();
        this.updateShippingAddressFormValidations(true);
    }
    // endregion

    // region #Start ShipMethods Section

    /**
       * on Shipping Method Change
       */
    selectShippingMethod(shippingMethod: ShippingMethod, isTaxCalculated?: boolean) {
        if (this.isOrderFormLoad && this.orderInformation.orderShippings.length > 0) {
            const shipmethodId = this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP
                ? this.orderInformation.orderShippings[0].shipMethodId.toString() : this.orderInformation.orderShippings[0].shipMethodId;
            this.orderFormGroup.controls['shipMethodId'].setValue(shipmethodId);
        }
        if (!this.isOrderSessionInfo && this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
            let option: string = this.selectEnum.firstOption.toString();
            if (this.isOrderFormLoad) {
                if (this.orderInformation && this.orderInformation.orderShippings && this.orderInformation.orderShippings.length > 0) {
                    if (this.orderInformation.orderShippings[0].shippingWaived) {
                       const waiverPercentage = this.orderInformation.orderShippings[0].shippingWaiverPercentage;
                       this.orderFormGroup.controls['shippingCostPercentage'].setValue(waiverPercentage) ;
                       option = waiverPercentage > 0 ? this.selectEnum.thirdOption.toString() : this.selectEnum.secondOption.toString();
                    }
                }
            }
            this.orderFormGroup.controls['shippingCostSelector'].setValue(option);
            this.shippingCostChange(false, true);
        }
        this.isRestrictedProduct = false;
        if (shippingMethod) {
            if (shippingMethod.pickUpLocation && this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP) {
                this.orderFormGroup.controls['shippingCostPercentage'].setValue(0);
                this.shippingCost = this.orginalShippingCost;
                this.orderFormGroup.controls['originalShippingCost'].setValue(this.orginalShippingCost);
                const productRestrictionModel: ProductRestrictionModel
                 = this.prepareProductRestrictionModelRequest(shippingMethod.pickUpLocation);
                 this.shipMethod = shippingMethod;
                this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
                    if (response && response.success && response.productModels) {
                        this.isRestrictedProduct = true;
                        this.getRestrictedProducts(response.productModels);
                    } else {
                        this.taxCalculationStatus = true;
                        this.showSelectedShipMethod = true;
                        this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                        if (this.isOrderSessionInfo) {
                            this.shippingCost = this.orderSession.shippingCostValue || 0;
                            this.shippingTax = this.orderSession.shippingTax || 0;
                        } else if (this.isOrderFormLoad) {
                            this.shippingCost = this.orderInformation.shippingCost || 0;
                            this.shippingTax = this.orderInformation.shippingTax || 0;
                            this.orderFormGroup.patchValue({
                                shippingCost: this.shippingCost.toFixed(2)
                            });
                        } else {
                            this.shippingCost = shippingMethod.shippingCharge || 0;
                            this.shippingTax = shippingMethod.shippingTax || 0;
                            this.orderFormGroup.patchValue({
                                shippingCost: this.shippingCost.toFixed(2)
                            });
                        }
                        this.orginalShippingCost = shippingMethod.shippingCharge;
                        this.orderFormGroup.patchValue({
                            originalShippingCost: shippingMethod.shippingCharge.toFixed(2)
                        });
                        if (!isTaxCalculated) {
                            this.calculateOrderTax();
                        }
                    }
                });
            } else {
                this.taxCalculationStatus = true;
                        this.shipMethod = shippingMethod;
                        this.showSelectedShipMethod = true;
                        this.importFeeValue = this._currencyPipe.getFormatedCurrency(shippingMethod.importFeeValue || 0, this.storeInfo);
                        if (this.isOrderSessionInfo) {
                            this.shippingCost = this.orderSession.shippingCostValue || 0;
                        } else if (this.isOrderFormLoad) {
                            /* Logic changes for CSP-817: CSP- Shipping tax is not calculating for the retail order placed
                                from Shop portal when we view the orders in the CSP */
                            this.shippingCost = this.orderInformation.shippingCost || 0;
                            this.shippingTax = this.orderInformation.shippingTax || 0;
                            this.orderFormGroup.patchValue({
                                shippingCost: this.shippingCost.toFixed(2),
                            });

                        } else {
                            this.shippingCost = shippingMethod.shippingCharge || 0;
                            this.shippingTax = shippingMethod.shippingTax || 0;
                            this.orderFormGroup.patchValue({
                                shippingCost: this.shippingCost.toFixed(2)
                            });
                        }
                        this.originalShippingTax = this.shippingTax || 0;
                        this.orginalShippingCost = this.memberInfo && this.memberInfo.vatRegistered ? this.shippingCost
                        : (this.appConfig.calculateShippingWithTax) ? this.shippingCost + this.originalShippingTax : this.shippingCost;
                        this.orderFormGroup.patchValue({
                            originalShippingCost: this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo),
                            originalShippingTax: shippingMethod.shippingTax
                        });
                        if (!isTaxCalculated) {
                            this.calculateOrderTax();
                        }
            }
        }
        // if (!isTaxCalculated && this.orderFormGroup.value.deliveryPreference ===  ShippingType.DELIVERY) {
        //     this.calculateOrderTax();
        // }
    }
        /**
         * @description To Show Shipping Restriction Error message
         * @date 2019-08-01
         * @private
         * @returns {string}
         * @memberof OrderEditComponent
         */
        private getShippingRestrictionError(): string {
            if (this.shippingAddressInfo
            && this.shippingAddressInfo.stateCode && this.shippingAddressInfo.countryId && this.states && this.states.length > 0) {
                const stateName: string = this.states.find(x => x.stateCode === this.shippingAddressInfo.stateCode).stateName;
                const error: any = this._translatePipe.get('order.' + Translations.SHIPPING_RESTRICTION_ERROR, { stateName: stateName });
                this.productErrorMsg = error.value;
            } else {
                const error: any = this._translatePipe.get('order.Following products are not allowed for selected shipping address.');
                this.productErrorMsg = error.value;
            }
            return this.productErrorMsg;
      }


    /**
     * @description this method used for preparing product restriction odel request for pickup
     */
    getProcuctRestrictions(pickupAddress: any): void {
        const productRestrictionModel: ProductRestrictionModel = this.prepareProductRestrictionModelRequest(pickupAddress);
        this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
            if (response && response.success && response.productModels) {
                this.getRestrictedProducts(response.productModels);
            }
        });
    }

    /**
     * @description this method used for preparing product restriction odel request for pickup
     */
    prepareProductRestrictionModelRequest(pickupAddress: any): ProductRestrictionModel {
        let productRestrictionModel: ProductRestrictionModel;
        productRestrictionModel = {
        countryCode: pickupAddress.countryCode,
        stateCode: pickupAddress.stateCode
        };
        const productModel: ProductModel[] = [];
        if (this.products && this.products && this.products.length > 0) {
            this.products.forEach(item => {
                productModel.push( { itemNumber: item.itemNumber});
            });
        }
        productRestrictionModel.productModels = productModel;
        return productRestrictionModel;

    }

    getShippingCost(isTaxCalculated?: boolean) {
        if (!isTaxCalculated) {
            this.calculateOrderTax();
        }
    }

    /**
     * Get Ship Methods By Products and Store
     */
    getShipMethods() {
        let items;
        this.taxCalculationStatus = true;
        this.shippingMethods = [];
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.showSelectedShipMethod = false;
        this.shipMethodValidation = null;
        this.restrictedProducts = [];
        this.orderFormGroup.controls['shipMethodId'].setValidators([Validators.required]);
        this.orderFormGroup.controls['shipMethodId'].updateValueAndValidity();
        this.orderFormGroup.controls['shipMethodId'].setValue('');
        if (this.orderFormGroup.value.deliveryPreference === ShippingType.DELIVERY) {
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValue('');
        }
        if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0
            && (this.shippingAddressInfo || (this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP || this.orderFormGroup.value.deliveryPreference===ShippingType.DROPSHIP))) {
            const shippingOptions: ShippingOptionsRequest = {
                productModels: this.getProductModels(),
                orderSourceId: OrderSourceType.Web,
                languageCode: this.languageCode,
                orderTypeId: ShippingOrderType.Personal,
                fromAddress: this.getWarehouseAddress(),
                // toAddress: this.orderFormGroup.value.deliveryPreference ===
                //     this.deliveryPreference.DELIVERY ? this.getShippingAddress() : {},
                toAddress: this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY ? this.getShippingAddress() :
                 (this.shippingAddressInfoConfig.dropShipLocationsEnabled  && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP)? this.getPudoDropShipPersonAddress( this.selectedPudoCollectionPoint) : {},
                storeId: this.storeInfo.id,
                requestID: 2, // for now we are using two once config is done we will drive from enum
                memberTypeId: (this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR || this.memberInfo.memberTypeId === MemberTypeEnum.FPC)
                    ? ShippingMemberType.DISTRIBUTOR : ShippingMemberType.RETAIL,
                priceTypeId: this.getPriceTypeId(),
                memberLevelId: (this.orderInformation && this.orderInformation.memberLevelId ===  MemberLevel.PREFERREDCUSTOMER) ? ShippingMemberTitle.NOVUS : ShippingMemberTitle.ASSISTANTMANAGER,
                orderSubTotal: this.subTotal,
                orderCaseCredits: this.totalCommissionableVolume,
                purchaseFlowId: this.getPurchaseFlowId(),
                shippingTypeId: this.orderFormGroup.value.deliveryPreference ===
                    this.deliveryPreference.DELIVERY ? ShippingType.DELIVERY :( this.orderFormGroup.value.deliveryPreference ===
                        this.deliveryPreference.DROPSHIP  && this.shippingAddressInfoConfig.dropShipLocationsEnabled ) ? ShippingType.DROPSHIP : ShippingType.PICKUP ,
                storeHomeCountryCode: this.selectedIsoCountryCode,
                vatInclusive: this.memberInfo && this.memberInfo.vatRegistered == true ? this.memberInfo.vatRegistered : false,
                initialOrder: false,
                vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
                bwpEnabled: this.isBWPEnabledMember && this.isBWPEnabledProduct && this.storeInfo && this.storeInfo.bwpEnabled ? true : false
            };

            //order source only for AUT && DEU Country
            if(this.shippingAddressInfoConfig.sendSourceToShippingOptions) {
                shippingOptions.source = this.orderInformation && this.orderInformation.source === Source.Customer_Service ? Source.CSP : this.orderInformation.source;
            }
            this._orderService.getShipmentService(shippingOptions).subscribe(response => {
                if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                    this.shipMethods = response;
                    this.shippingMethods = response.shippingMethods;
                    this.importFeeEnabled = response.importFeeEnabled;

                    if (this.shippingMethods.length > 0) {
                        this.shippingMethods.forEach(shipMethod => {
                            shipMethod.shippingCharge = shipMethod.shippingCharge - shipMethod.shippingTax;
                            shipMethod.shippingCharge = this._currencyPipe.getFormatedCurrency(shipMethod.shippingCharge, this.storeInfo);
                            shipMethod.importFeeEnabled = response.importFeeEnabled;
                        });
                        if (this.isOrderSessionInfo && !this.isOrderFormLoad) {

                            this.orderFormGroup.patchValue({
                                shippingCostSelector: this.orderSession.shippingCostSelector,
                                originalShippingCost: this.orderSession.originalShippingCost ? parseFloat(this.orderSession.originalShippingCost).toFixed(2) : 0,
                                shipMethodId: this.orderSession.shipMethodId,
                                shippingCost: this.orderSession.shippingCost ? parseFloat(this.orderSession.shippingCost).toFixed(2) : 0,
                                shippingCostPercentage: this.orderSession.shippingCostPercentage,
                                isShippingDiscountApplied: this.orderSession.isShippingDiscountApplied
                            });
                            const shipMethodId = this.orderFormGroup.value.shipMethodId;
                            if (shipMethodId && this.shippingMethods) {
                                const shippingObj =
                                    this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === +shipMethodId)[0];
                                if (shippingObj) {
                                    this.shippingCost = shippingObj.shippingCharge;
                                    this.selectShippingMethod(shippingObj, false);
                                    this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                }
                            }
                            this.getShippingCost();
                        } else if (this.isOrderFormLoad || (this.orderInformation && this.orderInformation.orderShippings.length > 0
                            && this.orderInformation.orderShippings[0].shipMethodId)) {
                            if (this.orderInformation.orderShippings.length > 0) {
                                const shipmethodId = this.orderFormGroup.value.deliveryPreference
                                    === ShippingType.PICKUP ? this.orderInformation.orderShippings[0].shipMethodId.toString()
                                    : this.orderInformation.orderShippings[0].shipMethodId;
                                this.orderFormGroup.controls['shipMethodId'].setValue(shipmethodId);
                            }
                            const shippingMethodId = (+this.orderFormGroup.value.shipMethodId);
                            if (shippingMethodId && this.shippingMethods) {
                                const shippingObj = this.shippingMethods.filter((shipMethod: any) =>
                                    shipMethod.shippingMethodId === shippingMethodId)[0];
                                if (shippingObj) {
                                    this.shippingCost = shippingObj.shippingCharge;
                                    this.selectShippingMethod(shippingObj, false);
                                    this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                } else {
                                    this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId);
                                    this.selectShippingMethod(this.shippingMethods[0], false);
                                    this.getShippingCost(true);
                                    //this.calculateOrderTax();
                                }
                            }
                        } else {
                            this.orderFormGroup.patchValue({
                                shippingCost: 0,
                                originalShippingCost: 0,
                                shippingCostPercentage: 0,
                                isShippingDiscountApplied: false,
                                originalShippingTax: 0
                            });
                            if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                                this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId.toString());
                            } else if(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP){
                                this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId.toString());
                            }
                             else {
                                this.orderFormGroup.controls['shipMethodId'].setValue(this.shippingMethods[0].shippingMethodId);
                            }
                            this.selectShippingMethod(this.shippingMethods[0]);
                        }
                        this.isOrderFormLoad = false;
                        this.orderSession = null;
                        this.isOrderSessionInfo = false;
                    }
                } else if (response && response.productModels && response.productModels.length > 0) {
                    this.getRestrictedProducts(response.productModels);
                } else if (response && response.validations.length > 0) {
                    this.shipMethodValidation = response.validations[0];
                }
                if(this.isDropShipOptionExist && !this.pudoShippingMethod){
                    this.getDropShipPudoShippingMethods(shippingOptions, response.shippingMethods, false);
                }
            }, error => {
                const notification: any = this._translatePipe.get('order.Unable to fetch Ship Methods');
                this._commonService.createNotification('', notification.value, 'error');
            });
        } else {
            this.orderFormGroup.patchValue({
                shippingCost: 0,
                originalShippingCost: 0,
                shippingCostPercentage: 0,
                isShippingDiscountApplied: false,
                originalShippingTax: 0
            });
        }

    }

    /** Products
    * @returns Products
    */
    private getProductModels(): ShippingProductModel[] {
        const productModels: ShippingProductModel[] = [];
        if (this.products && this.products.length > 0) {

            for (let index = 0; index < this.products.length; index++) {

                const product = this.products[index];
                if (product) {
                    const productModel: ShippingProductModel = {
                        productID: product.id,
                        productHeight: product.shipping ? product.shipping.height : 0,
                        productWeight: product.shipping ? product.shipping.weight : 0,
                        productQuantity: product.quantity,
                        productLength: product.shipping ? product.shipping.length : 0,
                        productWidth: product.shipping ? product.shipping.width : 0,
                        wholesalePrice: product.wholesalePrice,
                        sellingPrice: product.applicablePrice,
                        isOrderLiteratureOnly: product.literature,
                        retailPrice: product.retailPrice,
                        weightMetricId: ProductWeightMetric.KGS,
                        isShippable: product.shipping ? product.shipping.shippingRequired : 0,
                        itemNumber: product.itemNumber
                    };
                    productModels.push(productModel);
                }

            }

        }
        return productModels;
    }

    // endregion

    // region #Start Products Section
    /**
    * @param  {any} data
    * @returns SafeHtml
    */
    autocompleListFormatter = (data: any): SafeHtml => {
        const html = `<span>${data.itemNumber} - ${this._titleCase.transform(data.displayName ? data.displayName : data.name)}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     * Auto Complete Product Search
     */
    observableSource = (keyword: any, fullSearch?: boolean): Observable<any[]> => {
        if (this.memberInfo && this.storeInfo) {
            if (keyword && keyword.length > 2) {
                if (keyword.indexOf('#') == 0) {
                    keyword = keyword.replace(/#/, '');
                }
                let wholesaleQualified: boolean = this.orderInformation ? this.orderInformation.wholesaleQualified : null;
                if (wholesaleQualified == null) {
                    wholesaleQualified = false;
                }
                let fpc5PercentEnabled = false;
                if (this.appConfig) {
                    fpc5PercentEnabled = this.appConfig.fpc5PercentEnabled;
                }
                const optin: boolean = this.orderInformation ? this.orderInformation.optIn : false;
                const memberTitleId = this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId;
                const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5PercentEnabled, false, memberTitleId);
                let _itemNumberURL = environment.productsUrl + '/stores/' + this.storeInfo.id + '/categories/products' +
                    '?languageCode=' + this.storeDefaultLanguage + '&memberTitleId=' + memberTitleId + '&purchaseFlowType='
                    + purchaseFlowType + '&countryCode=' + this.selectedIsoCountryCode + '&pageSize=10&pageNumber=1&wholesaleQualified='
                    + wholesaleQualified + '&productWildSearch=' + keyword.trim() + '&excludeVariableProducts=true&isAutoShip=false&excludePromotionProducts=true&source=' + ProductSource.ADMINISTRATION
                    + '&optin=' + optin + '&taxInclusive=' + this.storeInfo.taxInclusive;
                if (fullSearch) {
                    _itemNumberURL += '&searchType=FULL';
                }
                return this._http.get(decodeURIComponent(encodeURIComponent(_itemNumberURL))).map(res => {
                    const results = res.json();
                    if (results && results.length > 0) {
                        return results;
                    } else {
                        return [];
                    }
                });
            } else {
                return Observable.of([]);
            }
        } else {
            let notification: any;
            if (!this.memberInfo) {
                notification = this._translatePipe.get('order. Member Details are Mandatory');
            }
            if (!this.storeInfo && !this.pickupDeliveryOptionAvailable && !this.shippingDeliveryOptionAvailable && !this.dropshipDeliveryOptionAvailable) {
                notification = this._translatePipe.get('Shipping options not available');
            } else if (!this.storeInfo && (this.pickupDeliveryOptionAvailable || this.shippingDeliveryOptionAvailable ||  !this.dropshipDeliveryOptionAvailable)) {
                notification = this._translatePipe.get('order.Country Details are Mandatory');
            }
            this._commonService.createNotification('', notification.value, 'error');
        }
    }

    /**
     * Add products on load
     */
    getProducts() {
        let productsIds = [];
        if (this.isOrderSessionInfo) {
            this.orderFormGroup.controls['deliveryPreference'].setValue(this.orderSession.deliveryPreference);
            this.validationsOnDeliveryPreference();
            productsIds = this.orderSession.products.map((product: any) => product.productId);
            if (productsIds.length > 0) {
                this.getProductsByIds(productsIds);
            } else {
                this.getMemberAddressByMemberId(this.memberInfo.memberId, this.currentCountryObj.countryId);
                this.deliveryPreferenceOnChange();
            }
        } else {
            let productLineItems = this.orderInformation && this.orderInformation.orderLineItems.filter(item =>
                item.lineItemTypeId != OrderLineItemTypeEnum.CHILD_PRODUCT);
            this.orderInformation.orderLineItems = productLineItems;
            productsIds = this.orderInformation && this.orderInformation.orderLineItems.map((product: any) => product.productId);
            this.getProductsByIds(productsIds);
        }

    }
    /**
     * get products by Ids
     */
    getProductsByIds(productsIds: Array<number>) {
        let wholesaleQualified: boolean = this.orderInformation ? this.orderInformation.wholesaleQualified : false;
        if (wholesaleQualified == null) {
            wholesaleQualified = false;
        }
        const memberTitleId = this.orderInformation && this.orderInformation.memberLevelId
        ? this.orderInformation.memberLevelId : this.memberInfo.memberTitleId;
        let fpc5percentEnabled = false;
        if(this.appConfig){
            fpc5percentEnabled = this.appConfig.fpc5PercentEnabled;
        }
        const isEnrollment = (this.orderInformation && this.orderInformation.orderTypeId === PurchaseFlow.Enrollment) ? true : false;
        let purchaseFlowType;
        if (isEnrollment) {
            purchaseFlowType = PurchaseFlows.ENROLLMENT;
        } else {
            purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5percentEnabled, isEnrollment, memberTitleId);
        }
        const optin: boolean = (this.orderInformation && this.orderInformation.optIn) ? this.orderInformation.optIn : false;
        this._orderService.getProductsByIds(productsIds, this.storeDefaultLanguage, this.storeInfo.id,
            memberTitleId, purchaseFlowType, this.selectedIsoCountryCode, wholesaleQualified, optin,
                this.storeInfo.taxInclusive, true).subscribe(response => {
                if (response && !response.status && response.length > 0) {
                    this.checkLoadedProducts(productsIds, response);
                    this.deliveryPreferenceOnChange();
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, this.currentCountryObj.countryId);
                } else if (response && response.status === 204 && productsIds && productsIds.length) {
                    this.checkLoadedProducts(productsIds);
                    this.deliveryPreferenceOnChange();
                    this.getMemberAddressByMemberId(this.memberInfo.memberId, this.currentCountryObj.countryId);
                }
            });
    }

    /**
     * @description get wholesale property
     * @date 2019-06-24
     * @returns {boolean}
     * @memberof OrderEditComponent
     */
    getWholeSaleQualified(): boolean {
        if (this.orderInformation && this.orderInformation.priceTierId !== PriceTier.RETAIL
             && this.orderInformation.priceTierId !== PriceTier.NEWDST) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Decrement the item Quantity
     * @returns void
     */
    decrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            if (items.controls[index].controls['quantity'].value > 1) {
                items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value - 1);
                items.controls[index].controls['quantity'].updateValueAndValidity();
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            this.orderFormGroup.markAsDirty();
            this.updateTotalsAndShipMethod();
        }
    }

    /**
    * Increment the item Quantity
    * @returns void
    */
    incrementQuantity(index: number): void {
        this.taxCalculationStatus = true;
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value + 1);
            const product = items.controls[index].controls['productItem'].value;
            if ((items.controls[index].controls['quantity'].value > product.stockQuantity && product.manageStock||! product.stockAvailable)
                && !(product.stockAvailable && !product.manageStock)) {
                const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                this._commonService.createNotification('', cartStockErrors.value, 'error');

                items.controls[index].controls['disableIncrement'].setValue(true);
            } else {
                items.controls[index].controls['disableIncrement'].setValue(false);
            }
            items.controls[index].controls['quantity'].updateValueAndValidity();
            this.orderFormGroup.markAsDirty();
            this.updateTotalsAndShipMethod();
        }
    }

    quantityChange(event: any, index: number) {
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            this.isFocused = false;
            items.controls[index].controls['quantity'].setValue(+items.controls[index].controls['quantity'].value);
            items.controls[index].controls['quantity'].updateValueAndValidity();
        }
    }

    /**
    * @param  {number} index
    * @returns void
    */
    updateQuantity(event: any, index: number): void {
        if (!this.isRestrictionPopupOpened) {
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
                if (items.controls[index].controls['quantity'].value > 1 ||
                    (event.target.value && parseInt(event.target.value, 10))) {
                    const product = items.controls[index].controls['productItem'].value;
                    if (product && event.target.value > product.stockQuantity && product.manageStock) {
                        items.controls[index].controls['quantity'].setValue(product.stockQuantity);
                        const cartStockErrors: any = this._translatePipe.get('stockError.No Stock Available');
                        this._commonService.createNotification('', cartStockErrors.value, 'error');
                        items.controls[index].controls['disableIncrement'].setValue(true);
                    } else {
                        items.controls[index].controls['quantity'].setValue(event.target.value);
                        items.controls[index].controls['disableIncrement'].setValue(false);
                    }
                    this.orderFormGroup.markAsDirty();
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                }
                if (!this.isFocused) {
                    this.updateTotalsAndShipMethod();
                }
                this.isFocused = false;
            }
        }
    }
    /**
     * @description open/close when restricted products shown
     * @date 2019-08-07
     * @param {boolean} isOpen
     * @memberof OrderEditComponent
     */
    restrictionPopupOpen(isOpen: boolean): void {
        this.isRestrictionPopupOpened = isOpen;
    }
    /**
     * @returns void
     */
    deleteItem(index: number): void {
        const items = this.orderFormGroup.get('items') as any;
        const productQuantity = +items.controls[index].controls['quantity'].value;
        if (items && items.length > 0) {
            if (this.productAssociationInfo) {
                const depositFeeEnabledCount = this._commonService.depositFeeEnabledProducts(items);
                let productId = items.value[index].productId;
                const parentProduct = this.productAssociationInfo.find(x => x.productId === productId);
                if (parentProduct) {
                    // remove the parent product
                    items.removeAt(index);
                    const depositFeeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === parentProduct.depositFeeProductId);
                    if (depositFeeEnabledCount > 1) {
                        if (depositFeeProductIndex > -1) {
                            let depositFeeProductQuantity = +items.value[depositFeeProductIndex].quantity;
                            depositFeeProductQuantity = depositFeeProductQuantity - productQuantity;
                            if (depositFeeProductQuantity > 0) {
                                items.value[depositFeeProductIndex].quantity = depositFeeProductQuantity
                                items.setValue(items.value);
                            } else {
                                items.removeAt(depositFeeProductIndex);
                            }
                        }
                    } else {
                        if (depositFeeProductIndex > -1) {
                            items.removeAt(depositFeeProductIndex);
                        }
                    }
                } else {
                    items.removeAt(index);
                }
            } else {
                items.removeAt(index);
            }
        }
        setTimeout(() => {
            if (this.addItemInput && this.addItemInput.nativeElement) {
                this.addItemInput.nativeElement.focus();
            }
        }, 500);
        this.updateTotalsAndShipMethod();
        //New logic to bind promtoion product from promotion engine
        const freeProductsInfo = this.validatePromotionCriteria(items);
        const productIds: number[] = this._commonService.updateCartAfterPromotion(freeProductsInfo, items, this.orderFormGroup, this.promotionIds);
        if (productIds && productIds.length) {
            this.addPromotionEngineProducts(productIds, freeProductsInfo);
        }
        this._commonService.removeNonPromotionProducts(freeProductsInfo, items);
        this.updateTotalsAndShipMethod();
    }

    /**
     * To Get Promotion Product details and bind it to order line items
     * @param productIds
     */
     addPromotionEngineProducts(productIds: number[], freeProductsInfo: any) {
        let items: any = this.orderFormGroup.get('items');
         let wholesaleQualified: boolean = this.orderInformation ? this.orderInformation.wholesaleQualified : false;
         if (wholesaleQualified == null) {
             wholesaleQualified = false;
         }
        // const notification: any = this._translatePipe.get('order.Invalid Item Number');
         let fpc5percentEnabled = false;
         if (this.appConfig) {
             fpc5percentEnabled = this.appConfig.fpc5PercentEnabled;
         }
         const isEnrollment = (this.orderInformation && this.orderInformation.orderTypeId === PurchaseFlow.Enrollment) ? true : false;
         let purchaseFlowType;
         const memberTitleId = this.memberInfo ? this.memberInfo.memberTitleId : null;
         if (isEnrollment) {
             purchaseFlowType = PurchaseFlows.ENROLLMENT;
         } else {
             purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, wholesaleQualified, fpc5percentEnabled, isEnrollment, memberTitleId);
         }
        if (items && items.length >= 0) {
            this._orderService.getProductsByIds(productIds, this.storeDefaultLanguage, this.storeInfo.id, this.memberInfo.memberTitleId,
                purchaseFlowType, this.selectedIsoCountryCode, false, false, this.storeInfo.taxInclusive).subscribe((products: Product[]) => {
                    if (products && products.length > 0) {
                        products.forEach((product) => {
                            const freeProductIndex = items.controls.findIndex(item => item.controls['productId'].value === product.id);
                            if (items && items.length >= 0 && freeProductIndex < 0) {
                                const currentFreeProduct = freeProductsInfo.find((freeProduct) => freeProduct.productId === product.id);
                                let stockQuantity: StockQuantity = this._commonService.stockQuantityCheck(product, currentFreeProduct);
                                if (stockQuantity.currentFreeProductQuantity> 0) {
                                    this.addItemNumber();
                                    const index = (items.length - 1);
                                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                    if (currentFreeProduct.promotionId && currentFreeProduct.promotionId.length > 0) {
                                        currentFreeProduct.promotionId.forEach((promotionId) => {
                                            if (this.promotionIds.indexOf(promotionId) == -1) {
                                                this.promotionIds.push(promotionId)
                                            }
                                        });
                                    }
                                    currentFreeProduct.quantity = stockQuantity.currentFreeProductQuantity;
                                    items = this._commonService.addPromoItem(items, index, product,
                                        environment.uiTemplateBaseUrl, environment.cdnURL);
                                    const productItem = items.controls[index].controls['productItem'].value;
                                    productItem.orderPromotionTrackings = stockQuantity.orderPromotionTrackings;
                                    if (!items.controls[index].controls['quantity'].value) {
                                        items.controls[index].controls['quantity'].setValue(currentFreeProduct.quantity);
                                    }
                                    items.controls[index].controls['quantity'].updateValueAndValidity();
                                    productItem.quantity = currentFreeProduct.quantity;
                                    items.controls[index].controls['productItem'].setValue(productItem);
                                }
                            }
                        });
                        this.updateTotalsAndShipMethod();
                    }
                });
        }
    }

    /**
     * Validate Promotions based on all criteria
     * @param product
     * @returns
     */
     validatePromotionCriteria(product: any) {
        const items = this.orderFormGroup.get('items');
        let freeProductsInfo = [];
        if (this.promotionModels && this.promotionModels.length > 0) {
            this._commonService.setSubTotalAndOrderCC(this.subTotal, this.totalCommissionableVolume, this.countryTaxInclusive);
            this._commonService.validateOrderCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderSubTotalCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateOrderCCCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateProductAtQuantityCriteria(this.promotionModels, freeProductsInfo, items);
            this._commonService.validateMultipleProductCriteria(this.promotionModels, freeProductsInfo, items);
        }
        return this._commonService.removeDuplicates(freeProductsInfo);
    }

    confirm(index: number) {
        if (index === 0 || index > 0) {
            this.deleteItem(index);
        }
    }

    addItemNumber(): void {
        this.items = this.orderFormGroup.get('items') as any;
        this.items.push(this.createItemNumberGroup());
    }

    // endregion

    // region #Start Common Methods Section
    /**
        * Clear All the Forms
        * @param clearCountry
        * @param clearShippingAddress
        */
    public clearForm() {
        this.items = [];
        this.getOrderDetails();
        this.isOrderFormLoad = true;
        this.verifiedBillingAddressId = 0;
        this.verifiedShippingAddressId = 0;
    }

    /**
     * disabling Submit button
     */
    disableSubmitButton(): void {
        this.taxCalculationStatus = true;
    }
    /**
     * update Totals and ShipMethod
     */
    updateTotalsAndShipMethod() {
        this.orderLevelDiscount = 0;
        this.taxCalculationStatus = true;
        this.subTotal = 0;
        this.retailSubTotal = 0.0;
        this.shippingCost = 0;
        this.importFeeValue = 0;
        this.taxableAmount = 0;
        this.retailDeliveryFee = 0;
        this.orderTaxResponse = null;
        this.products = [];
        this.totalCommissionableVolume = 0;
        this.shoppingCartCount = 0;
        this.itemCount = 0;
        if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.itemCount = this.shoppingCartCount;
        }
        const items: any = this.orderFormGroup.get('items');
        if (items && items.length > 0 && this.storeInfo && this.memberInfo) {
            for (let index = 0; index < items.length; index++) {
                const product = items.controls[index].controls['productItem'].value;
                const quantity = items.controls[index].controls['quantity'].value;
                if (product && quantity) {
                    const existProduct = this.products.filter(productObj => productObj.id === product.id)[0];
                    if (!existProduct) {
                        product.quantity = quantity;
                        this.products.push(product);
                    } else {
                        const productIndex = this.products.findIndex(item => item.id === existProduct.id);
                        this.products[productIndex].quantity = this.products[productIndex].quantity + quantity;
                    }
                    const shippingAddress = this.getShippingAddress();
                    if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
                        const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
                        this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
                    }
                    const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
                    const taxCalculated = this.appConfig.displayTaxInclusivePrice ? false : true;
                    this.displayPriceConfig = this._memberDisplayPriceConfigService
                        .getDisplayPriceConfig(PortalDisplayPage.PlaceOrder, this.storeInfo.taxInclusive,
                            this.memberInfo, taxCalculated, this.countryTaxInclusive, this.storeInfo.homeIsocodeThree, isEnableVATCalculation);
                    let price: number = this.countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    if (this.displayPriceConfig) {
                        price = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice : product.catalogPrice);
                    }
                    if (product.bwpEnableProduct && this.isBWPEnabledMember && this.storeInfo && this.storeInfo.bwpEnabled) {
                        const subTotalprice = price * +quantity;
                        this.orderLevelDiscount = this.orderLevelDiscount + ((subTotalprice * 5) / 100);
                    }
                    this.subTotal = this.subTotal + (price * +quantity);
                    this.retailSubTotal = this.retailSubTotal + (product.retailPrice * +quantity);
                    this.totalCommissionableVolume = this.totalCommissionableVolume + (product.commissionableVolume * +quantity);

                    this.total = this.taxableAmount + (+this.shippingCost) + this.subTotal + this.importFeeValue;
                    this.shoppingCartCount += +product.quantity;
                }
            }
            if (this.storeInfo && !this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this.itemCount = this.shoppingCartCount - this.itemCount;
            } else {
                this.itemCount = this.shoppingCartCount;
            }
             if (this.orderFormGroup.value.backDateOrder) {
                this.getMemberOrderRules(this.memberInfo, true);
            } else {
                this.getMemberOrderRules(this.memberInfo, false)
            }
            this.validateThreshold();           
            this.validateOrderLimit(true);
            this.getShipMethods();
        } else {
            !this.isOrderSessionInfo && !this.isOrderFormLoad ? this.getShipMethods() : '';
        }
    }

    // endregion

    /**
     * Selected Shipping Address
     */
    getShippingAddress(): any {
        let shippingAddressdata = null;
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.pudoLocationsEnabled) {
            this.shippingAddressInfo = this.pudoShippingAddressInfo;
        }else if(this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
            this.shippingAddressInfo = this.pudoShippingAddressInfo;
    } else {
            shippingAddressdata = this.shippingAddressInfo;
        }
        if (this.shippingAddressInfo) {
            const shippingAddress: any = {
                addressLine1: this.shippingAddressInfo.addressLine1,
                addressLine2: this.shippingAddressInfo.addressLine2,
                addressLine3: this.shippingAddressInfo.addressLine3,
                addressLine4: this.shippingAddressInfo.addressLine4,
                city: this.shippingAddressInfo.city || null,
                state: this.shippingAddressInfo.stateName,
                stateCode: this.shippingAddressInfo.stateCode,
                countryCode: this.shippingAddressInfo.countryCode,
                country: this.shippingAddressInfo.countryName,
                postalCode: this.shippingAddressInfo.postalCode ? this.shippingAddressInfo.postalCode.toUpperCase() : null,
                zip: this.shippingAddressInfo.postalCode ? this.shippingAddressInfo.postalCode.toUpperCase() : null,
                countryId: this.shippingAddressInfo.countryId,
                stateId: this.shippingAddressInfo.stateId,
                name: this.shippingAddressInfo.shipToName,
                addressType: this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP?AddressType.PICKUP_PERSON:AddressType.SHIPPING,
                phone: this.shippingAddressInfo.phone ? this.getValidPhoneNumber(this.shippingAddressInfo.phone) : null,
                countryCodeTwo: this.selectedCountryCodeTwo,
                addressVerified: this.shippingAddressInfo.addressVerified,
                firstName: this.shippingAddressInfo.firstName,
                middleName: this.shippingAddressInfo.middleName,
                lastName: this.shippingAddressInfo.lastName,
                phoneType: this.shippingAddressInfo.phoneType,
                saveForFutureUse: this.orderFormGroup.value.saveForFutureUse,
                deliveryInstruction:  this.shippingAddressInfo.deliveryInstruction,
                email: this.shippingAddressInfo.email ? this.shippingAddressInfo.email : null
            };
            this.setShippingAddress = shippingAddress;
            return shippingAddress;
        }
    }

    getValidPhoneNumber(phoneNumber: string){
        if(phoneNumber && this.storeInfo && this.storeInfo.foreverDirectEnabled){
            phoneNumber = phoneNumber.replace(/[a-zA-Z ]/g, '');
            if(phoneNumber.substring(0,1) !=='+' && phoneNumber.substring(0,2) !== '00'){
                phoneNumber = '+' + phoneNumber;
            }
        }
        else{
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        }
        return phoneNumber;
    }
    /**
* Selected Shipping Address
*/
    getBillingAddress(): any {
        let countryId = 0;
        if(!this.billingAddressInfo){
            this.billingAddressInfo = this.paymentComponentSettings.billingAddress || (this.shippingAddressInfo?this.shippingAddressInfo:null);
        }
        if (this.countries && this.billingAddressInfo && !this.billingAddressInfo.countryId) {
            const countryList = this.countries.find((x: any) => x.isocodeThree === this.billingAddressInfo.countryCode);
            if (countryList && countryList.length > 0) {
                countryId =
                    this.countries.find((x: any) => x.isocodeThree === this.billingAddressInfo.countryCode).countryId;
            }
        }
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress: any = {
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2,
            addressLine3: this.billingAddressInfo.addressLine3,
            addressLine4: this.billingAddressInfo.addressLine4,
            city: this.billingAddressInfo.city || null,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            countryCode: this.billingAddressInfo.countryCode,
            country: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            zip: this.billingAddressInfo.postalCode || this.billingAddressInfo.zip,
            countryId: this.billingAddressInfo.countryId || countryId,
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            addressType: AddressType.BILLING,
            countryCodeTwo: this.selectedCountryCodeTwo
        };
        return billingAddress;
    }
    getPickUpAddress(): any {
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
            this.shipMethod.pickUpLocation.addressType = AddressType.PICKUP;

            const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
            const stateObj = this.getStateDetailsByStateIdOrCode(null, this.shipMethod.pickUpLocation.stateCode);

            if (countryObj) {
                this.shipMethod.pickUpLocation.countryId = countryObj.countryId;
                this.shipMethod.pickUpLocation.country =  countryObj.isocodeThree ? countryObj.isocodeThree : '';
                this.shipMethod.pickUpLocation.countryCodeTwo = countryObj.isocodeTwo ? countryObj.isocodeTwo : '';
                this.shipMethod.pickUpLocation.countryCode = countryObj.isocodeThree ? countryObj.isocodeThree : '';
            }
            if (stateObj) {
                this.shipMethod.pickUpLocation.stateId = stateObj.id;
            }
            this.shipMethod.pickUpLocation.name = this.shipMethod.pickUpLocation.pickupCenterName;
            this.shipMethod.pickUpLocation.postalCode = this.shipMethod.pickUpLocation.zip;
            this.setPickupAddress = this.shipMethod.pickUpLocation;
            return this.shipMethod.pickUpLocation;
        } else {
            return this.getWarehouseAddress();
        }
    }
    /**
     * Store Ware house Address
     */
    getWarehouseAddress(): any {
        if (this.storeInfo && this.storeInfo.warehouseAddress) {
            const warehouseAddress: any = {
                addressLine1: this.storeInfo.warehouseAddress.addressLine1,
                addressLine2: this.storeInfo.warehouseAddress.addressLine2,
                addressLine3: this.storeInfo.warehouseAddress.addressLine3,
                addressLine4: this.storeInfo.warehouseAddress.addressLine4,
                city: this.storeInfo.warehouseAddress.city,
                state: this.storeInfo.warehouseAddress.stateCode,
                stateCode: this.storeInfo.warehouseAddress.stateCode,
                countryCode: this.storeInfo.warehouseAddress.countryCode,
                country: this.storeInfo.warehouseAddress.countryCode,
                postalCode: this.storeInfo.warehouseAddress.zipCode,
                zip: this.storeInfo.warehouseAddress.zipCode,
                countryId: this.storeInfo.warehouseAddress.countryId,
                stateId: this.storeInfo.warehouseAddress.stateOrProvinceId,
                name: null
            };
            return warehouseAddress;
        }
    }

    /**
     *
     * @param shippingMethod
     */
    getShippingMethodWarehouseAddress(): Address {
        if (this.shipMethod && this.shipMethod.warehouseAddress) {
            this.shipMethod.warehouseAddress.postalCode = this.shipMethod.warehouseAddress.zip;
            this.shipMethod.warehouseAddress.country = this.shipMethod.warehouseAddress.countryCode;
            return this.shipMethod.warehouseAddress;
        }
    }



    private getPurchaseFlowId(): PurchaseFlowType {
        if (this.memberTypeId === this.memberTypeEnums.GUEST || this.memberTypeId === this.memberTypeEnums.RETAIL) {
            return PurchaseFlowType.Retail;
        } else {
            return PurchaseFlowType.WholeSale;
        }
    }
    private getPriceTypeId(): PriceType {
        if (this.memberTypeId === this.memberTypeEnums.GUEST || this.memberTypeId === this.memberTypeEnums.RETAIL) {
            return PriceType.RETAILPRICE;
        } else {
            return PriceType.WHOLESALEPRICE;
        }
    }

    subscribeSaveAddress() {
        this.messageService.getAddressSaved().subscribe(data => {
            if (!this.address) {
                this.address = {};
            }
            this.address.isSavedAddress = data;
        });
    }


    //#endregion---------------------payment section End using world pay-----------------------------------
    updateOrder(url?: string) {
        if(this.isCloneOrder){
            this.calculateOrderTax();
        }
        const productRestrictionModel: ProductRestrictionModel = this.prepareProductRestrictionModelRequest(
            this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP ? this.getPickUpAddress() : this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP ? this.getPudoDropShipPersonAddress(this.selectedPudoCollectionPoint): this.getShippingAddress());
        if (productRestrictionModel) {
            this._commonService.getProductRestrictions(productRestrictionModel).subscribe((response) => {
                if (response && response.success && response.productModels) {
                    this.getRestrictedProducts(response.productModels);
                }
                else {
                    const items: any = this.orderFormGroup.get('items');
                    let productids: number[] = [];
                    items.value.forEach(element => {
                        productids.push(element.productId);
                    });
                    if (this.validateEnteredAmount) {
                        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            this.posStockAvailabilityCheck(productids, + this.orderFormGroup.controls['shipMethodId'].value, url);
                        } else {
                            this.proceedUpdateOrder(url);
                        }
                    }
                }
            });
        }
        else {
            const items: any = this.orderFormGroup.get('items');
            let productids: number[] = [];
            items.value.forEach(element => {
                productids.push(element.productId);
            });
            if (this.validateEnteredAmount) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                    this.posStockAvailabilityCheck(productids, + this.orderFormGroup.controls['shipMethodId'].value, url);
                } else {
                    this.proceedUpdateOrder(url);
                }
            }
        }
    }

    proceedUpdateOrder(url?: string){
        if (this.shippingAddressChanged) {
            this.showVerifyAddressMessage();
            return;
        }
        this.isUpdated = true;
        this.orderSubmitted = true;
        if (this.address && !this.address.isSavedAddress && this.orderFormGroup.value.saveForFutureUse) {
            this.saveAddress(this.getShippingAddress());
        }
        if (this.orderSubmitted) {
            this.constructPlaceOrderRequest(url);
        }

    }
    posStockAvailabilityCheck(productIds: number[], posLocationid?: number, url?:string): void {
        const noStockItems = [];
        if(posLocationid && posLocationid > 0 && productIds && productIds.length > 0){
            this._customerService.getProductsByLocation(posLocationid, productIds).subscribe(
                (response:any) => {
                    const posProducts = response;
                    if(posProducts && posProducts.length >0){
                        posProducts.forEach((pickUpProduct) => {
                            const cartProduct = this.orderFormGroup.value.items.find((product) => product.productId === pickUpProduct.productId);
                            if(cartProduct && pickUpProduct.manageStock && cartProduct.quantity > pickUpProduct.stockQuantity){
                                cartProduct.stockQuantity = pickUpProduct.stockQuantity;
                                noStockItems.push(cartProduct);
                            }
                        });
                    }
                    this.outOfStockItems = noStockItems;
                    if (this.outOfStockItems && this.outOfStockItems.length > 0) {
                        this.outOfStockModal.open();
                    } else {
                        this.proceedUpdateOrder(url);

                    }
                },
                (error:any) => {
                    const errorMessage: any = this._translateService.get('common.Sorry, Something Went Wrong: Please try again later.');
                    this._commonService.createNotification('', errorMessage.value, NotificationType.ERROR);
                }
            );
        }
    }
    closeOutOfStockForm(){
        this.outOfStockModal.close();
        this.orderSubmitted = false;
    }
    clearOutOfStockItems(){
        const items = this.orderFormGroup.get('items') as any;
        if (this.outOfStockItems && this.outOfStockItems.length) {
            const productIds = this.outOfStockItems.map((product: Product) => product.productId);
            this.removeOutOfStockItems(items, productIds);
            this.updateTotalsAndShipMethod();
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
            this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
            this.orderFormGroup.controls['enableStatus'].setValue(false);
            this.orderSubmitted = false;
            this.outOfStockModal.close();
        }

    }

    removeOutOfStockItems(items: FormArray, productIds: number[]) {
        productIds.forEach((id: number) => {
            const productIndex = items.value.findIndex((product) => product.productId === id);
            if (productIndex > -1) {
                items.removeAt(productIndex);
            }
        });
    }

    /**
     * @description construct place order request
     * @date 2019-05-06
     * @memberof OrderEditComponent
     */
    constructPlaceOrderRequest(url: string): void {
        let requestUrl = '';
        if (url) {
            requestUrl = url;
        } else {
            requestUrl = ApiUrlConstants.orderApiUrl + '/V1/orders/' + this.webOrderId.toUpperCase();
        }

        if (this.unTouchedOrderRequest) {
            const modifiedOrderRequest = this.mapModifiedOrderResponse();
            const isOrderChanged = isEqual(modifiedOrderRequest, this.unTouchedOrderRequest);
            if ((isOrderChanged && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId))
             && !this.orderFormGroup.value.backDateOrder && !this.orderFormGroup.controls['enableStatus'].value) {
                this.isUpdated = false;
                this.orderMessage.open();
            } else {
                this.placeOrder(requestUrl);
            }
        } else {
            this.placeOrder(requestUrl);
        }

        // For now commenting the changes need to do some changes as part of T10-8437

        // if (this.unTouchedOrderRequest && this.unTouchedOrderRequest.orderPayments
        //     && this.unTouchedOrderRequest.orderPayments.length > 0
        //     && this.unTouchedOrderRequest.orderPayments[0].paymentMode === PaymentMethodTypes.Money_order
        //     && this.orderFormGroup.controls['enableStatus'].value) {
        //    const modifiedOrderRequest = this.mapModifiedOrderResponse();
        //    const isOrderChanged = isEqual(modifiedOrderRequest, this.unTouchedOrderRequest);
        //     if (isOrderChanged) {
        //         const moneyOrderRequest: MoneyOrderRequest = {
        //             paymentStatusId: 5,
        //             orderId: this.orderInformation && this.orderInformation.orderPayments
        //              && this.orderInformation.orderPayments.length > 0 ? this.orderInformation.orderPayments[0].orderId : null,
        //             paymentType: PaymentMethodTypes.Money_order,
        //             notes: ''
        //         };
        //         this._orderService.processMoneyOrder(this.webOrderId, moneyOrderRequest).subscribe((response) => {
        //             if (response) {
        //                 let orderLog;
        //                 const paymentInfo = this.getOrderPaymentInfo();
        //                 if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Money_order
        //                     && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
        //                     orderLog = 'Money Order funds $' + this.orderFormGroup.controls['moneyOrderAmount'].value
        //                      + this.storeInfo.currencyCode + ' are received.';
        //                 }
        //                 const notification: any = this._translatePipe.get('order.Order Updated successfully');
        //                 this._commonService.createNotification('', notification.value, 'success');
        //                 this.orderSubmitted = false;
        //                 this.orderFormGroup.controls['backDateOrder'].setValue(false);
        //                 const updatedOrderInfo = {
        //                     webOrderId: this.webOrderId ? this.webOrderId.toUpperCase() : null,
        //                     countryCode: this.selectedIsoCountryCode
        //                 };
        //                 this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
        //                 this.router.navigate(['/customerservice/orders']);
        //                 this.createOrderLog(orderLog);
        //             } else {
        //                 const notification: any = this._translatePipe.get('order.Unable to Update Order');
        //                 this._commonService.createNotification('', notification.value, 'error');
        //             }

        //         }, (error: any) => {
        //             const notification: any = this._translatePipe.get('order.Unable to Update Order');
        //             this._commonService.createNotification('', notification.value, 'error');
        //             this.isUpdated = false;
        //         });
        //     } else {
        //         this.placeOrder(requestUrl);
        //     }
        // } else {
        //     this.placeOrder(requestUrl);
        // }

    }

    validateThreshold(): void {
        const totalPoints = this.calculateTotalPoints();
        const subTotal = this.calculateItemsSubTotal(this.storeInfo);
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            totalPoints <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE &&
            subTotal <= this.orderRules.maxValue) {
            this.thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            const details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            this.thresholdCrossed = details.thresholdCrossed;
            this.memberCCLimitExceeded = details.monthlyCCValid;
            this.monthlyCCValue = details.monthlyCCValue;
        } else {
            this.thresholdCrossed = true;
        }
        // Monthly CC override for member
        if (this.memberCCOverride && this.memberCCOverride.overrideFlag && this.memberOrderCCInfo) {
            const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
            const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                .format(DateConstants.DateFormat);
            if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                && (new Date(currentDate) <= new Date(endDate))) {
                this.thresholdCrossed = true;
            } else if ((this.orderRules.maxCCValue < this.memberCCOverride.cVLimit) &&
                ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                && (new Date(currentDate) <= new Date(endDate))) {
                this.thresholdCrossed = false;
            }
        }
    }

    /**
     * @description place order
     * @date 2019-05-04
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    placeOrder(requestUrl: string) {
        const memberTypeId = this.currentMemberTypeID ? this.currentMemberTypeID : this.memberTypeId;
        if (memberTypeId !== MemberTypeEnum.RETAIL && memberTypeId !== MemberTypeEnum.GUEST) {
            if (this.orderFormGroup.value.backDateOrder) {
                this.getMemberOrderRules(this.memberInfo, true, requestUrl);
            } else {
                this.getMemberOrderRules(this.memberInfo, false, requestUrl);
            }

        } else {
            this.validateThreshold();
            this.submitOrder(requestUrl);
        }

    }

        /** get Member Order rules
     * @description
     * @date 2019-05-20
     * @memberof OrderPromotionComponent
     */
    getMemberOrderRules(userInfo: Member, isBackOrderDate: boolean, requestUrl?: string): void {
        this.memberOrderCCInfo = null;
        this._orderService.getMemberOrderBusinessRules(userInfo.memberId, this.storeId, isBackOrderDate, this.selectedIsoCountryCode, this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : userInfo.memberTitleId, this.webOrderId.toUpperCase())
        .subscribe((response: any) => {
            if (response) {
                const memberOrderRules = response;
                this.memberOrderCCInfo = memberOrderRules.memberOrderCCInfo.filter((x: any) => x.frequency === 'MONTHLY')[0];
                const validateOrderRule = this.verifyOrderRules(isBackOrderDate);
                this.thresholdCrossed = validateOrderRule.thresholdCrossed;
                this.memberCCLimitExceeded = validateOrderRule.monthlyCCValid;
                this.monthlyCCValue = validateOrderRule.monthlyCCValue;
                this.memberCCOverrideLimitExceeded = validateOrderRule.memberCCOverride;
                if (requestUrl) {
                    this.submitOrder(requestUrl);
                }
            }
        }, error => {
        });
    }

    /**
 * Get member cc overrides
 * @param memberId
*/
  getMemberCCOverrides(memberId: number): void {
    this._customerService.getMemberCCOverride(this.storeId, memberId)
    .subscribe(response => {
        if (response && response.length) {
        this.memberCCOverride =  response[0];
    }
    }, (err: any) => {
    });
  }

    validateOrderLimit(quantityUpdate: boolean): void {
        if (!this.orderRules) {
            return;
        }
        const exceedMonthlyCCPopup: any = this._translatePipe
            .get('order.Your cart contains a case credit value that brings your total monthly case credits above the limit');
        const exceedMonthlyCCOverridePopup: any = this._translatePipe
            .get('order.Monthly CC limit reached');
        //   const exceedPerOrderCC: any = this._translatePipe.get('order.Retail Max Order limit reached');
        const orderRulesMaxValue = this.orderRules.maxValue ? this.orderRules.maxValue : this.orderRules.literatureMaxValue;
        let maxValue = this._currencyPipe.getFormatedCurrencyWithSepartors(this._commonService.validateNumberDecimalPoint(orderRulesMaxValue ? orderRulesMaxValue : orderRulesMaxValue) + '.00' || '0',this.storeInfo);
        const exceedPerOrderCC: any = this._translatePipe.get('order.The maximum limit for a Retail purchase is {{max}}. Please remove items from the shopping bag to continue.',
            { max: maxValue });
        if (this.thresholdCrossed && this.orderRules && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
            if (this.memberCCLimitExceeded) {
                const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                    + this.monthlyCCValue + '</b>';
                this._commonService.createNotification('', monthlyCCContent, 'error');
            }
            else if (!quantityUpdate) {
                const isLiteratureValidation = this.isLiteratureValidation(this.products);
                const invalidProductPopup: any = this._translateService.get('order.Your cart must be a minimum amount of {{min}} and  a maximum amount of {{max}}',
                    {
                        min: isLiteratureValidation ? this.orderRules.literatureMinValue : this.orderRules.minValue,
                        max: isLiteratureValidation ? this.orderRules.literatureMaxValue : this.orderRules.maxValue
                    });
                this._commonService.createNotification('', invalidProductPopup.value, NotificationType.ERROR);
            }
        }
        if ((this.memberCCLimitExceeded || this.thresholdCrossed) && !this.memberCCOverrideLimitExceeded
            && this.orderRules.valueType !== ValueType.BOTH) {
            const monthlyCCContent = exceedMonthlyCCPopup.value + ' <b class="helvetica-bold">'
                + this.monthlyCCValue + '</b>';
            if (this.memberTypeId !== MemberTypeEnum.RETAIL && this.memberTypeId !== MemberTypeEnum.GUEST) {
                this._commonService.createNotification('', monthlyCCContent, 'error');
            } else {
                this._commonService.createNotification('', exceedPerOrderCC.value, 'error');

            }
            this.isUpdated = false;
        }
        if (this.memberCCOverrideLimitExceeded) {
            const monthlyCCOverrideContent = exceedMonthlyCCOverridePopup.value + ' <b class="helvetica-bold">'
                + this.memberCCOverride.cVLimit + ' CC</b>';
            this._commonService.createNotification('', monthlyCCOverrideContent, NotificationType.ERROR, 0, Constants.MIN_LIMIT);
            this.isUpdated = false;
        }
    }

    /**
     * @description place order
     * @date 2019-05-22
     * @param {string} requestUrl
     * @memberof OrderPromotionComponent
     */
    submitOrder(requestUrl: string): void {
        const orderLogMessage = this.getOrderLogMessage();
        if(!this.isCloneOrder){
            const orderRequest: any = this.prepareOrderRequest();
            this.updateFinalOrder(orderRequest, requestUrl, orderLogMessage);
        }else{
        this.validateOrderLimit(false);
        if (((this.orderRules && !this.thresholdCrossed) || !this.orderRules) && (!this.memberCCOverrideLimitExceeded) &&
            ((this.memberOrderCCInfo && !this.memberCCLimitExceeded) || !this.memberOrderCCInfo)) {
            if (orderLogMessage == '' && this.orderFormGroup.value.backDateOrder && !this.isOrderBackdated
                && this.orderStatusId.Failed !== this.orderInformation.orderStatusId) {
                this._orderService.backDateOrder(this.webOrderId.toUpperCase()).subscribe((response: any) => {
                    if (response) {
                        if (response.json().success) {
                            this.orderSuccess(response.json());
                        } else {
                            this.orderPending(response);
                        }
                        this.isUpdated = false;
                    }
                }, (error: any) => {
                    const notification: any = this._translatePipe.get('order.Unable to Update Order');
                    this._commonService.createNotification('', notification.value, 'error');
                    this.isUpdated = false;
                });
            } else {
                const orderRequest: any = this.prepareOrderRequest();
                if (this.orderStatusId.Failed === this.orderInformation.orderStatusId) {
                   this.placeFinalOrder(orderRequest);
                } else {
                    this.updateFinalOrder(orderRequest, requestUrl, orderLogMessage);
                }
            }

        }
     }
    }
    /**
     * @description cloning the failed order as new Order
     * @date 2020-04-27
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    placeFinalOrder(orderRequest: any): void {

        if (orderRequest) {
           const url =   ApiUrlConstants.orderApiUrl + '/V1/orders';
            this._orderService.createNewOrder(orderRequest, url).subscribe((response: any) => {
                if (response) {
                    if (response.json().status === 'COMPLETED' && response.json().responseModel
                        && response.json().responseModel.success) {
                        const shippingLogInfo = this.getShippingLogInfo();
                        if (shippingLogInfo) {
                            this.createOrderLog(response.json().responseModel, true, shippingLogInfo);
                        }
                        // this.createOrderLog(response.json().responseModel, true);
                        this.orderSuccess(response.json().responseModel);
                        const sessionGuid = ((this.memberCart && this.memberCart.sessionGuid) || this.memberCartSessionGuid);
                        if (sessionGuid && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST && this.shoppingBagClicked) {
                            this.deleteCart(sessionGuid);
                        }
                    } else if (response.json().responseModel && !response.json().responseModel.success
                        && response.json().responseModel.validations.length > 0) {
                        this._commonService.createNotification('', response.json().responseModel.validations[0].message, 'error');
                    } else {
                        this.orderPending(response);
                    }
                    this.isUpdated = false;
                }
            }, (error: any) => {
                const notification: any = this._translatePipe.get('order.It looks like there was a technical issue while processing the order. Please call our Sales Support team at 1-888-440-ALOE (2563) to try again.');
                this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                this.isUpdated = false;
            });
        }
    }
    /**
     * @description edit Order
     * @date 2020-04-27
     * @param {string} requestUrl
     * @memberof OrderEditComponent
     */
    updateFinalOrder(orderRequest: any, requestUrl: any, orderLogMessage: any) {

        this._orderService.updateOrder(orderRequest, requestUrl).subscribe((response: any) => {
            if (response) {
                if (response.json().success) {
                    this.orderSuccess(response.json());
                    this.createOrderLog(orderLogMessage);
                } else {
                    this.orderPending(response);
                }
                this.isUpdated = false;
            }
        }, (error: any) => {
            const notification: any = this._translatePipe.get('order.Unable to Update Order');
            this._commonService.createNotification('', notification.value, 'error');
            this.isUpdated = false;
        });
    }

     /**
     * @description
     * frame content to be logged for shipping price change
     * @date 2020-03-18
     * @returns {string}
     * @memberof OrderPromotionComponent
     */
    getShippingLogInfo(): string {

        let shippingLogInfo: string;
        const shippingCost = this.getOrderShippingCost();
        if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostSelector']) {
            const hasWaived = (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString()) ? true : false;
            if (hasWaived && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
                const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
                shippingLogInfo = discountPercentage > 0 ? 'Shipping Cost was discounted by ' +
                    (discountPercentage + '%') + '.' : '';
            } else if (hasWaived && this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
                const costDifference = shippingCost - this.orginalShippingCost;
                shippingLogInfo = costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
                    transform(costDifference, this.storeInfo, true) +
                    '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
                        transform(-costDifference, this.storeInfo, true) + '.';
            }
        }
        return shippingLogInfo;
    }

    private orderSuccess(response: any) {

        this.showSelectedShipMethod = false;
        this.updateShippingAddressFormValidations(false);
        let notification: any;
        let validation = 'success';
        if (this.orderInformation && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId)) {
           notification = this._translatePipe.get('order.Order Updated successfully');
        } else {
            // only for cloned order
            if (response && response.orderStatusId === OrderStatus.Failed) {
                notification = this._translatePipe.get('order.Order Creation failed');
                validation = 'error';
            } else {
                notification = this._translatePipe.get('order.Order Created successfully');
            }
        }
        this._commonService.setNotification('', notification.value, validation, 0, false, 500);
        this.orderSubmitted = false;
        this.orderFormGroup.controls['backDateOrder'].setValue(false);
        const updatedOrderInfo = {
            webOrderId: response.webOrderId,
            countryCode: this.selectedIsoCountryCode
        };
        this._cacheService.set('UpdatedOrderInfo', updatedOrderInfo);
        this.router.navigate(['/customerservice/orders']);
    }
    private orderPending(response: any) {
        if ((response.json().status === 'IN-PROGRESS') || (response.json().status === 'QUEUED')) {
            if (this.pollCount < this.maxPollCount) {
                if (localStorage.getItem('appadmin.pollCount')) {
                    this.pollCount = +(localStorage.getItem('appadmin.pollCount'));
                } else {
                    localStorage.setItem('appadmin.pollCount', '1');
                }
                this.pollCount = this.pollCount + 1;
                localStorage.setItem('appadmin.pollCount', this.pollCount + '');
                this.updateOrder(response.json().location);
            }
        } else {
            localStorage.removeItem('appadmin.pollCount');
            if (response.json().validations && response.json().validations.length > 0) {
                const notification: any = this._translatePipe.get('order.Order is in Processing status');
                this._commonService.createNotification('', notification.value, 'error');

            }
        }
        localStorage.removeItem('appadmin.pollCount');
    }

    prepareOrderRequest(): any {
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        let orderTypeId = PurchaseFlow.Personal_Order;
        let shippingAddress;
        const memberTypeId = this.currentMemberTypeID ? this.currentMemberTypeID : this.memberTypeId;
        if (memberTypeId === this.memberTypeEnums.GUEST || memberTypeId === this.memberTypeEnums.RETAIL) {
            orderTypeId = PurchaseFlow.Retail;
        }
        const shippingTax = this._enrollService.prepareShippingTax(this.orderTaxResponse) || this.shippingTax;
        shippingAddress = this.getShippingAddress();
        if (shippingAddress && shippingAddress.countryId && this.countries && this.countries.length > 0) {
        const country = this.countries.find(x => x.countryId === shippingAddress.countryId);
        this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        const shippingObj = this.shippingMethods.filter((shipMethod: any) => shipMethod.shippingMethodId === this.orderFormGroup.value.shipMethodId)[0];
        if(this.hasManageOrderUpdatePermission && this.orderInformation.orderPayments.length > 0 && this.paymentStatusEnum.PEND !== this.orderInformation.orderPayments[0].paymentStatusId){
           this.orderStatusShippedORPickUP =  +this.orderFormGroup.controls['shippedOrderStatus'].value;
        } else {
            this.orderStatusShippedORPickUP =this.orderFormGroup.value.enableStatus ? OrderStatus.Accepted : OrderStatus.Pending
        }
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {
            shippingAddress = this.getShippingAddress();
       }else{
            shippingAddress = this.getShippingAddress();
       }
        let orderRequest: any = {
            backDateOrder: this.isOrderBackdated ? this.isOrderBackdated : this.orderFormGroup.value.backDateOrder,
            countryCode: this.selectedIsoCountryCode,
            orderStatusId: this.orderStatusShippedORPickUP,
            memberTypeId: memberTypeId,
            memberId: this.memberInfo ? this.memberInfo.memberId : null,
            email: this.memberInfo ? this.memberInfo.email : null,
            languageCode: this.languageShortCode,
            storeId: this.storeInfo.id,
            orderTypeId: orderTypeId,
            memberLevelId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
            shippingCost: this.getTaxExclusiveShippingCost(),
            moneyOrderAmount: this.orderFormGroup.controls['moneyOrderAmount'].value,
            importFeeValue: this.importFeeValue,
            retailDeliveryFee: this.retailDeliveryFee,
            shippingTax: (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice || this.appConfig && this.appConfig.displayTaxInclusivePrice ) ? 0 : shippingTax,
            distrubutorId: this.memberInfo && this.memberInfo.fboId ? this.memberInfo.fboId : null,
            orderSubTotal: this.subTotal,
            orderTotalAfterDiscount: null,
            orderTotal: this.calculateOrderTotal(),
            orderTax: this.taxableAmount,
            currencyId: this.storeInfo.currencyId,
            source: 'Customer Service',
            orderGroupId: this.orderFormGroup.value.orderType,
            orderNotes: null,
            orderLineItems: this.getOrderLineItems(this.countryTaxInclusive),
            orderShippings: this.getOrderShippings(),
            orderDiscounts: null,
            orderPayments: this.getOrderPaymentInfo(),
            shippingAddressModel: shippingAddress,
            billingAddressModel: null,
            addresses: this.getAddresses(),
            currencyCode: this.storeInfo.currencyCode,
            createdBy: this.userInfo ? this.userInfo.userId : null,
            taxMetaData: this.orderTaxResponse ? this.orderTaxResponse.taxMetaData : null,
            erpTaxMetaData: (this.orderInformation && this.orderInformation.erpTaxMetaData)?this.orderInformation.erpTaxMetaData : null,
            priceTierName: this.getPriceTier(),
            wholesaleQualified: this.orderInformation ? this.orderInformation.wholesaleQualified : null,
            sponsorId: this.orderInformation ? this.orderInformation.sponsorId : null,
            personalDiscountPercentage: this.memberInfo ? this._commonService.getDiscountPerc(this.memberDiscountPercentage)
            : this.personalDiscountPercentage,
            memberLevelDiscount: this.orderInformation ? this.orderInformation.memberLevelDiscount : 0,
            // we have to send the wholesale discount percentage of the user,
            // how much discount he will get if he is an wholesaleQualified User
            wholesaleQualifiedDiscount: this.orderInformation ? this.orderInformation.wholesaleQualifiedDiscount : 0,
            optIn: this.orderInformation ? this.orderInformation.optIn : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            vatID: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.governmentId  : null,
            accountLevelId: this._commonService.getMemberAccountLevelId(this.memberInfo),
            coldProtection: shippingObj ? shippingObj.coldProtection : false,
            languageCulture :  (this.orderInformation && this.orderInformation.languageCulture) ? this.orderInformation.languageCulture  :null,
            overrideMinimumLimit : (this.orderInformation.overrideMinimumLimit === true) ? this.orderInformation.overrideMinimumLimit : false,
            retailFreeShippingOrder: this.orderInformation && this.orderInformation.retailFreeShippingOrder ? this.orderInformation.retailFreeShippingOrder : false,
            retailFreeShippingCost: this.orderInformation && this.orderInformation.retailFreeShippingCost ? +this.orderInformation.retailFreeShippingCost : 0,
            orderLevelDiscount: this.orderLevelDiscount,
            paymentLinkEmail: this.emailForm.value.payByLinkEmail,
            sourceTypeId: 5,
            freeShippingPromotionOrder: this.orderInformation && this.orderInformation.freeShippingPromotionOrder ? this.orderInformation.freeShippingPromotionOrder : false,
        };
        return orderRequest;
    }
     /**
   * @description
   * @memberof CommonService
   */
  getCountryTaxInclusiveInfo(country: Country): boolean {
    let countryTaxInclusive = false;
    if (country && country.countryMetadata &&
      country.countryMetadata.length > 0 &&
      country.countryMetadata[0].metadata) {
      countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
    }
    return countryTaxInclusive;
  }

    /**
    * @returns OrderLineItem
    */
    private getOrderLineItems(countryTaxInclusive: boolean): any[] {
        const lineItems: any[] = [];
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;
            let lineItemTax: any;
            this.products.sort((x, y) => {
              return (x.comboBOMEnabled === y.comboBOMEnabled) ? 0 : x.comboBOMEnabled ? 1 : -1 ;
             });
            this.products.forEach((product: any) => {
                if (product) {
                    let unitPrice: number = countryTaxInclusive ? product.applicablePrice : product.catalogPrice;
                    let retailPrice: number = countryTaxInclusive ? product.retailPrice : product.baseRetailPrice;
                    let wholesalePrice: number = countryTaxInclusive ? product.wholesalePrice : product.baseWholesalePrice;
                    if (this.displayPriceConfig) {
                        unitPrice = this.displayPriceConfig.displayApplicablePrice ? product.applicablePrice :
                            (this.displayPriceConfig.displayComputedTaxInclusivePrice ? product.computedTaxInclusivePrice :
                                (this.displayPriceConfig.displayCatalogPrice ? product.catalogPrice : product.applicablePrice));
                        retailPrice = this.displayPriceConfig.displayRetailPrice ? product.retailPrice :
                            this.displayPriceConfig.displayBaseRetailPrice ? product.baseRetailPrice : product.retailPrice;
                        wholesalePrice = this.displayPriceConfig.displayWholesalePrice ? product.wholesalePrice :
                            this.displayPriceConfig.displayBaseWholesalePrice ? product.baseWholesalePrice : product.wholesalePrice;
                    }
                    if (this.orderTaxResponse && this.orderTaxResponse.cart && this.orderTaxResponse.cart.orderLineItems
                        && this.orderTaxResponse.cart.orderLineItems.length > 0) {
                        lineItemTax = this.orderTaxResponse.cart.orderLineItems.find(y => y.itemNumber === product.itemNumber);
                    }
                    const unitDiscountPrice = this.memberInfo && this.memberInfo.transactionalWholesaleQualified ?
                            (product.baseWholesalePrice - product.catalogPrice) : 0;
                    const lineItem: any = {
                        discountPercentage: product.discountPercentage,
                        literature: product.literature,
                        orderLineNumber: ++itemLineNumber,
                        productId: product.id,
                        itemNumber: product.itemNumber,
                        productName: product.displayName ? product.displayName : product.name,
                        unitRetailPrice: retailPrice,
                        unitWholeSalePrice: wholesalePrice,
                        unitBaseWholeSalePrice: product.baseWholesalePrice,
                        unitPaidPrice: unitPrice,
                        taxInclusive: (this.checkoutConfig && this.checkoutConfig.storeTaxExclusivePrice) ? false : countryTaxInclusive,
                        unitTaxExclusiveRetailPrice: product.baseRetailPrice,
                        unitTaxExclusivePaidPrice: product.catalogPrice,
                        unitCommissionablePrice: 0,
                        importedMeasurementUnit: product.importedMeasurementUnit,
                        revisionNumber: product.revisionNumber,
                        taxRate: product.taxRate || 0,
                        unitTax: lineItemTax ? lineItemTax.salesTax : 0,
                        unitTaxablePrice: lineItemTax && lineItemTax.taxablePrice ? lineItemTax.taxablePrice : 0,
                        unitQualificationValue: product.commissionableVolume || 0,
                        quantity: product.quantity,
                        freeshipping: false,
                        shippable: product.shipping ? product.shipping.shippingRequired : null,
                        fboEligible: this.getFBOEigibleProduct(product),
                        downloadActivated: product.downloadableProduct,
                        weight: product.shipping ? product.shipping.weight : null,
                        height: product.shipping ? product.shipping.height : null,
                        length: product.shipping ? product.shipping.length : null,
                        width: product.shipping ? product.shipping.width : null,
                        totalAmount: this._currencyPipe.getFormatedCurrency(this.getItemTotalSum(product), this.storeInfo),
                        discountAmount: this._currencyPipe.getFormatedCurrency
                            (this.calculateDiscountAmount(product, this.displayPriceConfig), this.storeInfo),
                        personalDiscount: this._currencyPipe.getFormatedCurrency(((
                            parseFloat(product.retailPrice.toFixed(2)) * product.quantity
                            * this.personalDiscountPercentage) / 100), this.storeInfo),
                        priceTierName: product.priceTierName,
                        netUnitPrice: this.appConfig && this.appConfig.calculateNetUnitPrice
                            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
                            && this.memberInfo.transactionalOptin ? this.calculateNetUnitPrice(product) : 0,
                        unitDiscount: unitDiscountPrice,
                        lineDiscount: unitDiscountPrice * product.quantity,
                        comboBOMEnabledProduct: product.comboBOMEnabledProduct ? product.comboBOMEnabledProduct : false,
                        depositFeeProduct: product.display ? (product.display.depositFeeProduct? true: false) : false,
                        depositFeeEnabledProduct: product.productMetaData ? (product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1')? true: false) : false,
                        orderPromotionTrackings: product.orderPromotionTrackings ? product.orderPromotionTrackings : null,
                        shippableFulfillment: product.shipping ? (product.shipping.shippableFulfillment? true : false): false,
                        bondedProduct: product.bwpEnableProduct ? true : false
                    };
                    lineItems.push(lineItem);
                }

            });
        }
        return lineItems;
    }

    calculateDiscountAmount(item: any, displayPriceConfig: DisplayPriceConfig): number {
        let discountAmount = 0;
            discountAmount = (parseFloat(item.baseRetailPrice.toFixed(2)) * item.quantity) -
                (parseFloat(item.catalogPrice.toFixed(2)) * item.quantity);
        return discountAmount;
    }

   /**
    * @description will return Unit retail price
    * @date 2020-07-25
    * @private
    * @param {*} product
    * @param {DisplayPriceConfig} displayPriceConfig
    * @returns {number}
    * @memberof OrderEditComponent
    */
   private getUnitRetailPrice(product: any, displayPriceConfig: DisplayPriceConfig): number {
        let unitRetailPrice = 0;
        if (displayPriceConfig && product) {
            if (displayPriceConfig.displayRetailPrice) {
            unitRetailPrice = product.retailPrice;
            } else if (displayPriceConfig.displayBaseRetailPrice) {
            unitRetailPrice = product.baseRetailPrice;
            } else {
            unitRetailPrice = product.retailPrice;
            }
        }
        return unitRetailPrice;
    }
    /**
     * @description will return unitwholeSale price
     * @date 2020-07-25
     * @private
     * @param {*} product
     * @param {DisplayPriceConfig} displayPriceConfig
     * @returns {number}
     * @memberof OrderEditComponent
     */
    private getUnitWholesalePrice(product: any, displayPriceConfig: DisplayPriceConfig): number {
        let unitWholesalePrice = 0;
        if (displayPriceConfig && product) {
          if (displayPriceConfig.displayWholesalePrice) {
            unitWholesalePrice = product.wholesalePrice;
          } else if (displayPriceConfig.displayBaseWholesalePrice) {
            unitWholesalePrice = product.baseWholesalePrice;
          } else {
            unitWholesalePrice = product.wholesalePrice;
          }
        }
        return unitWholesalePrice;
    }

    /**
     * @description will return UnitPaidPrice
     * @date 2020-07-25
     * @private
     * @param {*} product
     * @param {DisplayPriceConfig} displayPriceConfig
     * @returns {number}
     * @memberof OrderEditComponent
     */
    private getUnitPaidPrice(product: any, displayPriceConfig: DisplayPriceConfig): number {
        let unitPaidPrice = 0;
        if (displayPriceConfig && product) {
          if (displayPriceConfig.displayApplicablePrice) {
            unitPaidPrice = product.applicablePrice;
          } else if (displayPriceConfig.displayCatalogPrice) {
            unitPaidPrice = product.catalogPrice;
          } else if (displayPriceConfig.displayComputedTaxInclusivePrice) {
            unitPaidPrice = product.computedTaxInclusivePrice;
          } else {
            unitPaidPrice = product.applicablePrice;
          }
        }
        return unitPaidPrice;
    }

    /**
     * @description get FBO eligible product
     * @date 2019-07-04
     * @private
     * @param {Product} product
     * @returns {boolean}
     * @memberof OrderPromotionComponent
     */
    private getFBOEigibleProduct(product: Product): boolean {
        if (product.productMetaData) {
            const fboEligibilty = product.productMetaData.
              find(x => x.metaTitle === ProductMetatDataValue.DISTRIBUTORELIGIBLE);
            if (fboEligibilty && fboEligibilty.metaKeyWords === '1') {
              return true;
            }
          }
    }

    private getOrderShippings(): any[] {
        const orderShippings: any[] = [];
        let shippingAddressId = null;
        if (this.savedAddressId) {
            shippingAddressId = this.savedAddressId;
        } else if (this.verifiedShippingAddressId) {
            shippingAddressId = this.verifiedShippingAddressId;
        }
        const discountPercentage = this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
            && this.orderFormGroup.controls['shippingCostPercentage'].value > 0
            ? this.orderFormGroup.controls['shippingCostPercentage'].value : 0;
        const hasWaived = (this.orderFormGroup.controls['shippingCostSelector'].value !== this.selectEnum.firstOption.toString()) ? true : false;
        const orderShipping: any = {
            deliveryPreferenceId: this.orderFormGroup.value.deliveryPreference,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingAddressId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) ?
                shippingAddressId : null,
            shortCode: this.shipMethod.shortCode,
            preferredTime: null,
            notes: null,
            shipmentDate: null,
            shippingWaived: hasWaived,
            shippingWaiverPercentage : hasWaived ? (discountPercentage > 0 ? discountPercentage : null) : null,
            distributionCenter: this.shipMethods.distributionCenterName
        };

        if (orderShipping.deliveryPreferenceId === ShippingType.PICKUP) {
            orderShipping.distributionCenter = (this.shipMethod.pickUpLocation.pickupCenterName) ? this.shipMethod.pickUpLocation.pickupCenterName : '';
        }
        orderShippings.push(orderShipping);
        return orderShippings;
    }
    /**
      * @returns payment method id
      */
    private getPaymentMethodId(paymentMethod: string): any {
        let paymentType: PaymentType;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentType.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentType.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentType.Money_order;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentType.Wire_Transfer;
                break;
            case 'Bank_Transfer':
                paymentType = PaymentType.Bank_Transfer;
                break;
            case 'Ideal':
                paymentType = PaymentType.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentType.PayPal;
                break;
            default:
                paymentType = PaymentType.Credit_Card;
                break;

        }
        return paymentType;
    }

    /*
    */
    private getPaymentMethod(paymentMethod: string): any {
        let paymentType: PaymentMethodTypes;
        switch (paymentMethod) {
            case 'Credit_Card':
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case 'eCheck':
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case 'Money_Order':
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case 'Wire_Transfer':
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            case 'Cash':
                paymentType = PaymentMethodTypes.Cash;
                break;
            case 'Ideal':
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case 'PayPal':
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case 'Cash_On_Delivery':
                    paymentType = PaymentMethodTypes.Cash_On_Delivery;
                    break;
            case 'Orange_Money':
                    paymentType = PaymentMethodTypes.Orange_Money;
                    break;
            case 'Bank_Transfer':
                    paymentType = PaymentMethodTypes.Bank_Transfer;
                    break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

    getAddresses(): any {

        const addresses: any[] = [];
        if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) {
            const pickupAddress = this.getPickUpAddress();
            if (pickupAddress) {
                pickupAddress.deliveryInstruction = pickupAddress && pickupAddress.instruction ? pickupAddress.instruction :  '' ;
                pickupAddress.email = pickupAddress.email ? pickupAddress.email : null;
                addresses.push(pickupAddress);
            }
        }
        else {
            addresses.push(this.getShippingAddress());
        }

         if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled) {

            const pudoDropAddress = this.getPudoDropAddress(this.pudoShippingAddressInfo, this.shipMethod);
            if (pudoDropAddress) {
                pudoDropAddress.deliveryInstruction = pudoDropAddress && pudoDropAddress.instruction ? pudoDropAddress.instruction : '';
                pudoDropAddress.email = pudoDropAddress.email ? pudoDropAddress.email : null;
                addresses.push(pudoDropAddress);
            }

        }


        if ((this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) || (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString())) {
            addresses.push(this.getBillingAddress());
        }
        return addresses;
    }

    calculateOrderTotal(): any {
        let totalCost = 0;
        this.isBWPEnabledProduct = false;
        const taxableAmount = (this.checkoutConfig && this.checkoutConfig.storeTaxInclusivePrice) ? 0 : (+this.taxableAmount);
        const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
        if (this.memberInfo && this.memberInfo.vatRegistered && this.orderTaxResponse && this.countryTaxInclusive) {
            totalCost = +this.subTotal + (this.importFeeValue) + (+this.getShippingCostForOrderSummary() || 0) + taxableAmount;
        } else {
            totalCost = +this.subTotal + (this.importFeeValue) + (+this.getShippingCostForOrderSummary() || 0) +
                ((this.countryTaxInclusive === false || isCalculateTaxExclusivePrice) ? (+this.taxableAmount || 0) : 0);
        }
        this.totalOrderCost = this._currencyPipe.getFormatedCurrency(totalCost, this.storeInfo)
        if (this.orderLevelDiscount > 0 && this.storeInfo && this.storeInfo.bwpEnabled) {
            this.isBWPEnabledProduct = true;
            this.totalOrderCost = this.totalOrderCost - this.orderLevelDiscount;
            this.totalOrderCost = Number((this.totalOrderCost).toFixed(Math.max(0, ~~this.storeInfo.numberDecimals)));
        }
        this.itemTotal= totalCost - (this.itemShippingCost + this.shippingTax);;
        return this.totalOrderCost;
    }



    /**
    * @param  {any} shippingInfo
    * @returns void
    */
    calculateOrderTax(): void {

        // Get the caluculated tax from valence else Prepare ordered tax from order details
        if (!this.isOrderedTax) {
            this.taxCalculationStatus = true;
            if (this.memberInfo && this.storeInfo && this.products && this.products.length > 0 && this.orderFormGroup.value.shipMethodId) {
                const taxRequest: TaxRequest = this.prepareTaxRequest();
                this._orderService.calculateOrderTax(taxRequest)
                    .subscribe((taxResponse: any) => {
                        if (taxResponse && taxResponse.success) {
                            this.processTaxResponse(taxResponse);
                            setTimeout(() => {
                                this.taxCalculationStatus = false;
                            }, 500);
                        }
                    },
                        (error: any) => {
                            if (error) {
                                const taxResponse = error;
                                if (taxResponse && taxResponse.validations && taxResponse.validations.length > 0) {
                                    if((taxResponse.validations.map(validation => validation.name).indexOf(CommonConstant.Order_Tax))>-1) {
                                        const notification: any = this._translatePipe.get('order.Tax cannot be calculated now. Please try again later.');
                                        this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                                    }
                                    else {
                                        const notification: any = this._translatePipe.get('order.' + taxResponse.validations[0].message);
                                        this._commonService.createNotification('', notification.value, 'error');
                                    }
                                }
                            }
                        });
            }
        } else {
            // Prepare taxmeta data from Order details
            const orderedTaxResponse = this.prepareCalculatedTax();
            this.processTaxResponse(orderedTaxResponse);
            setTimeout(() => {
                this.taxCalculationStatus = false;
            }, 1000);
            this.isOrderedTax = false;
        }
    }
    /**
     * @description Process Tax value from valence data
     * @author njagadeesan
     * @date 2020-02-20
     * @param {*} taxResponse
     * @memberof OrderEditComponent
     */
    processTaxResponse(taxResponse: any): void {
        if (taxResponse.cart && taxResponse.cart.totalTax >= 0) {
            taxResponse.cart.totalTax = this._currencyPipe.getFormatedCurrency(taxResponse.cart.totalTax, this.storeInfo);
            this.orderTaxResponse = taxResponse;
            this.taxableAmount = taxResponse.cart.totalTax;
            this.retailDeliveryFee = taxResponse.cart.retailDeliveryFee ? taxResponse.cart.retailDeliveryFee : 0;
            if (this.orderTaxResponse && this.orderTaxResponse.taxMetaData
                && this.orderTaxResponse.taxMetaData.orderTaxCharges
                && this.orderTaxResponse.taxMetaData.orderTaxCharges.length > 0) {
                const gst = this.orderTaxResponse.taxMetaData
                    .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                const pst = this.orderTaxResponse.taxMetaData
                    .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                this.gstTax = gst ? gst.taxAmount : 0;
                this.pstTax = pst ? pst.taxAmount : 0;
                if (this.countryTaxInclusive) {
                    const shippingLineItem = this.orderTaxResponse.taxMetaData
                    .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.NOR && tax.lineNo === 0);
                    if (shippingLineItem && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.secondOption.toString() && this.orderFormGroup.controls['shippingCostSelector'].value != this.selectEnum.thirdOption.toString() ) {
                        this.shippingTax = shippingLineItem.taxAmount;
            }
                }
            }
            if (this.isOrderedTax) {
                this.importFeeValue = taxResponse.cart.importFeeValue;
            }
            this.total = this.taxableAmount + (+this.shippingCost) + this.subTotal + this.importFeeValue;
        }
    }
    /**
     * @description To prepare Ordered Tax Value
     * @author njagadeesan
     * @date 2020-02-20
     * @returns
     * @memberof OrderEditComponent
     */
    prepareCalculatedTax() {
        let taxOrderLineItems: any = [];
        if(this.orderInformation && this.orderInformation.orderLineItems){
            this.orderInformation.orderLineItems.forEach(element => {
                let taxOrderLineItem: any ={
                    itemNumber: element.itemNumber,
                    salesTax: element.unitTax,
                    taxablePrice: element.unitTaxablePrice
                }
                taxOrderLineItems.push(taxOrderLineItem);
            });
        }
        if (this.orderInformation && this.orderInformation.taxMetaData) {
            return {
                taxMetaData: this.orderInformation.taxMetaData,
                cart: {
                    totalTax: this.orderInformation.orderTax,
                    importFeeValue: this.orderInformation.importFeeValue,
                    retailDeliveryFee: this.orderInformation.retailDeliveryFee,
                    orderLineItems: taxOrderLineItems
                }
            };
        } else {
            this.isOrderedTax = false;
            this.calculateOrderTax();
        }
    }

    private prepareTaxRequest(): TaxRequest {
        const taxRequest: TaxRequest = {
            orderID: 0,
            memberID: this.memberInfo ? this.memberInfo.memberId : null,
            shopingCart: this.mapCartToTaxCart(),
            fromAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
                this.getPickUpAddress() : this.getShippingMethodWarehouseAddress(),
            // toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
            //     this.getPickUpAddress() : this.getShippingAddress(),
            toAddress: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation)
                ? this.getPickUpAddress(): (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP)?this.getPudoDropShipPersonAddress( this.selectedPudoCollectionPoint) :this.getShippingAddress(),
            memberNumber: this.memberInfo ? this.memberInfo.fboId : null,
            orderNumber: 0,
            storeID: this.storeInfo.id,
            priceTierName: this.getPriceTier(),
            currencyCode: this.storeInfo.currencyCode,
            countryCode: this.selectedIsoCountryCode.toLowerCase(),
            deliveryTypeId: (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) ?
                ShippingType.PICKUP : ShippingType.DELIVERY,
            orderSource: 'CUSTOMER SERVICE',
            orderTypeId: 2,
            conversionRate: 1,
            memberLevelId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
            wholesaleQualified: this.orderInformation ? this.orderInformation.wholesaleQualified : null,
            vatRegistered: this.memberInfo && this.memberInfo.vatRegistered ? this.memberInfo.vatRegistered : false,
            isDiscountedShipping: this.orderFormGroup.value.isShippingDiscountApplied,
            memberType: this.orderInformation && this.orderInformation.memberTypeId ?  MemberTypeEnum[this.orderInformation.memberTypeId] : this.memberInfo ?  MemberTypeEnum[this.memberInfo.memberTypeId] : ''
        };
        return taxRequest;
    }
    /**
      * @returns TaxCart
      */
    private mapCartToTaxCart(): any {
        const taxCart: any = {
            shippingTax: 0,
            shipMethodId: this.orderFormGroup.value.shipMethodId,
            shippingCost: this.getTaxExclusiveShippingCost() || 0,
            importFeeValue: this.importFeeValue || 0,
            importFeeEnabled: this.importFeeEnabled,
            orderLineItems: this.mapItemstoTaxItems()
        };
        return taxCart;
    }

    /**
     * @returns CartItems
     */
    private mapItemstoTaxItems(): any[] {
        // PS2020-496 PR applicable tax issue
        const address = (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP && this.shipMethod.pickUpLocation) ?
        this.getPickUpAddress() : this.getShippingAddress() ;
        /*
            TASK : HOTFIX PS2020-387
            TO:DO : taxablePrice price coloumn mapping should be based on Provider. We will adopt this changes as part of R7 release
        */
        const taxItems: any[] = [];
        if (this.products && this.products.length > 0) {
            let itemLineNumber = 0;

            if (address && address.countryId && this.countries && this.countries.length > 0) {
                const country = this.countries.find(x => x.countryId === address.countryId);
                this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
            }

            this.products.forEach((x: any) => {
                let taxablePrice: any;
                let paidPrice: any;
                if (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice) {
                    taxablePrice = x.catalogPrice;
                    paidPrice = x.applicablePrice;
                } else {
                    taxablePrice = ((this.checkoutConfig.catalogPriceAsTaxablePrice ||
                    (address && address.stateCode && address.stateCode === 'PR')) ? x.catalogPrice : x.retailPrice);
                    paidPrice = ((this.checkoutConfig.applicablePriceAspaidPrice ||
                    (address && address.stateCode && address.stateCode === 'PR')) ? x.applicablePrice : x.retailPrice);
                }
                const taxItem: any = {
                    lineNumber: ++itemLineNumber,
                    itemNumber: x.itemNumber,
                    taxablePrice: this.getTaxablePrice(taxablePrice,x),
                    quantity: +x.quantity,
                    taxCode: null,
                    description: '',//'testing',
                    taxInclusive: this.countryTaxInclusive ? true : false,
                    resale: false,
                    resalePrice: 0,
                    taxBreakDown: x.taxBreakDown,
                    productIdentifier: null,
                    retailPrice: x.retailPrice,
                    paidPrice: this.getPaidPrice(paidPrice, x),
                    wholeSalePrice: x.wholesalePrice,
                    salesTax: 0,
                    revisionNumber: x.revisionNumber,
                    itemWeight: x.shipping && x.shipping.weight ? x.shipping.weight : 0,
                    importedMeasurementUnit: x.importedMeasurementUnit,
                    unitTaxExclusiveRetailPrice: x.baseRetailPrice,
                    computedTaxInclusivePrice: x.computedTaxInclusivePrice,
                    comboBOMEnabled: x.display ? (x.display.comboBOMEnabled ? x.display.comboBOMEnabled : false) : false,
                    computedComboTaxTotals: x.computedComboTaxTotals && x.computedComboTaxTotals.length > 0 ? x.computedComboTaxTotals : [],
                    bondedProduct: (x.bwpEnableProduct && this.isBWPEnabledMember )? true : false
                };
                taxItems.push(taxItem);
            });
        }
        return taxItems;
    }
    getPaidPrice(paidPrice: number, item: any): number {
        if (this.checkoutConfig && this.checkoutConfig.applicablePriceAsTaxablePrice && (item.priceTierName === 'NEWDST' || item.priceTierName ==='WHLSAL')) {
            return item.applicablePrice;
        } else {
            return paidPrice;
        }
    }

    getTaxablePrice(taxablePrice: number, item: any): number {
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(this.selectedIsoCountryCode);
        if (this.appConfig && this.appConfig.calculateNetUnitPrice
            && this.memberInfo && this.memberInfo.transactionalWholesaleQualified
            && this.memberInfo.transactionalOptin &&
            (this.memberInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                || this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                && enableWHLSAL00ForAsstSupervisor)) {
            return this.calculateNetUnitPrice(item);
        } else if (this.memberInfo && this.memberInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
            && !enableWHLSAL00ForAsstSupervisor) {
            return item.catalogPrice;
        } else {
            return taxablePrice;
        }

    }
    getPriceTier() {
        let priceTierName = '';
        if (this.products && this.products.length > 0) {
            priceTierName = this.products[0].priceTierName;
        }
        return priceTierName;
    }

    addNewProductItem(items, index, product) {
        const itemValue = product.itemNumber + ' - ' + product.name;
        items.controls[index].controls['itemNumber'].setValue(itemValue);
        const itemImage = (product.imageModelList && product.imageModelList.length > 0)
            ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
        const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
            : (environment.uiTemplateBaseUrl + '/images/no_image.png');
        items.controls[index].controls['productImage'].setValue(imageUrl);
        items.controls[index].controls['productNumber'].setValue(product.itemNumber);
        items.controls[index].controls['productName'].setValue(product.displayName ? product.displayName : product.name);
        items.controls[index].controls['productId'].setValue(product.id);
        items.controls[index].controls['productItem'].setValue(product);
        items.controls[index].controls['disableIncrement'].setValue(false);
        return items;
    }

    setFocusbyID(id) {
        setTimeout(() => {
            const element = document.getElementById(id) as HTMLInputElement;
            if (element) {
                element.focus();
                element.select();
            }
        }, 500);
    }
    itemLevelSearchEvent(event) {
        if (event.currentTarget.value) {
            this.taxCalculationStatus = true;
            this.observableSource(event.currentTarget.value, true).subscribe((products) => {
                const responseproducts = products;
                if (responseproducts.length > 0) {
                    const product = responseproducts[0];
                    if (product.stockAvailable) {
                        let items: any = this.orderFormGroup.get('items');
                        if (items && items.length > 0) {
                            const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === product.itemNumber);
                            if (sameProductIndex >= 0) {
                                items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                                this.setFocusbyID('quantity-' + (sameProductIndex));
                            } else {
                                this.addItemNumber();
                                const index = (items.length - 1);
                                items.controls[index].controls['quantity'].setValidators([Validators.required]);
                                if (!items.controls[index].controls['quantity'].value) {
                                    items.controls[index].controls['quantity'].setValue(1);
                                }
                                items.controls[index].controls['quantity'].updateValueAndValidity();
                                this.orderFormGroup.controls['itemSearch'].setValue('');
                                items = this.addNewProductItem(items, index, product);
                                this.setFocusbyID('quantity-' + (items.length - 1));
                                this.disableUpdateQuanitity[index] = false;
                            }
                        }
                        this.updateTotalsAndShipMethod();
                        if (this.orderFormGroup.controls['orderType'].value === OrderType.POS || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                            this.deliveryPreferenceOnChange();
                        }
                    } else if (!product.stockAvailable) {
                        this._commonService.createNotification('', 'Out of stock - '
                            + (product.name || ''), 'error');
                        if (this.itemLevelSearchInput && this.itemLevelSearchInput.nativeElement) {
                            this.itemLevelSearchInput.nativeElement.focus();
                        }
                        this.taxCalculationStatus = false;
                    }
                } else {
                    if (this.itemLevelSearchInput && this.itemLevelSearchInput.nativeElement) {
                        this.itemLevelSearchInput.nativeElement.focus();
                    }
                    const notification: any = this._translatePipe.get('order.Invalid Item Number');
                    this._commonService.createNotification('', notification.value, 'error');
                }
                this.itemLevelSearchInput.nativeElement.value = '';
            });
        }
    }


    onItemSelect() {
        if (this.orderFormGroup.controls['itemSearch'].value && this.orderFormGroup.controls['itemSearch'].value.id
            && this.orderFormGroup.controls['itemSearch'].value.stockAvailable) {
            let items: any = this.orderFormGroup.get('items');
            if (items && items.length >= 0) {
                this.taxCalculationStatus = true;
                const sameProductIndex = items.controls.findIndex(item => item.controls['productNumber'].value === this.orderFormGroup.controls['itemSearch'].value.itemNumber);
                if (sameProductIndex >= 0) {
                    items.controls[sameProductIndex].controls['quantity'].setValue(+items.controls[sameProductIndex].controls['quantity'].value + 1);
                    this.orderFormGroup.controls['itemSearch'].setValue('');
                    this.setFocusbyID('quantity-' + (sameProductIndex));
                } else {
                    this.addItemNumber();
                    const index = (items.length - 1);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    if (!items.controls[index].controls['quantity'].value) {
                        items.controls[index].controls['quantity'].setValue(1);
                    }
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    if (this.orderFormGroup.controls['itemSearch'].value) {
                        const typHeadItem = this.orderFormGroup.controls['itemSearch'].value;
                        this.orderFormGroup.controls['itemSearch'].setValue('');
                        items = this.addNewProductItem(items, index, typHeadItem);
                    }
                    this.setFocusbyID('quantity-' + (items.length - 1));
                    this.isFocused = true;
                    this.disableUpdateQuanitity[index] = false;
                }
            }
            this.updateTotalsAndShipMethod();
            if (this.orderFormGroup.controls['orderType'].value === OrderType.POS || this.orderFormGroup.value.deliveryPreference === DeliveryPreference.PICKUP) {
                this.deliveryPreferenceOnChange();
            }
        } else if (this.orderFormGroup.controls['itemSearch'].value && this.orderFormGroup.controls['itemSearch'].value.id && !this.orderFormGroup.controls['itemSearch'].value.stockAvailable) {
            setTimeout(() => {
                if (this.addItemInput && this.addItemInput.nativeElement) {
                    this.addItemInput.nativeElement.focus();
                }
            }, 500);
            this._commonService.createNotification('', 'Out of stock - ' + (this.orderFormGroup.controls['itemSearch'].value.name || ''), 'error');
            this.orderFormGroup.controls['itemSearch'].setValue('');
        }
    }

    shippingAddressSelectionChange() {
        this.shippingAddressInfo = this.address;
        this.getShipMethods();

    }
    /**
     * get shipping cost in percentage
     */
    getShippingCostInPercentage() {
        let shippingOriginalCost=this.orginalShippingCost;
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                ? this.orderFormGroup.controls['originalShippingCost'].value
                : this.orderFormGroup.controls['originalShippingCost'].value - this.orderFormGroup.controls['originalShippingTax'].value;
            this.shippingTax = this.orderFormGroup.controls['originalShippingTax'].value;
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()) {
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost= this.memberInfo && this.memberInfo.vatRegistered
            ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax ;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
        }
        this.shippingTax = 0;
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(this.shippingCost, this.storeInfo);
        this.getShippingCost();
    }
    /**
     * on chnage on shipping charge selector
     */
    shippingCostChange(removeValidations?: boolean, calculateTax?: boolean) {
        if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.firstOption.toString()) {
            if (this.showSelectedShipMethod) {
                this.orderFormGroup.controls['originalShippingCost'].setValue(this._currencyPipe.getFormatedCurrency(this.orginalShippingCost || 0, this.storeInfo));
                this.orderFormGroup.controls['originalShippingTax'].setValue(this.originalShippingTax);
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            } else {
                this.orderFormGroup.controls['originalShippingCost'].setValue(0);
                this.orderFormGroup.controls['originalShippingTax'].setValue(0);
            }
            this.orderFormGroup.controls['originalShippingCost'].setValidators([Validators.required]);
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCostPercentage'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(false);
        } else if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()) {
            this.shippingCost = this.orderFormGroup.controls['shippingCost'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCostPercentage'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([Validators.required, Utils.amountValidation]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (this.shippingCost === 0) {
                this.shippingTax = 0;
            }
            this.shippingTax = 0;
        } else {
            //this.shippingCost = this.orderFormGroup.controls['shippingCostPercentage'].value;
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['shippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([Validators.required]);
            //this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
            let shippingOriginalCost=this.orginalShippingCost;
            const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value || 0;
            shippingOriginalCost= this.memberInfo && this.memberInfo.vatRegistered
            ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            const shippingcost = +shippingOriginalCost * (100 - (+discountPercentage)) / 100;
            this.shippingCost = shippingcost;
            this.orderFormGroup.controls['isShippingDiscountApplied'].setValue(true);
            if (discountPercentage === 0) {
                this.shippingTax = this.originalShippingTax;
                this.shippingCost = this.memberInfo && this.memberInfo.vatRegistered
                    ? this.orginalShippingCost : this.orginalShippingCost - this.originalShippingTax;
            } else if (discountPercentage === 100) {
                this.shippingTax = 0;
        }
        this.shippingTax = 0;
        }
        if (removeValidations) {
            this.orderFormGroup.controls['originalShippingCost'].setValue('');
            this.orderFormGroup.controls['originalShippingCost'].setValidators([]);
            this.orderFormGroup.controls['originalShippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCost'].setValidators([]);
            this.orderFormGroup.controls['shippingCostPercentage'].setValidators([]);
            this.orderFormGroup.controls['shippingCost'].updateValueAndValidity();
            this.orderFormGroup.controls['shippingCostPercentage'].updateValueAndValidity();
        }
        this.shippingCost = this._currencyPipe.getFormatedCurrency(+this.shippingCost, this.storeInfo);
        if (!calculateTax && !removeValidations) {
            this.calculateOrderTax();
        }
    }

    shippingPercentChange(event: any) {
        if (event.keyCode !== 8) {
            const value: any = (this.orderFormGroup.controls['shippingCostPercentage'].value
                ? this.orderFormGroup.controls['shippingCostPercentage'].value : '') + (event.key ? event.key : '');
            const pattern = /^(?:100|[1-9]?[0-9])$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }
    allowOnlyNumbers(event: any) {
        this.isFocused = false;
        if (event.keyCode !== 8) {
            const value: any = (event.key ? event.key : '');
            const pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }

    /**
     * Save Shipping Address
     */
    saveShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.address && this.address.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        this.useNewShippingAddress(address);

        setTimeout(function () {
            const addtoSavedAddresses = document.getElementById('addtoSavedAddresses');
            if (addtoSavedAddresses) {
                addtoSavedAddresses.focus();
            }
        }, 200);

    }

    /**
     * @description save billing address
     * @date 2018-11-19
     * @param {Address} address
     * @memberof OrderPromotionComponent
     */
    saveBillingAddress(address: Address) {
        if (address) {
            this.billingAddressInfo = this.mapVerifiedAddressToFormFields(address);
            if (this.saveEcheckFormBtn) {
                this.saveEcheckFormBtn.nativeElement.click();
            }
        }
    }

    // *************************payvision payment section*******************************/
    /**
     * @description Load Member Saved Cards
     * @date 2018-08-30
     * @memberof PaymentComponent
     */
    loadSavedCardsForMemberId(memberId: number, countryCode: string): void {
        let paymentStatus = this._cacheService.get(CacheKey.PaymentStatus);
        if (paymentStatus) {
            const newCardError: any = this._translatePipe.get('order.Payment gateway not responding');
            this._commonService.createNotification('', newCardError.value, NotificationType.ERROR);
            this._cacheService.remove(CacheKey.PaymentStatus);
        }
        const paymentInstrumentId: number = this._cacheService.get(CacheKey.PaymentInstrumentId);
        this._payvisionService.getSavedPayvisonCards(memberId, countryCode,
             paymentInstrumentId).subscribe((savedCardResponse: PayvisionSavedCardResponse) => {
            if (savedCardResponse && savedCardResponse.savedCards && savedCardResponse.savedCards.length > 0) {
                this.paymentComponentSettings.savedCards = savedCardResponse.savedCards;
                this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                    card.notes = card.defaultCard ? PaymentConstants.default : '';
                });

                if (paymentInstrumentId) {
                    this.isPaymentChanged = true;
                    this.isNewPayment = true;
                    const selectedCard = this.paymentComponentSettings.savedCards.find(x => x.id === paymentInstrumentId);
                    if (selectedCard) {
                        const indexPostion = this.paymentComponentSettings.savedCards.findIndex(x => x.id === paymentInstrumentId);
                        this.paymentComponentSettings.savedCards.splice(indexPostion, 1);
                        this.paymentComponentSettings.savedCards.unshift(selectedCard);
                        this.selectedpayvisionCardInfo = selectedCard;
                    }
                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(paymentInstrumentId);
                    this._cacheService.remove(CacheKey.PaymentInstrumentId);
                }
                else if (this.payvisionCardId) {
                    if (this.selectedpayvisionCardInfo.paymentMethod === this.paymentMethodTypes.Credit_Card
                        || this.selectedpayvisionCardInfo.paymentMethod === this.paymentMethodTypes.PayPal) {
                        const card = this.paymentComponentSettings.savedCards.find(x => x.id === +this.payvisionCardId);
                        if (card) {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                            this.selectSavedCard(card);
                        }
                    }
                } else {
                    if (this.paymentComponentSettings.savedCards && this.paymentComponentSettings.savedCards.length > 0) {
                        let isDefaultCard = false;
                        this.paymentComponentSettings.savedCards.forEach((card: PayvisionSavedCard) => {
                            if (card.expired === false && isDefaultCard === false) {
                                isDefaultCard = true;
                                if (this.selectedpayvisionCardInfo.paymentMethod === this.paymentMethodTypes.Credit_Card
                                    || this.selectedpayvisionCardInfo.paymentMethod === this.paymentMethodTypes.PayPal) {
                                    this.orderFormGroup.controls['paymentInstrumentId'].setValue(card.id);
                                    this.selectSavedCard(card);
                                }
                            }
                        });
                    } else {
                        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
                        this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
                        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                    }
                }
            } else {
                this.paymentComponentSettings.savedCards = [];
            }
        }, (error: Response) => {
            this.paymentComponentSettings.isAddNewCard = false;
        });
    }
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    getImagePath(cardType: any): string {
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    this.paymentComponentSettings.cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    this.paymentComponentSettings.cardTypeImage = null;
                    break;
            }
        }
        return this.paymentComponentSettings.cardTypeImage;
    }
    /**
     * On change of card
     */
    selectSavedCard(cardDetails: any, isNewCard?: boolean, isPaymentChanged?: boolean) {
        if (isPaymentChanged) {
            this.isPaymentChanged = true;
        }
        this.mapBillingAddress();
        this.mapShippingAddress();
        if (isNewCard) {
            if (this.shippingAddressChanged) {
                this.showVerifyAddressMessage();
                return;
            }
            this._cacheService.set(CacheKey.IsRefreshed, true);
            this.addOrderInfoToSession();
            if (this.isWorldpayPayment) {
                this.showWorldpayXml = true;
                this.showWorldPayXMLPopup.open();
            } else if (this.isAdyenPayment) {
                this.showAdyenPayment = true;
                this.showAdyenPaymentPopup.open();
            } else if (this.isNIPayment) {
                this.showNIPayment = true;
                this.showNIPopup.open();
            }   else if (this.NexioPayment) {
                this.isNexioPayment = true;
                this.showNexioPayment.open();
            }else {
                this.addNewpayvisionCard = true;
                this.payvisionPayment.open();
            }
        } else {
            this.selectedpayvisionCardInfo = cardDetails;
            this.addNewpayvisionCard = false;
            this.showWorldpayXml = false;
            this.showNIPayment = false;
            this.isNexioPayment = false;
            this.showAdyenPayment = false;
        }
    }

    showVerifyAddressMessage(): void {
        const verifyAddressError: any = this._translatePipe.get('order.Shipping Address must be verified. Please click on VERIFY ADDRESS');
        this._commonService.createNotification('', verifyAddressError.value, 'error');
    }

    addOrderInfoToSession() {
        this._cacheService.remove('UpdateOrderInfo');
        const formValues = this.orderFormGroup.value;
        const OrderInfo = {
            products: formValues.items,
            countryId: formValues.countryId,
            deliveryPreference: formValues.deliveryPreference,
            memberInfo: formValues.memberInfo,
            orderType: formValues.orderType,
            paymentSelector: formValues.paymentSelector,
            shippingAddressId: formValues.shippingAddressId,
            shippingAddressInfo: this.shippingAddressInfo,
            shipMethodId: formValues.shipMethodId,
            shippingCost: formValues.shippingCost,
            shippingCostPercentage: formValues.shippingCostPercentage,
            shippingCostSelector: formValues.shippingCostSelector,
            shippingCostValue: this.shippingCost,
            webOrderId: this.webOrderId,
            saveForFutureUse: formValues.saveForFutureUse,
            isSavedAddress: this.address ? this.address.isSavedAddress : null,
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            shoppingBagClicked: this.shoppingBagClicked ? true : false,
            memberCartSessionGuid: this.shoppingBagClicked && this.memberCart
                && this.memberCart.sessionGuid ? this.memberCart.sessionGuid :
                this.shoppingBagClicked && this.memberCartSessionGuid ? this.memberCartSessionGuid : null,
            isShippingDiscountApplied: this.orderFormGroup.value.isShippingDiscountApplied,
            originalShippingCost : formValues.originalShippingCost,
        };
        this._cacheService.set('UpdateOrderInfo', OrderInfo);
    }
    /**
     *load procducts from session
     */
    loadproducts(products: any, isDisableUpdateQuantity?: boolean) {
        products.forEach((product: any) => {
            this.addItemNumber();
            const items: any = this.orderFormGroup.get('items');
            if (items && items.length > 0) {
                const index = (items.length - 1);
                if (product) {
                    const itemValue = product.itemNumber + ' - ' + product.name;
                    items.controls[index].controls['itemNumber'].setValue(itemValue);
                    const itemImage = (product.imageModelList && product.imageModelList.length > 0)
                        ? (product.imageModelList[0].details.find((imageDetail: any) => imageDetail.type === ImageType.Thumbnail)) : '';
                    const imageUrl = (itemImage && itemImage.url) ? (environment.cdnURL + '/' + itemImage.url)
                        : (environment.uiTemplateBaseUrl + '/images/no_image.png');
                    items.controls[index].controls['productImage'].setValue(imageUrl);
                    items.controls[index].controls['productNumber'].setValue(product.itemNumber);
                    items.controls[index].controls['productName'].setValue( product.displayName ? product.displayName : product.name, );
                    items.controls[index].controls['productId'].setValue(product.id);
                    items.controls[index].controls['productItem'].setValue(product);
                    items.controls[index].controls['disableIncrement'].setValue(false);
                    items.controls[index].controls['quantity'].setValidators([Validators.required]);
                    items.controls[index].controls['quantity'].updateValueAndValidity();
                    if (this.isOrderSessionInfo) {
                        const productInfo = this.orderSession.products.find((item: any) => product.id === item.productId);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                    } else if (this.isOrderFormLoad && !this.isOrderSessionInfo) {
                        let productInfo = null;
                        if (this.memberCart && this.memberCart.items.length > 0) {
                            productInfo = this.memberCart.items.find((item: any) => product.id === item.productId);
                        } else {
                            productInfo = this.orderInformation.orderLineItems.find((item: any) => product.id === item.productId);
                        }
                        const isDepositFeeProduct = productInfo ? (productInfo.depositFeeProduct? true: false) : false;
                        const depositFeeEnabled = product.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords);
                        items.controls[index].controls['isDepositFeeProduct'].setValue(!!isDepositFeeProduct);
                        items.controls[index].controls['depositFeeEnabled'].setValue(!!depositFeeEnabled);
                        items.controls[index].controls['quantity'].setValue(productInfo && productInfo.quantity ? productInfo.quantity : 1);
                        product.orderPromotionTrackings = productInfo && productInfo.orderPromotionTrackings ? productInfo.orderPromotionTrackings : null;
                        items.controls[index].controls['productItem'].setValue(product);
                        if(items.controls[index].controls['productItem'].value.orderPromotionTrackings && items.controls[index].controls['productItem'].value.orderPromotionTrackings.length > 0 ) {
                            items.controls[index].controls['disableDelete'].setValue(true);
                            items.controls[index].controls['disableIncrement'].setValue(true);
                            this.disableUpdateQuanitity[index] = true;
                        } else {
                            items.controls[index].controls['disableDelete'].setValue(false);
                    }
                    }
                    if (isDisableUpdateQuantity || product.orderPromotionTrackings != null) {
                        this.disableUpdateQuanitity[index] = true;
                    } else {
                        this.disableUpdateQuanitity[index] = false;
                    }

                }
            }
        });
        //this.updateTotalsAndShipMethod();
        // this.orderFormGroup.value.deliveryPreference === ShippingType.PICKUP && !this.isOrderSessionInfo ? this.getShipMethods() : '';
    }
    /**
     * map shipping Info with the shipping form
     */
    mapShippingAddressToShippingInfo() {
        const formAddress = this.orderSession.shippingAddressForm;
        const shippingAddressForm: any = this.orderFormGroup.get('shippingAddressForm');
        shippingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        shippingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        shippingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        shippingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        shippingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        shippingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        shippingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        shippingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        shippingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        shippingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        if (this.orderSession.shipVerificationProcessDone) {
            this.shippingAddressInfo = this.orderSession.shippingAddressInfo;
        }
    }
    /**
     * map billing Info with the billing form
     */
    mapBillingAddressToBillingInfo() {
        const formAddress = this.orderSession.billingAddressForm;
        const billingAddressForm: any = this.orderFormGroup.get('billingAddressForm');
        billingAddressForm.controls[0].controls['name'].setValue(formAddress.name);
        billingAddressForm.controls[0].controls['addressLine1'].setValue(formAddress.addressLine1);
        billingAddressForm.controls[0].controls['addressLine2'].setValue(formAddress.addressLine2 || '');
        billingAddressForm.controls[0].controls['addressLine3'].setValue(formAddress.addressLine3 || '');
        billingAddressForm.controls[0].controls['addressLine4'].setValue(formAddress.addressLine4 || '');
        billingAddressForm.controls[0].controls['city'].setValue(formAddress.city);
        billingAddressForm.controls[0].controls['stateId'].setValue(formAddress.stateId);
        billingAddressForm.controls[0].controls['countryId'].setValue(formAddress.countryId);
        billingAddressForm.controls[0].controls['postalCode'].setValue(formAddress.postalCode);
        billingAddressForm.controls[0].controls['phone'].setValue(formAddress.phone || '');
        if (this.orderSession.billVerificationProcessDone) {
            this.billingAddressInfo = this.orderSession.billingAddressInfo;
        }
    }
    /**
     * on close of payvision form popup
     */
    onPayvisionFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        this.addNewpayvisionCard = false;
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.payvisionPayment.close();
        this.paymentComponentSettings.payvisionFormLoaded = false;
         // To remove payvision Configurations
         this._commonService.unloadPayvisionWidget();
    }

    /**
    * @returns any
    */
    private getOrderPaymentInfo(): any[] {
        const payments: any[] = [];
        const orderPayment: any = {
            savePaymentMethod: this.savePaymentMethod ? this.savePaymentMethod : false,
            paymentAmount: this.calculateOrderTotal(),
            redirect: false,
            orderSourceTypeId: OrderSourceValue.CUSTOMER,
            memberPaymentMethodId: +this.orderFormGroup.controls['paymentSelector'].value,
            authorizationCode:this.orderInformation && this.orderInformation.orderPayments[0].authCode ? this.orderInformation.orderPayments[0].authCode : null,
            creditCardModel: {
                currencyCode: this.storeInfo.currencyCode,
                paymentToken: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.token : null,
                paymentMethodType: this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value),
                maskedCreditCardNumber: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.maskedCard : null,
                cardHolderName: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.nameOnTheCard : null,
                expMonth: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.expiryMonth : null,
                expYear: this.orderFormGroup.controls['paymentSelector'].value
                    === this.selectEnum.firstOption.toString() ? this.selectedpayvisionCardInfo.expiryYear : null
            },
            paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()
            ) ? this.getEcheckInfo() : null
            // paymentECheck: (this.orderFormGroup.controls['paymentSelector'].value === this.paymentTypeEnum.eChek) ? this.getAchInfo():  null
        };
        payments.push(orderPayment);
        return payments;
    }

      /**
      * @returns payment method
      */
     private getPaymentMethodById(paymentMethodId: number): any {
        let paymentType: string;
        switch (paymentMethodId) {
            case this.paymentTypeEnum.Credit_Card:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;
            case this.paymentTypeEnum.eCheck:
                paymentType = PaymentMethodTypes.eCheck;
                break;
            case this.paymentTypeEnum.Money_order:
                paymentType = PaymentMethodTypes.Money_order;
                break;
            case this.paymentTypeEnum.Wire_Transfer:
                paymentType = PaymentMethodTypes.Wire_Transfer;
                break;
            case this.paymentTypeEnum.Cash:
                paymentType = PaymentMethodTypes.Cash;
                break;
            case this.paymentTypeEnum.Ideal:
                paymentType = PaymentMethodTypes.Ideal;
                break;
            case this.paymentTypeEnum.PayPal:
                paymentType = PaymentMethodTypes.PayPal;
                break;
            case this.paymentTypeEnum.Cash_On_Delivery:
                paymentType = PaymentMethodTypes.Cash_On_Delivery;
                break;
            case this.paymentTypeEnum.Bank_Transfer:
                paymentType = PaymentMethodTypes.Bank_Transfer;
                break;
            case this.paymentTypeEnum.BanContact_MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.BanContact_MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.MisterCash_and_Maestro:
                paymentType = PaymentMethodTypes.MisterCash_and_Maestro;
                break;
            case this.paymentTypeEnum.Saved_Cards:
                paymentType = PaymentMethodTypes.Saved_Cards;
                break;
            case this.paymentTypeEnum.Orange_Money:
                paymentType = PaymentMethodTypes.Orange_Money;
                break;
            case this.paymentTypeEnum.Google_Pay:
                paymentType = PaymentMethodTypes.Google_Pay;
                break;
            case this.paymentTypeEnum.Apple_Pay:
                paymentType = PaymentMethodTypes.Apple_Pay;
                break;
            case this.paymentTypeEnum.Pay_By_Link:
                paymentType = PaymentMethodTypes.Pay_By_Link;
                break;
            default:
                paymentType = PaymentMethodTypes.Credit_Card;
                break;

        }
        return paymentType;
    }

  /**
      * @returns payment method id
      */
     private getPaymentMethodEnumByName(paymentMethodName: string): any {
        let paymentType: number;
        switch (paymentMethodName) {
            case PaymentMethodTypes.Credit_Card:
                paymentType = this.paymentTypeEnum.Credit_Card;
                break;
            case PaymentMethodTypes.eCheck:
                paymentType = this.paymentTypeEnum.eCheck;
                break;
            case PaymentMethodTypes.Money_order:
                paymentType = this.paymentTypeEnum.Money_order;
                break;
            case PaymentMethodTypes.Wire_Transfer:
                paymentType = this.paymentTypeEnum.Wire_Transfer;
                break;
            case PaymentMethodTypes.Cash:
                paymentType = this.paymentTypeEnum.Cash;
                break;
            case PaymentMethodTypes.Ideal:
                paymentType = this.paymentTypeEnum.Ideal;
                break;
            case PaymentMethodTypes.PayPal:
                paymentType = this.paymentTypeEnum.PayPal;
                break;
            case PaymentMethodTypes.Cash_On_Delivery:
                paymentType = this.paymentTypeEnum.Cash_On_Delivery;
                break;
            case PaymentMethodTypes.Bank_Transfer:
                paymentType = this.paymentTypeEnum.Bank_Transfer;
                break;
            case PaymentMethodTypes.Orange_Money:
                paymentType = this.paymentTypeEnum.Orange_Money;
                break;
            case PaymentMethodTypes.Google_Pay:
                paymentType = this.paymentTypeEnum.Google_Pay;
                break;
            case PaymentMethodTypes.Apple_Pay:
                paymentType = this.paymentTypeEnum.Apple_Pay;
                break;
            case PaymentMethodTypes.Pay_By_Link:
                paymentType = this.paymentTypeEnum.Pay_By_Link;
                break;
            default:
                paymentType = this.paymentTypeEnum.Credit_Card;
                break;
        }
        return paymentType;
    }

    /**
     * @description get selectedPayment Type
     * @date 2019-05-04
     * @returns {string}
     * @memberof OrderEditComponent
     */
    getSelectedPaymentType(): string {
        let paymentMethodType: string;
        if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.firstOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Credit_Card');
        } else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.secondOption.toString()) {
            paymentMethodType = this.getPaymentMethod('eCheck');
            this.savePaymentMethod = this.echeckRequest ? this.echeckRequest.reusable : false;
        } else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.thirdOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Money_Order');
        } else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.sixthOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Orange_Money');
        } else if (this.orderFormGroup.controls['paymentSelector'].value === this.selectEnum.fifthOption.toString()) {
            paymentMethodType = this.getPaymentMethod('Wire_Transfer');
        }
        return paymentMethodType;
    }

    /**
     * get controls of items
     */
    getItemsControl() {
        return <FormArray>this.orderFormGroup.get('items');
    }
    /**
     * get payment Details
     */
    getOrderPaymentInfoUsingWebOrderId(webOrderId: any, orderId: any) {
        this._customerService.getPaymentInfo(webOrderId.toUpperCase(), orderId).subscribe((response: any) => {
            if (response) {
                this.billingAddressInfo = response.billingAddress;
                this.payvisionCardId = response.cardId;
                this.selectedpayvisionCardInfo = response;
                this.selectedpayvisionCardInfo.nameOnTheCard = response.cardHolderName;
                this.selectedpayvisionCardInfo.expiryMonth = response.expiryMonth;
                this.selectedpayvisionCardInfo.expiryYear = response.expiryYear;
                this.selectedCardId = response.cardId;
                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.selectedCardId);
                if (this.orderSession && this.orderSession.paymentSelector) {
                    this.orderFormGroup.controls['paymentSelector'].setValue(this.orderSession.paymentSelector);
                } else {
                    const paymentMethodId = this.getPaymentMethodEnumByName(this.selectedpayvisionCardInfo.paymentMethod);
                    this.orderFormGroup.controls['paymentSelector'].setValue(paymentMethodId.toString());
                    const options: any[] = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Bank_Transfer,
                        this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Wire_Transfer, this.paymentTypeEnum.Pay_By_Link, this.paymentTypeEnum.Orange_Money];
                    if (options.some(x => x == (+paymentMethodId))) {
                   if (paymentMethodId === this.paymentTypeEnum.Bank_Transfer && (this.orderInformation && this.orderInformation.memberTypeId)) {
                      this.currentMemberTypeID = this.orderInformation.memberTypeId;
                   }
                    this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
                    this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
                 }
               }
            }
        });
    }

    /**
     * @description
     * @date 2019-05-23
     * @memberof OrderEditComponent
     */
    disablePlaceOrderBtn(): boolean {

        const paymentMethodTypes: any[] = [PaymentMethodTypes.PayPal, PaymentMethodTypes.Credit_Card];
        if (this.isOrderStatusUpdateEnableStatus) {
        return !this.taxCalculationStatus && this.orderFormGroup.valid && this.unTouchedOrderRequest ? true : this.orderFormGroup.dirty;
        } else {
        return !this.taxCalculationStatus && this.orderFormGroup.valid && this.isPayByLinkValid &&
           (((this.unTouchedOrderRequest && this.unTouchedOrderRequest.orderPayments
                && this.unTouchedOrderRequest.orderPayments.length > 0
                && paymentMethodTypes.some(x => x === this.unTouchedOrderRequest.orderPayments[0].paymentMode)) || this.isNewPayment)
                ? true : this.isCloneOrder ? this.orderFormGroup.valid : this.orderFormGroup.dirty);
        }
    }


    /**
     * prevent +, -, e entering in shipping cost
     */
    keyEventShippingCost(event: any) {
        if (event.keyCode === 43 || event.keyCode === 45 || event.keyCode === 101) {
            event.preventDefault();
        }
    }
    validateMoneyOrderAmount() {
        this.orderFormGroup.controls['moneyOrderAmount'].setValidators([Validators.required, Utils.moneyOrderAmountValidation]);
        this.orderFormGroup.controls['moneyOrderAmount'].updateValueAndValidity();
        let paymentSelector = +this.orderFormGroup.controls['moneyOrderAmount'].value;
        if(paymentSelector >= 0 && this.orderFormGroup.controls['moneyOrderAmount'].value) {
        var balanceOrderTotal :any =  this.totalOrderCost -paymentSelector ;
           if(balanceOrderTotal === 0){
            this.validateEnteredAmount = true;
           }
           else{
            this.validateEnteredAmount = false;
           }
        }
        else{
            this.validateEnteredAmount = true;
        }

    }
    enableAmount(event: any) {
        this.orderFormGroup.controls['enableStatus'].setValue(!this.orderFormGroup.controls['enableStatus'].value);
        if (this.orderFormGroup.controls['enableStatus'].value) {
            this.orderFormGroup.controls['moneyOrderAmount'].enable();
        } else {
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
            this.validateEnteredAmount = true;
        }
        this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
    }

    // *************************************** ECheck Payment****************************/
    /**
     * Get ECheck payment
     */
    getSavedEchecks(): void {
        if (this.memberInfo.memberId) {
            this._echeckService.getSavedEchecks(this.memberInfo.memberId, this.selectedIsoCountryCode, this.eCheckTokenRes)
                .subscribe((response: PersonalCheck[]) => {
                    if (response && response.length > 0) {
                        this.paymentComponentSettings.savedEChecks = response;
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            const selectedCard = this.paymentComponentSettings.savedEChecks.find(x => x.id === this.echeckRequest.id);
                            if (selectedCard) {
                                const indexPostion = this.paymentComponentSettings.savedEChecks
                                    .findIndex(x => x.id === this.echeckRequest.id);
                                this.paymentComponentSettings.savedEChecks.splice(indexPostion, 1);
                                this.paymentComponentSettings.savedEChecks.unshift(selectedCard);
                                this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                            } else {
                                const index = this.paymentComponentSettings.savedEChecks.length - 1;
                                this.orderFormGroup.controls['paymentInstrumentId']
                                    .setValue(this.paymentComponentSettings.savedEChecks[index].id);
                                // this.orderFormGroup.controls['paymentInstrumentId']
                                //     .setValue(this.paymentComponentSettings.savedEChecks[0].id);
                            }
                            // this.selectECheck();
                        }

                    } else {
                        this.paymentComponentSettings.savedEChecks = [];
                        this.savedEChecks = '';
                    }
                    this.savedEChecks = JSON.stringify(this.paymentComponentSettings.savedEChecks);
                });
        }
    }
    /**
     * on change of payment method
     */
    onPaymentMethodChnage() {
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        //this.selectedpayvisionCardInfo = null;
        this.echeckRequest = null;
        const options: any[] = [this.paymentTypeEnum.Money_order, this.paymentTypeEnum.Wire_Transfer, this.paymentTypeEnum.Bank_Transfer,
            this.paymentTypeEnum.Cash_On_Delivery, this.paymentTypeEnum.Cash,this.paymentTypeEnum.BanContact_MisterCash_and_Maestro,
          this.paymentTypeEnum.MisterCash_and_Maestro, this.paymentTypeEnum.Pay_By_Link, this.paymentTypeEnum.Orange_Money];
        this.orderFormGroup.controls['moneyOrderAmount'].setValue('');
        if (options.some(x => x == (+this.orderFormGroup.controls['paymentSelector'].value))) {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([]);
            this.orderFormGroup.controls['enableStatus'].setValue(false);
            this.orderFormGroup.controls['moneyOrderAmount'].disable();
        } else {
            this.orderFormGroup.controls['paymentInstrumentId'].setValidators([Validators.required]);
            this.orderFormGroup.controls['moneyOrderAmount'].setValidators([]);
        }
        this.setPayByLinkEmail();
        
        this.selectedpayvisionCardInfo.paymentMethod = this.getPaymentMethodById(+this.orderFormGroup.controls['paymentSelector'].value);
        this.orderFormGroup.controls['paymentInstrumentId'].updateValueAndValidity();
    }

    setPayByLinkEmail(){
        
        if((+this.orderFormGroup.controls['paymentSelector'].value) === this.paymentTypeEnum.Pay_By_Link) {
            const email = this.paymentComponentSettings && this.paymentComponentSettings.memberEmail ? this.paymentComponentSettings.memberEmail : this.address && this.address.email ? this.address.email : null;
            if(email != null) {
                this.emailForm.controls['payByLinkEmail'].setValue(email);
            } else {
                this.emailForm.controls['payByLinkEmail'].setValue('');
            }
            this.emailForm.controls['payByLinkEmail'].updateValueAndValidity();
            if(this.emailForm.controls['payByLinkEmail'].value !== '') {
            this.isPayByLinkValid = true;
            } else {
                this.isPayByLinkValid = false;
            }
        } else {
            this.isPayByLinkValid = true;
        }
        
    }
    /**
     * on change of Echeck
     */
    selectECheck(echeckDetails: PersonalCheck, isNewEcheck: boolean) {
        this.isPaymentChanged = true;
        if (isNewEcheck) {
            this.buildEcheckForm();
            this.echeckSubmitted = false;
            this.eCheckPaymentPopup.open();
            this.addNeweCheck = true;
        } else {
            this.selectedECheckInfo = echeckDetails;
            this.billingAddressInfo = echeckDetails.billingAddress;
            this.addNeweCheck = false;
            this.eCheckTokenRes = '';
            this.echeckRequest = {
                portalCsp: true,
                id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
                portalType: EcheckPortalTypes.CustomerCare,
                accountNumber: this.selectedECheckInfo.accountNumber,
                routingNumber: this.selectedECheckInfo.routingNumber,
                bankName: this.selectedECheckInfo.bankName,
                accountType: this.selectedECheckInfo.accountType,
                nameOnBankAccount: this.selectedECheckInfo.nameOnBankAccount,
                reusable: this.selectedECheckInfo.reusable,
                defaultECheck: this.selectedECheckInfo.defaultECheck,
                customerId: this.memberInfo.memberId,
                billingAddress: this.getBillingAddressForECheck(),
                billingAddressId: null,
                billingAddressRequired: true,
                customMessage: '',
                storeId: this.storeInfo.id,
                email: this.selectedECheckInfo.email,
                phone: this.selectedECheckInfo.phone
            };
            if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                this.paymentFormBtn.nativeElement.focus();
            }
        }
    }
    /**
     * when Echeck form is closed
     */
    onECheckFormClose() {
        this.eCheckPaymentPopup.close();
        this.addNeweCheck = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedEcheckDdl && this.savedEcheckDdl.nativeElement) {
            this.savedEcheckDdl.nativeElement.focus();
        }
    }
    /**
     * buildEcheckForm
     */
    buildEcheckForm() {
        let phone = '';
        let email = '';
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if(this.phoneNumberFormat){
                phone = this._maskPipe.transform(this.memberInfo.phone, this.phoneNumberFormat);
            }else{
                phone = this.memberInfo.phone;
            }

        }
        this.echeckForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            accountType: ['', [Validators.required]],
            nameOnBankAccount: ['', [Validators.required, CustomValidators.requiredNotEmpty, Utils.alphaNumericCharacterValidation, Validators.maxLength(25)]],
            bankName: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]]
        });
    }

    validateNewECheck() {
        this.echeckSubmitted = true;
        if (this.echeckForm.valid) {
            const echeckFormValue = this._commonService.trimObjectValues(this.echeckForm.value);
            if (echeckFormValue.phone) {
                const phoneCode = PhoneCodesConstants.phoneCodes.find(x => echeckFormValue.phone.toUpperCase().indexOf(x.name) > -1);
                if (phoneCode) {
                    echeckFormValue.phone = echeckFormValue.phone;
                } else {
                    if (this.phoneNumberFormat) {
                        echeckFormValue.phone = this._maskPipe.transform(echeckFormValue.phone, this.phoneNumberFormat);
                    } else {
                        echeckFormValue.phone = echeckFormValue.phone;
                    }
                }
            }
            const validateECheckReq: ValidateEcheckRequest = {
                accountNumber: echeckFormValue.accountNumber,
                accountType: echeckFormValue.accountType,
                bankName: echeckFormValue.bankName,
                routingNumber: echeckFormValue.routerNumber,
                addressOne: this.billingAddressInfo.addressLine1,
                addressTwo: this.billingAddressInfo.addressLine2,
                city: this.billingAddressInfo.city,
                country: this.paymentComponentSettings.isoTwoletterCountryCode,
                state: this.billingAddressInfo.stateCode,
                zip: this.billingAddressInfo.postalCode,
                email: echeckFormValue.email,
                phone: echeckFormValue.phone,
                paymentMethodType: this.paymentComponentSettings.paymentMethodTypes.eCheck
            };
            this.validateECheck(validateECheckReq);
        }
    }

    /**
     * @description
     * @date 2019-01-22
     * @param {ValidateEcheckRequest} validateECheckReq
     * @memberof OrderEditComponent
     */
    validateECheck(validateECheckReq: ValidateEcheckRequest) {
        this.eCheckValidationMessages = [];
        this._echeckService.validateEcheck(validateECheckReq)
            .subscribe((response: ValidateEcheckResponse) => {
                if (response && response.success) {
                    this.savePersonalEcheck(validateECheckReq);
                } else if (response && !response.success && response.validations.length > 0) {
                    this.eCheckValidationMessages = response.validations.map(validation => validation.message);
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, error => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * save personal echecks
     */
    savePersonalEcheck(eCheckInfo: ValidateEcheckRequest) {
        this.echeckRequest = {
            portalCsp: true,
            id: this.addNeweCheck ? 0 : this.selectedECheckInfo.id,
            portalType: EcheckPortalTypes.CustomerCare,
            accountNumber: eCheckInfo.accountNumber,
            routingNumber: eCheckInfo.routingNumber,
            bankName: eCheckInfo.bankName,
            accountType: eCheckInfo.accountType,
            nameOnBankAccount: this.addNeweCheck ? eCheckInfo.name : this.selectedECheckInfo.nameOnBankAccount,
            reusable: this.addNeweCheck ? this.echeckForm.value.reuse : this.selectedECheckInfo.reusable,
            defaultECheck: this.addNeweCheck ? false : this.selectedECheckInfo.defaultECheck,
            customerId: this.memberInfo.memberId,
            billingAddress: this.getBillingAddressForECheck(),
            billingAddressId: null,
            billingAddressRequired: true,
            customMessage: '',
            storeId: this.storeInfo.id,
            email: eCheckInfo.email,
            phone: eCheckInfo.phone
        };
        this._echeckService.savePersonalCheck(this.memberInfo.memberId, this.echeckRequest)
            .subscribe((response:any) => {
                if (response) {
                    this.eCheckTokenRes = response;
                    this.echeckSubmitted = false;
                    if (this.addNeweCheck) {
                        this.eCheckPaymentPopup.close();
                        const savedEChecks = JSON.parse(this.savedEChecks);
                        this.paymentComponentSettings.savedEChecks = savedEChecks;
                        // this.orderFormGroup.controls['paymentInstrumentId'].setValue('');

                        // if (!this.echeckRequest.reusable) {
                        //     this.paymentComponentSettings.savedEChecks.push(this.echeckRequest);
                        //     this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                        // } else {
                        //     this.getSavedEchecks();
                        // }
                        if (this.echeckRequest && this.echeckRequest.reusable) {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                            this.getSavedEchecks();
                        } else {
                            this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.echeckRequest.id);
                        }
                    }
                    if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
                        this.paymentFormBtn.nativeElement.focus();
                    }
                } else {
                    this.eCheckValidationMessages.push('Echeck validation failed.');
                }
            }, (error: any) => {
                this.eCheckValidationMessages.push('Echeck validation failed.');
            });
    }
    /**
     * map billing address for e-Check
     */
    /**
     * map billing address for e-Check
     */
    getBillingAddressForECheck() {
        const stateObj = this.getStateDetailsByStateIdOrCode(null, this.billingAddressInfo.state);
        const billingAddress = {
            id: null,
            addressLine1: this.billingAddressInfo.addressLine1,
            addressLine2: this.billingAddressInfo.addressLine2 || '',
            addressLine3: this.billingAddressInfo.addressLine3 || '',
            addressLine4: this.billingAddressInfo.addressLine4 || '',
            stateId: this.billingAddressInfo.stateId || stateObj.id,
            countryId: this.billingAddressInfo.countryId,
            city: this.billingAddressInfo.city,
            state: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            stateCode: this.billingAddressInfo.stateCode || this.billingAddressInfo.state,
            country: this.billingAddressInfo.countryCode,
            countryCode: this.billingAddressInfo.countryCode,
            postalCode: this.billingAddressInfo.postalCode,
            name: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            firstName: this.billingAddressInfo.shipToName || this.billingAddressInfo.name || this.billingAddressInfo.firstName,
            phone: ''
        };
        return billingAddress;
    }
    /**
     * get billing Address Id
     */
    getBillingAddressId() {
        let billingAddressId = 0;
        if (this.orderFormGroup.value.billingAddressId) {
            billingAddressId = this.orderFormGroup.value.billingAddressId;
        } else if (this.orderFormGroup.controls['billingAddressSelector'].value === this.selectEnum.thirdOption.toString()) {
            let shippingAddressId = 0;
            if (this.orderFormGroup.value.shippingAddressId) {
                shippingAddressId = this.orderFormGroup.value.shippingAddressId;
            } else if (this.verifiedShippingAddressId) {
                shippingAddressId = this.verifiedShippingAddressId;
            }
            billingAddressId = shippingAddressId;
        } else if (this.verifiedBillingAddressId) {
            billingAddressId = this.verifiedBillingAddressId;
        }
        return billingAddressId;
    }

    /**
     * @description add mask while chnaging phone number
     *
     * @memberof EcheckComponent
     */
    onChangeEcheckPhone($event: any) {
        const value = this.echeckForm.controls['phone'].value;
        let updatedValue = value;
        const alphaNumericValue = value.replace(/[^a-z0-9]/gi, '');
        if (value.match(/[a-zA-Z]/)) {
            if (alphaNumericValue.substr(0, 3).match(/[a-zA-Z]/)) {
                updatedValue = value.replace(/[^a-z0-9]/gi, '');
            } else if (alphaNumericValue.substr(3, 3).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) AAAAAAA');
            } else if (alphaNumericValue.substr(6, 4).match(/[a-zA-Z]/)) {
                updatedValue = this._maskPipe.transform(value, '(000) 000-AAAA');
            }
        } else {
            if (alphaNumericValue.length !== 3) {
                if(this.phoneNumberFormat){
                    updatedValue = this._maskPipe.transform(value, this.phoneNumberFormat);
                }else{
                    updatedValue = value;
                }
            }
        }
        this.echeckForm.controls['phone'].setValue(updatedValue);
    }

    /**
     * map Echeck Info for payment
     */
    getEcheckInfo() {
        const eCheckInfo = {
            bankName: this.echeckRequest.bankName,
            accountNumber: this.echeckRequest.accountNumber,
            routingNumber: this.echeckRequest.routingNumber,
            accountType: this.echeckRequest.accountType,
            mecTransactionID: '',
            nameOnBankAccount: this.echeckRequest.nameOnBankAccount,
            customMessage: '',
            reusable: this.echeckRequest.reusable,
            eCheckID: this.eCheckTokenRes ? parseInt(atob(this.eCheckTokenRes), 10) : this.echeckRequest ? this.echeckRequest.id : 0,
            email: this.echeckRequest.email,
            phone: this.echeckRequest.phone
        };
        return eCheckInfo;
    }

    onWorldpayXMLFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this._cacheService.remove('UpdateOrderInfo');
        this.showWorldpayXml = false;
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showWorldPayXMLPopup.close();
    }

    onAdyenPaymentFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showAdyenPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showAdyenPaymentPopup.close();
    }

    onNIFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.showNIPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNIPopup.close();
    }

    onNexioFormClose() {
        this._cacheService.remove(CacheKey.IsRefreshed);
        this.isNexioPayment = false;
        sessionStorage.removeItem(CacheKey.OrderInfo);
        this._cacheService.remove('UpdateOrderInfo');
        this.orderFormGroup.controls['paymentInstrumentId'].setValue('');
        if (this.savedCardsDdl && this.savedCardsDdl.nativeElement) {
            this.savedCardsDdl.nativeElement.focus();
        }
        this.showNexioPayment.close();
    }
    /**
 * get restricted products
 */
    getRestrictedProducts(productModels: RestrictedProduct[]) {
        this.isRestrictedProduct = true;
        this.getShippingRestrictionError();
        this.restrictedProducts = [];
        productModels.forEach((product: RestrictedProduct) => {
            const itemNumber = product.itemNumber.substring(product.itemNumber.indexOf('#') + 1);
            const item = this.products.find((x: any) => x.itemNumber === itemNumber);
            item ? this.restrictedProducts.push(item.name + ' - #' + itemNumber) : '';
        });
        this.showRestrictedProducts.open();
    }

    /**
     * generates and return Order Message based of changes made to Order.
     */
    getOrderLogMessage() {
        let orderLog = '';
        const intialProductIds = this.orderInformation.orderLineItems.map((item: any) => item.productId);
        this.products.forEach((product: any) => {
            const initialProduct = this.orderInformation.orderLineItems.find((item: any) => item.productId === product.id);
            if (initialProduct) {
                intialProductIds.splice(intialProductIds.indexOf(initialProduct.productId), 1);
                if (initialProduct.quantity != +product.quantity) {
                    orderLog += 'The quantity of Item #' + product.itemNumber + ' - ' + product.name + ' changed from ' + initialProduct.quantity + ' to ' + product.quantity + '. ';
                }
            } else {
                orderLog += 'Item #' + product.itemNumber + ' - ' + product.name + ' added and quantity is ' + product.quantity + '. ';
            }
        });
        intialProductIds.forEach((id: number) => {
            const initialProduct = this.orderInformation.orderLineItems.find((item: any) => item.productId === id);
            orderLog += 'Item #' + initialProduct.itemNumber + ' - ' + initialProduct.productName + ' removed. ';
        });
        const newShipMethod = this.shippingMethods.find((item: any) => item.shippingMethodId === +this.orderFormGroup.value.shipMethodId);
        if (this.orderInformation.orderShippings[0].deliveryPreferenceId
            !== this.orderFormGroup.value.deliveryPreference) {
            const initialPreference = Object.keys(DeliveryPreference)
                .find(k => DeliveryPreference[k] === this.orderInformation.orderShippings[0].deliveryPreferenceId);
            const newPreference = Object.keys(DeliveryPreference).find(k => DeliveryPreference[k]
                === this.orderFormGroup.value.deliveryPreference);
            orderLog += 'Delivery preference changed from ' + initialPreference + ' to ' + newPreference + '.';
            if (+this.orderFormGroup.value.shipMethodId !== this.orderInformation.orderShippings[0].shipMethodId) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) {
                    orderLog += 'Shipping Method is ' + newShipMethod.shippingMethodDisplayName + '. ';
                } else {
                    orderLog += 'Pick Up location is ' + newShipMethod.pickUpLocation.name + '. ';
                }
            }
        } else {
            if (+this.orderFormGroup.value.shipMethodId !== this.orderInformation.orderShippings[0].shipMethodId) {
                if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY) {
                    orderLog += 'Shipping Method changed to ' + newShipMethod.shippingMethodDisplayName + '. ';
                } else {
                    orderLog += 'Pick Up location changed to ' + newShipMethod.pickUpLocation.name + '. ';
                }
            }
        }
        if (this.orderFormGroup && this.orderFormGroup.controls['shippingCostPercentage']
        && this.orderFormGroup.controls['shippingCostPercentage'].value > 0) {
        const discountPercentage = this.orderFormGroup.controls['shippingCostPercentage'].value;
        orderLog += 'Shipping Cost was discounted by ' + (discountPercentage + '%') + '. ';
        } else if (this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DELIVERY
            && this.orginalShippingCost !== (this.shippingCost + this.originalShippingTax)) {
        const costDifference = this.shippingCost - this.orginalShippingCost;
        orderLog += costDifference > 0 ? 'Shipping Cost was increased by ' + this._currencyPipe.
        transform(costDifference, this.storeInfo, true) +
        '.' : 'Shipping Cost was discounted by ' + this._currencyPipe.
        transform(-costDifference, this.storeInfo, true) + '.';
        }
        const paymentInfo = this.getOrderPaymentInfo();
        if (this.orderInformation.orderPayments.length > 0 && this.orderInformation.orderPayments[0].paymentMode
            && paymentInfo[0].creditCardModel.paymentMethodType !== this.orderInformation.orderPayments[0].paymentMode) {
            orderLog += 'Order payment method changed from ' + this.orderInformation.orderPayments[0].paymentMode
                + ' to ' + paymentInfo[0].creditCardModel.paymentMethodType + '. ';
            if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Credit_Card) {
                orderLog += 'Payment done through card number ending with' + paymentInfo[0].creditCardModel.maskedCreditCardNumber + '. ';
            }
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Money_order
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            const moneyOrderAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Money Order funds ' + moneyOrderAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Orange_Money
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            const orangeMoneyAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += 'Orange Money funds ' + orangeMoneyAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Wire_Transfer
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            const moneyOrderAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Wire Transfer funds ' + moneyOrderAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Bank_Transfer
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            const bankTransferAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Bank Transfer funds ' + bankTransferAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        if (paymentInfo[0].creditCardModel.paymentMethodType === PaymentMethodTypes.Cash_On_Delivery
            && +this.orderFormGroup.controls['moneyOrderAmount'].value !== 0) {
            const CashOnDeliveryAmount = this._currencyPipe
                .getDecimalFormattedCurrency(this.orderFormGroup.controls['moneyOrderAmount'].value, this.storeInfo);
            orderLog += ' Cash On Delivery Amount ' + CashOnDeliveryAmount + ' ' + this.storeInfo.currencyCode + ' are received.';
        }
        //orderLog += "Order updated by " + this.userInfo.firstName + ' ' + (this.userInfo.middleName ? (this.userInfo.middleName + ' ') : '') + (this.userInfo.lastName ? this.userInfo.lastName : '') + ". ";

        return orderLog;
    }

     /**
     * create order log request parameter
     */
    createOrderLog(response: any, isNewOrder?: Boolean, shippingInfo?: String) {
        const orderLogRequest = {
            'messageTypeId': MessageTypeEnum.OrderLogsMessageType,
            'orderId': isNewOrder ? response.id : this.orderInformation.id,
            'webOrderId':  isNewOrder ? response.webOrderId : this.orderInformation.webOrderId,
            'message': isNewOrder ? (shippingInfo ? shippingInfo : 'Order Placed by the agent') : response,
            'source': Constants.CUSTOMER_SERIVCE
        };
        if(orderLogRequest && orderLogRequest.message) {
            this._orderservice.createOrderLog(orderLogRequest)
                .subscribe((response) => {
                }, (error: any) => {
                    this._commonService.createNotification('', 'Failed to Create order log', 'error');
                });
        }
    }

    /**
     * @description sip to different address click
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    shipToDifferentAddress(): void {
        this.showSavedAddress = true;
        this.isNewCard = false;
    }

    /**
     * @description this method will show new address form
     * @date 2018-11-16
     * @memberof OrderPromotionComponent
     */
    addNewAddress(): void {
        if(this.shippingAddressInfoConfig && (!this.shippingAddressInfoConfig.pudoLocationsEnabled && this.shippingAddressInfoConfig.dropShipLocationsEnabled) && this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DROPSHIP){
            this.displayDropAddress = false;
            this.pudoAddressSubmitted = false;
            this.addNewDropshipPersonAddress();
        }
        this.address = null;
        this.showSavedAddress = false;
        this.isNewCard = true;
        this.clearPudoLocationSearchData();
    }

    clearPudoLocationSearchData() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = true;
        this.buildPudoLocationSearchForm();
    }

        /**
     * map the billing address fields
     */
    mapBillingAddress() {
        if (this.orderFormGroup.value.deliveryPreference === this.deliveryPreference.DELIVERY && (this.shippingAddressInfo && this.shippingAddressInfo.countryId) || (this.memberInfo && this.memberInfo.address)) {
            const address =  (this.memberInfo && this.memberInfo.address) || this.shippingAddressInfo ;
            this.paymentComponentSettings.billingAddress = address;
            let country: Country;
            if (this.shippingAddressInfo && (this.shippingAddressInfo.stateCode === PaymentConstants.PuertoRico
                 || this.shippingAddressInfo.stateCode === PaymentConstants.VirginIslands
                  || this.shippingAddressInfo.stateCode === PaymentConstants.MarshallIslands)) {
                if (this.shippingAddressInfo.stateCode === PaymentConstants.MarshallIslands) {
                    country = this.countries.filter(x => x.isocodeThree.toLowerCase()
                        === this.shippingAddressInfo.stateCode.toLowerCase())[0];
                } else {
                    country = this.countries.filter(x => x.isocodeTwo.toLowerCase()
                        === this.shippingAddressInfo.stateCode.toLowerCase())[0];
                }
            } else {
                if(this.shippingAddressInfo && this.shippingAddressInfo.countryId) {
                    country = this.countries.filter(x => x.countryId ===  this.shippingAddressInfo.countryId)[0];
                }
            }
            this.paymentComponentSettings.billingAddress.countryCodeTwo =  country ? country.isocodeTwo : '';
            if(this.shippingAddressInfo && this.shippingAddressInfo.postalCode) {
                this.paymentComponentSettings.billingAddress.zipCode = this.shippingAddressInfo.postalCode;
            }
        } else {
            this.paymentComponentSettings.billingAddress = this.memberInfo.address;
            const country = this.countries.filter(x => x.countryId ===  this.memberInfo.address.countryId)[0];
            this.paymentComponentSettings.billingAddress.countryCodeTwo =  country ? country.isocodeTwo : '';
            this.paymentComponentSettings.billingAddress.zipCode = this.memberInfo.address.postalCode;
        }

    }

    /**
     * verifyOrderRules
     * @returns boolean
     */
    verifyOrderRules(isBackOrderDate: boolean): any {
        let valid: any;
        valid = { thresholdCrossed: false, monthlyCCValid: false, memberCCOverride: false };
        let monthlyCCValid = false;
        let thresholdCrossed = false;
        const totalPoints = this.calculateTotalPoints();
        let subTotal = this.calculateSubtotalWithWholesalePrice(this.calculateItemsSubTotal(this.storeInfo));
        if(this.selectedpayvisionCardInfo &&(this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Bank_Transfer ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Money_order ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Orange_Money ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Wire_Transfer ||
            this.selectedpayvisionCardInfo.paymentMethod === PaymentMethodTypes.Cash_On_Delivery)
            && this.orderInformation && !(this.orderStatusId.Failed == this.orderInformation.orderStatusId)
            && this.paymentStatusEnum.PEND == this.orderInformation.orderPayments[0].paymentStatusId)
            {
                this.isMoneyOrderAmountUpdate = true;
            }
        // changes for order min/max for taxInclusive stores PS2022-1077
        if (this.storeInfo && this.storeInfo.taxInclusive) {
            subTotal = this.itemTotal;
        }
        if (this.orderRules && this.orderRules.valueType === ValueType.CC &&
            (totalPoints >= this.orderRules.minValue && totalPoints <= this.orderRules.maxValue)) {
                thresholdCrossed = false;
        } else if (this.orderRules && this.orderRules.valueType === ValueType.PRICE) {
            if (this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length) {
                thresholdCrossed = this.validateSubTotalBasedOnType(this.products, subTotal);
            } else if (subTotal >= this.orderRules.minValue && subTotal <= this.orderRules.maxValue) {
                thresholdCrossed = false;
            } else {
                thresholdCrossed = true;
                if(subTotal <= this.orderRules.minValue && (this.orderInformation.overrideMinimumLimit === true||this.isOrderStatusUpdateEnableStatus||this.isMoneyOrderAmountUpdate)){
                    thresholdCrossed=false;
                }
            }
        } else {
           thresholdCrossed = true;
        }
            if (this.memberInfo && this.memberOrderCCInfo) {
                let maxValue;
                if (this.appConfig && !this.appConfig.displayPurchaseLimitationMessage && (this.orderRules &&
                    this.orderRules.valueType === ValueType.PRICE && this.orderRules.validateProductTypes && this.orderRules.validateProductTypes.length)) {
                    maxValue = this.orderRules.maxCCValue > this.memberOrderCCInfo.maxCCValue
                        ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                    valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
                }  else if(this.orderRules && this.orderRules.valueType === ValueType.PRICE && this.orderRules.monthlyValueType === ValueType.CC){
                     maxValue = this.orderRules.maxCCValue >= this.memberOrderCCInfo.maxCCValue ? this.orderRules.maxCCValue : this.memberOrderCCInfo.maxCCValue;
                   valid.monthlyCCValue = this.memberOrderCCInfo.maxCCValue;
             }else {
                    maxValue = this.orderRules.maxValue > this.memberOrderCCInfo.maxValue
                        ? this.orderRules.maxValue : this.memberOrderCCInfo.maxValue;
                    valid.monthlyCCValue = this.memberOrderCCInfo.maxValue;
                }
                if ((totalPoints + this.memberOrderCCInfo.actualCCValue) > maxValue) {
                    monthlyCCValid = true;
                    thresholdCrossed = false;
                }
                // Monthly CC override for member
                if (this.orderRules && this.memberOrderCCInfo && this.memberCCOverride
                     && this.memberCCOverride.overrideFlag) {
                    const currentDate = this.momentConstructor(new Date()).format(DateConstants.DateFormat);
                    const endDate = this.momentConstructor(new Date(this.memberCCOverride.effectiveEndDate))
                    .format(DateConstants.DateFormat);
                    if (!isBackOrderDate) {
                        if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                            valid.memberCCOverride = true;
                        } else if ((this.orderRules && this.orderRules.maxCCValue < this.memberCCOverride.cVLimit)
                        && ((totalPoints + this.memberOrderCCInfo.actualCCValue) <= this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate)) ) {
                           monthlyCCValid = false;
                       }
                    } else {
                        if (((totalPoints + this.memberOrderCCInfo.actualCCValue) > this.memberCCOverride.cVLimit)
                        && (new Date(currentDate) <= new Date(endDate))) {
                            valid.memberCCOverride = true;
                        }
                    }
                }
            }
            if (!totalPoints) {
                monthlyCCValid = false;
                thresholdCrossed = false;
            }
            valid.thresholdCrossed = thresholdCrossed;
            valid.monthlyCCValid = monthlyCCValid;
              // for order rule value type: BOTH
        if (this.orderRules && this.orderRules.valueType === ValueType.BOTH) {
            const totalCC = (totalPoints + (this.memberOrderCCInfo ? this.memberOrderCCInfo.actualCCValue : 0));
            const details = this._commonService.validateSubTotalBasedOnBothPriceAndCC(
                this.orderRules, this.isLiteratureValidation(this.products), subTotal, totalCC
            );
            valid.cartLimitExceed = details.cartLimitExceed;
            valid.cartLimitNotReach = details.cartLimitNotReach;
            valid.monthlyCCValid = details.monthlyCCValid;
            valid.monthlyCCValue = details.monthlyCCValue;
            valid.thresholdCrossed = details.thresholdCrossed;
        }
            return valid;
    }
 /**
     * calculateSubtotalWithWholesalePrice()
     * @param shoppingCart
     */
  calculateSubtotalWithWholesalePrice(orderSubTotal: number): number {
    let subTotal = orderSubTotal;
    if (this.products && this.products.length &&
        this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
        && this.appConfig.displayPurchaseLimitationMessage
        && this.orderRules && this.orderRules.minValueOnWholesalePrice && this.orderRules.valueType === ValueType.PRICE) {
        subTotal = 0;
        this.products.forEach(item => {
            subTotal += ((this.countryTaxInclusive ? item.wholesalePrice : item.baseWholesalePrice) * item.quantity);
        });
        // Should not apply wholesale price when user exceeds limit,
        // Wholesale price calculation applicable for minimum limit restriction
        if (orderSubTotal > this.orderRules.maxValue) {
            subTotal = orderSubTotal;
        }
    }
    return subTotal;
}


    /**
     * Get total points
     */
    calculateTotalPoints(): number {
        let _totalCV = 0;
        for (let i = 0; i < this.products.length; i++) {
            if (!this.products[i].literature) {
              _totalCV += this.products[i].commissionableVolume * this.products[i].quantity;
            }
        }
        return _totalCV;
    }

    /**
     * Get Total added Products Cost.
     */
    calculateItemsSubTotal(store: StoreConfig): number {
        let itemsSubTotal = 0;
        for (let i = 0; i < this.products.length; i++) {
            if (this.products[i].applicablePrice) {
                itemsSubTotal += Number(this.products[i].applicablePrice.
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * this.products[i].quantity;
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            itemsSubTotal = Number(itemsSubTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return itemsSubTotal;
    }

    /**
   * @description get Order Min Max Business Rules
   * @memberof OrderPromotionComponent
   */
  getOrderRules(): void {
    const userInfo: Member = this.memberInfo;
    const orderRulesRequest: OrderRulesRequest = {
      countryCode: this.selectedIsoCountryCode,
      memberTitleId: this.orderInformation && this.orderInformation.memberLevelId ? this.orderInformation.memberLevelId : MemberLevel.RETAIL,
      orderType: this.orderInformation && this.orderInformation.memberLevelId !== MemberLevel.RETAIL ? MemberOrderType.Personal
        : MemberOrderType.Retail
    };
    this._orderService.getOrderBusinessRules(orderRulesRequest)
      .subscribe((response: any) => {
        if (response) {
          this.orderRules =  response;
        }
      }, error => {
      });
      if (userInfo && userInfo.memberId && (this.memberInfo.memberTypeId === MemberTypeEnum.FPC
          || this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
          this.getMemberOrderRules(userInfo, false);
          this.getMemberCCOverrides(userInfo.memberId);
      }
  }

/**
   * @description savePayment methos
   * @memberof OrderPromotionComponent
   */
  savePaymentMethodClicked(savePaymentMethod: boolean): void {
    this.isPaymentChanged = true;
    this.savePaymentMethod = !savePaymentMethod;
  }

  /**
     *
     * @param items
     */
    getItemVolumeSum(items): number {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        } else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    }
    trackByItem(index: number): number {
        return index;
    }

    moveToItemLevelSearchBlock(event: any) {
        if (this.itemLevelSearchInput && this.itemLevelSearchInput.nativeElement) {
            this.itemLevelSearchInput.nativeElement.focus();
        }
    }

    validateSubTotalBasedOnType(products: any[], subTotal?: any): boolean {
        let isThresholdCrossed =  true;
        const itemSubTotal = subTotal;
        let orderMinValue = this.orderRules.minValue;
        let orderMaxValue = this.orderRules.maxValue;
        if (this.isLiteratureValidation(products)) {
             orderMinValue = this.orderRules.literatureMinValue;
             orderMaxValue = this.orderRules.literatureMaxValue;
        }
        if (itemSubTotal >= orderMinValue && itemSubTotal <= orderMaxValue) {
           isThresholdCrossed = false;
        }
        if(itemSubTotal<=orderMinValue){
            this.orderInformation.overrideMinimumLimit===true||this.isOrderStatusUpdateEnableStatus||this.isMoneyOrderAmountUpdate?isThresholdCrossed=false:isThresholdCrossed=true;
        }
       return isThresholdCrossed;
      }

      isLiteratureValidation(products?: any): boolean {
        const literatureItems = products && products.filter(item => item.literature);
        const isLiterature = literatureItems &&  literatureItems.length && products && products.length
        && products.length === literatureItems.length;
        return isLiterature;
      }

    /**
    * @description This method used to get cart items by member
    * getCartItemsByMemberAndCartTypeId()
    * @returns void
    */
    getCartItemsByMemberAndCartTypeId(isSaveBagClicked?: boolean): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, this.storeInfo)
            .subscribe((cartInfo: Cart) => {
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCart = cartInfo;
                    if (!this.isOrderSessionInfo && cartInfo.items && cartInfo.items.length && !isSaveBagClicked) {
                        const productIds = cartInfo.items.map(x => x.productId);
                        this.getProductsByIds(productIds);
                    }
                } else {
                    this.memberCart = null;
                }
                if (isSaveBagClicked) {
                    this.saveBag(true);
                }
            }, error => {
                new Error(error);
            });
    }

    /**
   * Save and update bag items
   * @returns void
   */
    saveBag(isFallBack?: boolean): void {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        if (items && items.length) {
            if (this.memberCart && this.memberCart.sessionGuid) {
                this.prepareCartUpdateRequest();
                this._customerService.updateCart(this.memberCart, CartTypes.OrderCart,
                    this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(response => {
                        if (response) {
                            this.createSuccessNotification(response);
                            this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                        }
                    });
            } else {
                if (!isFallBack) {
                    this.getCartItemsByMemberAndCartTypeId(true);
                } else {
                    const cart = this.prepareCartCreateRequest();
                    this._customerService.saveCart(cart, CartTypes.OrderCart,
                        this.storeInfo.id, this.memberInfo.memberId, 1).subscribe(response => {
                            if (response) {
                                this.createSuccessNotification(response);
                                this._cacheService.set(CacheKey.CARTUPDATED, 'true');
                            }
                        });
                }
            }
            this.getShoppingCartCount(this.storeInfo);
        }
    }

    /**
      * prepare update request
      * prepareCartUpdateRequest()
      * @returns void
      */
    prepareCartUpdateRequest(): void {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        items.forEach(item => {
            const product = this.memberCart.items.find(itm => itm.productId === item.productId);
            if (product) {
                this.memberCart.items.forEach(cart => {
                    if (cart.productId === product.productId) {
                        cart.quantity = this.shoppingBagClicked ? item.quantity : cart.quantity + Number(item.quantity);
                    }
                });
            } else {
                const productItem: Item = {
                    productId: item.productId,
                    quantity: item.quantity
                };
                this.memberCart.items.push(productItem);
            }
        });
        if (this.shoppingBagClicked) {
            this.memberCart.items = this.memberCart.items.filter(item => {
                return items.map(product => product.productId).indexOf(item.productId) > -1;
            });
        }
    }

    /**
      * prepare create request
      * prepareCartCreateRequest()
      * @returns void
      */
    prepareCartCreateRequest(): Cart {
        const items = this.getOrderLineItems(this.countryTaxInclusive);
        const memberCart: Cart = { items: [] };
        items.forEach(item => {
            const productItem: Item = {
                productId: item.productId,
                quantity: item.quantity
            };
            memberCart.items.push(productItem);
        });
        return memberCart;
    }

    // get existing shopping cart item count
    getShoppingCartCount(storeInfo: StoreConfig): void {
        this._customerService.getCartItemsByMemberIdAndCartType(this.memberInfo.memberId,
            CartTypes.OrderCart, storeInfo)
            .subscribe((cartInfo: Cart) => {
                this.existingItemCount = 0;
                if (cartInfo && cartInfo.sessionGuid) {
                    this.memberCartInfo = cartInfo;
                    this.existingItemCount = 0;
                    const cartItems = cartInfo.items;
                    for (let index = 0; cartItems.length > 0 && cartItems.length > index; index++) {
                        this.existingItemCount += cartItems[index].quantity;
                    }
                    this.shoppingCartCount = this.existingItemCount;
                } else {
                    this.existingItemCount = 0;
                }
            }, error => {
                new Error(error);
            });
    }

    /**
    * show success notification after updating cart items
    * createSuccessNotification()
    * @returns void
    */
    createSuccessNotification(response: Cart): void {
        this.memberCart = response;
        const notification = this._translatePipe.get('order.Member cart items updated successfully')['value'];
        this._commonService.createNotification('', notification, 'success');
    }

    /**
       * @description get member cart items list
       * @memberof OrderPromotionComponent
       */
    getMemberCartItems(): void {
        if (this.orderFormGroup && this.orderFormGroup.value.orderType === this.orderType.REGULAR
            && this.shoppingBagClicked && this.memberTypeId && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId();
        } else {
            this.memberCart = null;
        }
    }

      /**
     * @description
     * @private
     * @memberof OrderPromotionComponent
     */
    private loadMemberShoppingCart(storeInfo: StoreConfig): void {
        // get Member cart items when shopping bag clicked
        if (this.orderFormGroup.value.orderType === this.orderType.REGULAR && !this.memberCartSessionGuid
             && this.shoppingBagClicked && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.getCartItemsByMemberAndCartTypeId();
        } else if (!this.shoppingBagClicked && this.orderFormGroup.value.orderType === this.orderType.REGULAR && this.memberTypeId && this.memberTypeId !== MemberTypeEnum.GUEST) {
            this.shoppingCartCount = this.existingItemCount;
            this.memberCart = null;
        } else {
            this.memberCart = null;
        }
    }
    /**
      * removing not available cart items based on logged in user
      * @param  {Cart} orderCart
      * @param  {CartItem[]} unAvailableCartItems
      */
    private deleteCart(sessionGuid: string) {
        if (sessionGuid) {
            this.shoppingCartCount = 0;
            this.itemCount = 0;
            this._customerService.removeCartItem(sessionGuid,
                this.storeInfo.id).subscribe(response => {
                });
        }
    }

    gotoCheckout(): void {
        if (this.shoppingCartCount) {
            if (!this.memberCart) {
                if (this.memberCartInfo.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCartInfo,
                        shoppingBagClicked: true
                    });
                }
            } else {
                if (this.memberCart.items.length > 0) {
                    this._cacheService.set(CacheKey.CREATE_ORDER_INFO_SESSION_CODE, {
                        distributorId: this.memberInfo.fboId, shoppingCart: this.memberCart,
                        shoppingBagClicked: true
                    });
                }
            }
        }
    }

    calculateNetUnitPrice(product: any): number {
        const netUnitPrice = product.computedTaxInclusivePrice / (1 + (product.taxRate / 100));
        return Math.round((netUnitPrice + Number.EPSILON) * 100) / 100;
    }

    /**
    * @description this method will calculate shipping cost that has to be used for calculating order summary
    * @memberof OrderPromotionComponent
    */
   getShippingCostForOrderSummary(): number {
        let shippingCost = +this.getOrderShippingCost() || 0;
        if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost > 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value > 0)) {
                shippingCost = (this.memberInfo && this.memberInfo.vatRegistered || this.orderInformation.orderShippings[0] && this.orderInformation.orderShippings[0].shippingWaived || 
                    (this.appConfig.enableVatItemizationForNonVat && this.orderInformation.memberTypeId === this.memberTypeEnums.DISTRIBUTOR) || 
                    (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice))? (this.shippingCost || 0) : (this.shippingCost || 0) + (this.shippingTax || 0);
            } else if ((this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.secondOption.toString()
                && this.shippingCost === 0)
                || (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value === 100)) {
                shippingCost = 0;
}
        }
        this.itemShippingCost =shippingCost;
        return shippingCost;
    }

    /**
    * @description this method will calculate tax exclusive shipping cost
    * @memberof OrderPromotionComponent
    */
    getTaxExclusiveShippingCost(): number {
        let shippingCost = this.shippingCost || 0;
        if (this.orderFormGroup.value.isShippingDiscountApplied) {
            if (this.orderFormGroup.controls['shippingCostSelector'].value === this.selectEnum.thirdOption.toString()
                && this.orderFormGroup.controls['shippingCostPercentage'].value === 100) {
                shippingCost = 0;
            }
        }
        return shippingCost;
    }

    /**
    * @description this method will calculate total shipping cost that includes taxes
    * @memberof OrderPromotionComponent
    */
    getOrderShippingCost(): number {
        if (this.appConfig) {
            if (this.memberInfo && ((this.appConfig.enableVatItemizationForNonVat &&
                 this.memberInfo.memberTypeId === MemberTypeId.DISTRIBUTOR) ||
             this.memberInfo.vatRegistered || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)) &&
             !this.appConfig.calculateShippingWithTax) {
                return this.shippingCost;

            } else if (this.appConfig.calculateShippingWithTax &&   !(this.memberInfo.vatRegistered)) {
                return this.shippingCost + this.shippingTax;
            } else {
                return this.shippingCost;

            }

        }

    }
    getBankDetails() {
        const bankDetails = this._translateService.get(PaymentConstants.BankTransfer)['value'];
        if (bankDetails != PaymentConstants.BankTransfer) {
            for (const key in bankDetails) {
                if (key.indexOf(PaymentConstants.BankDetails) > -1) {
                    this.bankDetailsList.push(bankDetails[key]);
                }
            }
        }
    }

    /**
    *
    * @param items
    */
    getItemTotalSum(item): number {
        return this.calculateSubTotal(this.storeInfo,
            this.countryTaxInclusive, item, this.memberInfo, true);
    }

    /**
      * Get Total CartItems Cost.
    */
    calculateSubTotal(store: StoreConfig, taxInclusiveShippingCountry: boolean,
        item: any, userInfo: Member, taxCalculated: boolean): number {
        let subTotal = 0;
        if (item) {
            const isEnableVATCalculation = this.appConfig && this.appConfig.enableVATCalculation;
            const isCalculateTaxExclusivePrice = this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice;
           if (userInfo && store.taxInclusive && isEnableVATCalculation) {
                subTotal += this.calculateSubtotalForVatAndNonVatRegisteredUser(item,
                    store, taxInclusiveShippingCountry, userInfo, taxCalculated);
            } else {
                subTotal += this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry, isCalculateTaxExclusivePrice);
            }
        }
        if (store) {
            // tslint:disable-next-line:no-bitwise
            subTotal = Number(subTotal.toFixed(Math.max(0, ~~store.numberDecimals)));
        }
        return subTotal;
    }

    /**
     * calculate subtotal for vat and not vat registered user
     * calculateSubtotalForVatAndNonVatRegisteredUser()
     */
    calculateSubtotalForVatAndNonVatRegisteredUser(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean,
        userInfo: Member, taxCalculated: boolean): number {
        if (!item.literature && (taxCalculated || !userInfo.vatRegistered)) {
            if (userInfo.transactionalOptin &&
                userInfo.transactionalWholesaleQualified
                && (userInfo.memberTitleId > MemberLevel.ASSISTANTSUPERVISOR
                    || (userInfo.memberTitleId === MemberLevel.ASSISTANTSUPERVISOR
                        && this._commonService.isWHLSAL00enabledForAsstSupervisor(store.homeIsocodeThree)))) {
                const total = Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'computedTaxInclusivePrice']);
                return (Math.round((total + Number.EPSILON) * 100) / 100) * item.quantity;
            } else {
                return Number(item[(userInfo.vatRegistered || !taxInclusiveShippingCountry)
                    ? 'catalogPrice' : 'applicablePrice'].
                    // tslint:disable-next-line:no-bitwise
                    toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
            }
        } else if (taxCalculated && (userInfo.vatRegistered)) {
            return Number(item.catalogPrice.
                // tslint:disable-next-line:no-bitwise
                toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
        } else {
            return this.calculateItemSubtotal(item, store, taxInclusiveShippingCountry);
        }
    }

    /**
    * calculate subtotal
    * calculateItemSubtotal()
    */
    calculateItemSubtotal(item: any, store: StoreConfig, taxInclusiveShippingCountry: boolean, isCalcTaxExclusivePrice?: boolean): number {
        return Number(item[(taxInclusiveShippingCountry === false || isCalcTaxExclusivePrice) ? 'catalogPrice' : 'applicablePrice'].
            // tslint:disable-next-line:no-bitwise
            toFixed(Math.max(0, ~~(store && store.numberDecimals ? store.numberDecimals : 2)))) * item.quantity;
    }
    buildAchForm() {
        let phone = '';
        let email = '';
        let checkNumber = "";
        const phoneNumberFormat =this._commonService.getPhoneNumberFormatByCountryCode(this.countryCode);
        if (this.memberInfo) {
            email = this.memberInfo.email;
            if(phoneNumberFormat){
                phone = this._maskPipe.transform(this.memberInfo.phone, phoneNumberFormat);
            }else{
                phone = this.memberInfo.phone;
            }
        }
        this.paymentAchForm = this._formbuilder.group({
            routerNumber: ['', [Validators.required, Utils.alphaNumericCharacterValidation, Validators.maxLength(9)]],
            accountNumber: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
          //  accountType: ['', [Validators.required]],
            dlNumber: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
             dlState: ["", [Validators.required, CustomValidators.requiredNotEmpty]],
             secType: ['', [Validators.required, CustomValidator.checkIfAccountSelected()],
      ],
            email: [email, Validators.required],
            phone: [phone, [Validators.required, EcheckPhoneNumberValidation.PhoneNumberValidation]],
            checkNumber: [checkNumber,[Validators.required, CustomValidators.requiredNotEmpty]],
            reuse: [false],
            billingAddressId: [''],
        });
    }
    /**
     * on change of Ach
     */
    // selectAch(achDetails: PersonalAch, isNewAch: boolean) {
    //     if (isNewAch) {
    //         this.buildAchForm();
    //         this.echeckSubmitted = false;
    //         this.eCheckValidationMessages = [];
    //         this.achPaymentPopup.open();
    //        this.addNewAch = true;
    //     } else {
    //         this.selectedAchInfo = achDetails;
    //         this.billingAddressInfo = achDetails.billingAddress;
    //         this.addNewAch = false;
    //         if (this.paymentFormBtn && this.paymentFormBtn.nativeElement) {
    //             this.paymentFormBtn.nativeElement.focus();
    //         }
    //     }
    //  }
     /**
     * Get ACH payment
     */
    // getSavedAchs(): void {
    //     const memberId = this.getUserMemberId();
    //     if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
    //         this._achService.getSavedAchs(memberId, this.selectedIsoCountryCode, PaymentMethodTypeConstants.Ach, this.achToken)
    //             .subscribe((response: PersonalAch[]) => {
    //                 if (response && response.length) {
    //                     this.paymentComponentSettings.savedAchs = response;
    //                     this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
    //                     if (this.achRequest && this.achRequest.reusable) {
    //                         const selectedCard = this.paymentComponentSettings.savedAchs.find(x => x.id === this.achRequest.id);
    //                         if (selectedCard) {
    //                             const indexPostion = this.paymentComponentSettings.savedAchs
    //                                 .findIndex(x => x.id === this.achRequest.id);
    //                             this.paymentComponentSettings.savedAchs.splice(indexPostion, 1);
    //                             this.paymentComponentSettings.savedAchs.unshift(selectedCard);
    //                             this.orderFormGroup.controls['paymentInstrumentId'].setValue(this.paymentComponentSettings.savedAchs[0].id);
    //                         } else {
    //                             const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                             this.orderFormGroup.controls['paymentInstrumentId']
    //                                 .setValue(this.paymentComponentSettings.savedAchs[index].id);
    //                         }
    //                         const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                          this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
    //                     } else {
    //                         const index = this.paymentComponentSettings.savedAchs.length - 1;
    //                         this.selectAch(this.paymentComponentSettings.savedAchs[index],false);
    //                     }
    //                     this.savedAch = JSON.stringify(this.paymentComponentSettings.savedAchs);
    //                 }

    //             });
    //     }
    // }
    // getUserMemberId() {
    //     let memberId = null;
    //     if (this.accountMemberInfo && this.accountMemberInfo.memberId) {
    //       memberId = this.accountMemberInfo.memberId;
    //     } else
    //         memberId = 0

    //     return memberId;
    //   }
    /**
   * @description submit ach payment information
   * @memberof ACHComponent
   */
    //   submitAchPaymentInformation(achPaymentInfo) {
    //      if(achPaymentInfo){
    //         this.achPaymentInfo = achPaymentInfo;
    //         this.achToken=this.achPaymentInfo.personalCheckId;
    //         this.getSavedAchs();
    //         this.achPaymentPopup.close();
    //    }
    // }
    // onPaymentAchFormClose() {
    //     this.achPaymentPopup.close();
    // }
     /**
     * map Ach Info for payment
     */
//     getAchInfo() {
//         this.achPaymentInfo=this.achPaymentInfo?this.achPaymentInfo:this.selectedAchInfo;
//         if(this.achPaymentInfo){
//           const paymentAchInfo = {
//               bankName: this.achPaymentInfo.bankName,
//               accountNumber: this.achPaymentInfo.accountNumber,
//               routingNumber: this.achPaymentInfo.routingNumber,
//               accountType: this.achPaymentInfo.accountType,
//               mecTransactionID: '',
//               nameOnBankAccount: this.achPaymentInfo.nameOnBankAccount,
//               customMessage: '',
//               reusable: this.achPaymentInfo.reusable,
//               eCheckID:  this.achPaymentInfo.id,
//               email: this.achPaymentInfo.email,
//               phone: this.achPaymentInfo.phone,
//               secType:this.achPaymentInfo.secType,
//               dlState:this.achPaymentInfo.dlState,
//               dlNumber:this.achPaymentInfo.dlNumber,
//               checkNumber:this.achPaymentInfo.checkNumber,
//           };
//           return paymentAchInfo;
//       }

//   }

      /**
     * @description To get the list of bank details from payment service based on country
     * @date 2021-01-07
     * @param {*} countryCode
     * @memberof OrderEditComponent
     */
    getBankDetailsByCountry(countryCode: any,paymentMethod?:string) {
        this._achService.getBankDetailsByCountry(countryCode,paymentMethod).subscribe(response => {
            if (response && response.length > 0) {
                if (paymentMethod && PaymentMethodTypes.Wire_Transfer.toLowerCase() === paymentMethod.toLowerCase()) {
                    this.bankDetailsCountryList = response.filter((bankDetail) => bankDetail.paymentMode.toLowerCase() == PaymentMethodTypes.Wire_Transfer.toLowerCase());
                } else {
                    this.bankDetailsCountryList = response;
                }
            } else {
                this.bankDetailsCountryList = [];
            }
        });
    }

    checkLoadedProducts(productsIds: Array<number>, response?: any): void {
        if (response && response.length) {
            let responseProductIds = [];
            responseProductIds = response.map((product: any) => product.id);
            if (this.isEditOrder) {
                this.prepareProductModel(productsIds ,response);
            } else {
                const resultIds = productsIds.filter(item => responseProductIds.indexOf(item) === -1);
                this.prepareProductModel(resultIds);
                this.loadproducts(response);
            }
        } else {
            this.prepareProductModel(productsIds);
        }
        this.getDepositFeeProduct(productsIds);
    }

    prepareProductModel(idList: Array<number>, response?: any): void {
        if (idList && idList.length > 0) {
            let bwpEnableProduct: boolean;
            const products = [];
            idList.forEach((id) => {
                const lineItem = this.orderInformation.orderLineItems.find((item: any) => item.productId === id);
                const productResponse = response && response.find((product: any) => product.id === id);
                bwpEnableProduct = productResponse && productResponse.productMetaData.find(product => product.metaTitle === ProductMetatDataValue.BONDED_WAREHOUSE_PRODUCT && product.metaKeyWords === '1');
                const product = {
                    itemNumber: lineItem.itemNumber,
                    name: lineItem.productName,
                    id: lineItem.productId,
                    retailPrice: lineItem.unitRetailPrice,
                    baseRetailPrice: lineItem.unitRetailPrice,
                    applicablePrice: lineItem.unitPaidPrice,
                    catalogPrice: lineItem.unitPaidPrice,
                    computedTaxInclusivePrice: lineItem.unitPaidPrice,
                    baseWholesalePrice: lineItem.unitWholeSalePrice,
                    wholesalePrice: lineItem.unitWholeSalePrice,
                    unitBaseWholeSalePrice: lineItem.baseWholesalePrice,
                    taxRate: lineItem.taxRate,
                    discountPercentage: lineItem.discountPercentage,
                    literature: lineItem.literature,
                    importedMeasurementUnit: lineItem.importedMeasurementUnit,
                    revisionNumber: lineItem.revisionNumber,
                    commissionableVolume: lineItem.unitQualificationValue,
                    downloadableProduct: lineItem.downloadActivated,
                    shipping: {
                        height: lineItem.height,
                        weight: lineItem.weight,
                        length: lineItem.length,
                        width: lineItem.width,
                        shippingRequired: lineItem.shippable,
                        shippableFulfillment: lineItem.shippableFulfillment
                    },
                    stockAvailable: productResponse ? productResponse.stockAvailable : null,
                    manageStock: productResponse ? productResponse.manageStock : null,
                    stockQuantity: productResponse ? productResponse.stockQuantity : null,
                    bwpEnableProduct :bwpEnableProduct,
                    productMetaData: [{
                        metaTitle: ProductMetatDataValue.DISTRIBUTORELIGIBLE,
                        metaKeyWords: lineItem.fboEligible ? lineItem.fboEligible : false
                    },
                    {
                        metaTitle: ProductMetatDataValue.DEPOSIT_FEE_ENABLED,
                        metaKeyWords: productResponse && productResponse.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_ENABLED && x.metaKeyWords === '1') ? true: false
                    },
                    {
                        metaTitle: ProductMetatDataValue.DEPOSIT_FEE_PRODUCT,
                        metaKeyWords: productResponse.productMetaData.find(x => x.metaTitle === ProductMetatDataValue.DEPOSIT_FEE_PRODUCT && x.metaKeyWords === '1') ? true: false
                    }],
                    priceTierName: this.orderInformation.priceTierName,
                    imageModelList: response && response.length ? this.prepareProductImageModel(lineItem.productId ,response):[],
                    comboBOMEnabledProduct: productResponse.display ? (productResponse.display.comboBOMEnabled ? true : false) : false
                };
                products.push(product);
            });
            this.loadproducts(products, true);
        }
    }

    prepareProductImageModel(productId: number ,response?: any):any {
        const  productDetails = response.find(product=> product.id === productId);
        if ( productDetails && productDetails.imageModelList && productDetails.imageModelList.length) {
            return productDetails.imageModelList;
        } else {
            return [];
        }
    }

    /**
     * @description Method to search address based on name
     * @date 2021-04-21
     * @memberof OrderEditComponent
     */
    searchShippingAddress(event: any) {
        this.addressSearchResult = this._commonService.searchShippingAddress(event, this.memberAddressDetails);
    }

     /**
     * To Get Promotions based on store
     */
    getStorePromotions(memberTypeID) {
        if(this.storeInfo && this.storeInfo.languages && this.orderInformation) {
            let result;
            let cultureName = this.orderInformation.languageCulture;
            if (cultureName) {
            this.storeLanguageCultureId = this.storeInfo.languages.find((languageCulture: any) => languageCulture.cultureName.toLowerCase() == cultureName.toLowerCase()).cultureId;
            }
        }
        this.promotionModels = [];
        const promotionrequest: Promotion = {
            memberType: memberTypeID,
            orderType: PromotionOrderType.SHOP,
            memberLevel: this.memberInfo.memberTitleId,
            isTaxInclusive: this.countryTaxInclusive,
            languageSetting: this.storeLanguageCultureId ? this.storeLanguageCultureId :null
        };
        this._commonService.getPromotionEngineConfigurations(this.storeId, promotionrequest).subscribe((response: any) => {
            if (response && response.promotionModelList && response.promotionModelList.length > 0) {
                this.promotionModels = response.promotionModelList;
            } else {
                this.promotionModels = [];
            }
        }, error => {
            this.promotionModels = [];
        });
    }
    getStoreMetaData(storeId: any) {
        this._commonService.getStoreMetaData(storeId)
            .subscribe(storeMetaData => {
                this.storeMetadata = storeMetaData;
                if(this.storeInfo && this.storeMetadata && this.storeMetadata.length > 0) {
                    let hasOrderUpdatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.ORDER_STATUS_UPDATE + "]"),AccessLevel.Store,this.storeInfo ? this.storeInfo.id : null);
                    this.hasServiceOrderUpdatePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ServiceOrderPermissions[1]+ "]"),AccessLevel.Customer_Service);
                    let hasServiceOrderUpdatePermissions = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"),AccessLevel.Customer_Service);
                    let orderStatusUpdateAttribute = this.storeMetadata.find(x => (x.attribute &&
                            (x.attribute.toLowerCase() === (StoreMetaDataConstants.ENABLE_ORDER_STATUS_UPDATE.toLowerCase()||StoreMetaDataConstants.ENABLE_SERVICE_ORDER.toLowerCase()))));
                    let storeOrderUpdateFeatureEnabled = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                    this.hasManageOrderUpdatePermission = (hasOrderUpdatePermission||hasServiceOrderUpdatePermissions) && storeOrderUpdateFeatureEnabled;
                    let isPickupOrder = this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.PICKUP?true:false
                    this.isOrderStatusUpdateEnableStatus = (this.hasManageOrderUpdatePermission ||(this.hasServiceOrderUpdatePermission && isPickupOrder)) && this.orderInformation &&  this.isEditOrder && (this.orderStatusId.Processing == this.orderInformation.orderStatusId || this.orderStatusId.Shipped == this.orderInformation.orderStatusId || this.orderStatusId.Ready_For_Pickup == this.orderInformation.orderStatusId) && this.orderInformation.orderPayments.length > 0  && this.paymentStatusEnum.PEND !== this.orderInformation.orderPayments[0].paymentStatusId ? true : false;

                    if(this.isOrderStatusUpdateEnableStatus) {
                        this.orderFormGroup.controls['shippedOrderStatus'].setValidators(Validators.required);
                    }
                }
            });
    }
    mapShippingAddress() {
        if (this.shippingAddressInfo) {
            this.paymentComponentSettings.shippingAddressDetail = this.shippingAddressInfo;
        }
    }

    private getDepositFeeProduct(productsIds: number[]) {
        let depositFeeProducts: Product[] = null;
        const purchaseFlowType = this._commonService.getPurchaseFlowType(this.memberTypeId, this.memberInfo.wholeSaleQualified, this.appConfig.fpc5PercentEnabled, false, this.memberInfo.memberTitleId);
        const wholesaleQualified: boolean = this.memberInfo && this.memberInfo.wholeSaleQualified
            ? this.memberInfo.wholeSaleQualified : false;
        const optin: boolean = this.memberInfo && this.memberInfo.optin ? this.memberInfo.optin : false;
        this._customerService.getRelatedProductList(this.storeId, productsIds, 2, this.memberInfo.memberTitleId, this.countryCode, purchaseFlowType, this.storeInfo.taxInclusive, wholesaleQualified, optin)
            .subscribe(response => {
                if (response && response.length) {
                    depositFeeProducts = response;
                    depositFeeProducts.forEach(product => {
                        productsIds.forEach(productId => {
                            const depsoitFeeProductDetail = depositFeeProducts.find(x => x.associateProductId == productId);
                            if (depsoitFeeProductDetail && product.id == depsoitFeeProductDetail.id) {
                                const productAssociation = this.productAssociationInfo.find(x => x.productId === productId && x.depositFeeProductId === product.id);
                                if (!productAssociation) {
                                    this.productAssociationInfo.push({
                                        productId: productId,
                                        depositFeeProductId: product.id
                                    });
                                }
                            }
                        });
                    });
                }
            });
    }
    buildPudoLocationSearchForm(zipCode ?: string, city ?: string , addressLine1?: string , country?: string , externalId?: string ) {
        this.pudoLocationSearchForm = this._formbuilder.group({
            zipCode: [zipCode, [Validators.required, this.getZipCodePatterns()]],
            externalId: [externalId],
            city: [city, [Validators.required]],
            country: [country],
            addressLine1: [addressLine1]
        })
        const countryCode = this.selectedIsoCountryCode || '';
        this.pudoLocationSearchForm.patchValue({
            country: countryCode.toUpperCase()
        });
    }
    getZipCodePatterns() {
        this._commonService.getZipCodePatterns().subscribe((response: any) => {
            let zipCodePatterns = response;
            const pattern = zipCodePatterns.filter(x => x.isoCodeThree
                === this.selectedIsoCountryCode)
            this.zipPattern = pattern ? pattern.zipPattern : null;
        });
        return Validators.pattern(new RegExp(this.zipPattern));

    }

    private getPudoDropShipPersonAddress(collectionPoint?: CollectionPoint): any {
        let address: any = collectionPoint;
        let dropShipAddress;
        if(collectionPoint){
            dropShipAddress = {
                addressLine1: address.street ? collectionPoint.street : this.pudoShippingAddressInfo.addressLine1,
                addressLine2: address.address2,
                addressLine3: address.address3,
                city: address.city,
                state: collectionPoint.state,
                stateCode: this.pudoShippingAddressInfo.stateCode || null,
                countryCode: this.selectedIsoCountryCode,
                country: collectionPoint.country || this.selectedIsoCountryCode,
                postalCode: this.pudoShippingAddressInfo.postalCode || null,
                zipCode: address.zipCode,
                countryId: this.pudoShippingAddressInfo.countryId,
                stateId: this.pudoShippingAddressInfo.stateId,
                externalId: address.externalId,
                name: address.name ? this.storeInfo.warehouseAddress.name : null
            }
            this.pudoAddress = dropShipAddress;
            this.messageService.setPudoPersonAddress(true)
            this.dropShipAddress = dropShipAddress;
            return  this.dropShipAddress ;
        }
        else if (this.dropLoactionSelected) {
            return  this.dropShipAddress ;
        }else if(this.orderSession && this.orderSession.pudoaddress){
            return this.orderSession.pudoaddress;
        } else {
            return
        }
    }

    addNewDropshipPersonAddress(): void {
        this.pudoShippingAddressInfo = null;
        this.showDropShipPersonAddressForm = true;
        setTimeout(()=>{
            this.displayDropAddress = true;
        },100);
    }
    
    savePudoShippingAddress(address: Address) {
        address = this.mapVerifiedAddressToFormFields(address);
        if (this.memberInfo && this.orderFormGroup.controls['saveForFutureUse'].value) {
            this.saveAddress(address);
        } else if (this.pudoAddress && this.pudoAddress.isSavedAddress) {
            this.messageService.setAddressSaved(true);
        }
        if (address && address.countryId && this.countries && this.countries.length > 0) {
            const country = this.countries.find(x => x.countryId === address.countryId);
            this.countryTaxInclusive = this.getCountryTaxInclusiveInfo(country);
        }
        this.pudoShippingAddressInfo = address;
        this.pudoAddress = address;
        this.pudoAddressSubmitted = true;
    }
    getAddressIsValid(isValid) {
      //  this.formPickupPersonAddressValid = isValid;
        //this.pudoLocationsNotFound = false;
    }

    pudoAddressInputChange(address: Address): void {
        if (this.formPickupPersonAddressValid) {
            this.pudoAddress = address;
            this.pudoCollectionPoints = null;
            this.hidePudoPickupLocationsButton = true;
           this.pudoLocationsNotFound = false;
            if (this.pudoAddress) {
                this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city, this.pudoAddress.addressLine1,this.pudoAddress.externalId);
            }
        }
    }
    clearPudoLocationSearchForm() {
        this.pudoCollectionPoints = null;
        this.selectedPudoCollectionPoint = null;
        this.pudoLocationSearchForm = null;
        this.pudoLocationsNotFound = false;
        this.hidePudoPickupLocationsButton = false;
        this.buildPudoLocationSearchForm();
    }
    getPudoLocations() {
        let pudoLocationRequest: PudoLocationRequest = this.preparePudoLocationRequest();
        if (pudoLocationRequest) {
            this.pudoLocationsNotFound = false;
            this.pudoCollectionPoints = null;
            this.selectedPudoCollectionPoint = null;
            this.loadingPudoPickupLocations = true;
            this._orderService.getPudoLocations(pudoLocationRequest).subscribe(
                (res) => {
                    this.loadingPudoPickupLocations = false;
                    if (res && res.collectionPoints && res.collectionPoints.length) {
                        this.pudoLocationsNotFound = false;
                        res.collectionPoints.sort((x, y) => x.distance - y.distance);
                        this.pudoCollectionPoints = res.collectionPoints;

                        this.calculateOrderTax();
                        this.prepareBusinessHours();
                        if (this.pudoLocationSearchForm && this.pudoLocationSearchForm.value && this.pudoLocationSearchForm.value.externalId) {
                            this.selectedPudoCollectionPoint = this.pudoCollectionPoints.find((x) => x.externalId == this.pudoLocationSearchForm.value.externalId);
                            this.selectPudoCollectionPoint(this.selectedPudoCollectionPoint);
                        }
                    } else {
                        this.pudoLocationsNotFound = true;
                    }
                }, (error) => {
                    this.loadingPudoPickupLocations = false;
                    this.pudoLocationsNotFound = true;
                }
            );
        }
    }
    preparePudoLocationRequest() {
        if (!this.countries) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
        }
        let request: PudoLocationRequest = null;
        if (this.pudoLocationSearchForm) {
            let pudoLocationSearchFormData = this.pudoLocationSearchForm.value;
            if (this.pudoAddress) {
                this.pudoAddress.zip = this.pudoAddress.zip ? this.pudoAddress.zip : this.pudoAddress.postalCode;
            }
            if (pudoLocationSearchFormData && pudoLocationSearchFormData.zipCode ? true: this.pudoAddress && this.pudoAddress.zip) {
                if (!pudoLocationSearchFormData.zipCode) {
                    this.buildPudoLocationSearchForm(this.pudoAddress.zip, this.pudoAddress.city,this.pudoAddress.addressLine1);
                }
                pudoLocationSearchFormData = this.pudoLocationSearchForm.value
                if (this.countries && pudoLocationSearchFormData.zipCode) {
                    const country: Country = this.countries.find((x: Country) => x.isocodeThree.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
                    request = {
                        countryIsoCode: pudoLocationSearchFormData.country || '',
                        postalCode: pudoLocationSearchFormData.zipCode || '',
                        storeID: this.storeInfo && this.storeInfo.id || null,
                        city: pudoLocationSearchFormData.city || '.',
                        streetAddress: pudoLocationSearchFormData.addressLine1 || '',
                        languageCode : "en",
                    }
                }
            }
        }
        else {
                  if(this.pudoShippingAddressInfo){
                    request = {
                        countryIsoCode: this.pudoShippingAddressInfo.countryCode || '',
                        postalCode: this.pudoShippingAddressInfo.postalCode || '',
                        storeID:  this.orderInformation && this.orderInformation.storeId || null,
                        city: this.pudoShippingAddressInfo.city || '.',
                        streetAddress: this.pudoShippingAddressInfo.addressLine1 || '',
                       languageCode : "en",
                    }
                  }
                  this.buildPudoLocationSearchForm();

        }
        return request;
    }


        prepareBusinessHours(): void {
            if (this.pudoCollectionPoints && this.pudoCollectionPoints.length) {
                this.pudoCollectionPoints.forEach((collectionPoint) => {
                    if (collectionPoint && collectionPoint.openingHours) {
                        let businessHours: BusinessHour[] = [];
                        collectionPoint.openingHours.forEach((opening) => {
                            if (opening && opening.hours) {
                                let hours: SplitHour[] = [];
                                opening.hours.forEach((hour) => {
                                    hours.push({ start: hour.opens, end: hour.closes })
                                });
                                const businessHour: BusinessHour = {
                                    available: true,
                                    day: opening.dayText,
                                    hours: hours
                                }
                                businessHours.push(businessHour);
                            }
                        });
                        collectionPoint.businessHours = businessHours;
                    }
                });
            }
        }
        loadPUDOLocations() {
            if (!this.skipAddressVerification) {
                this.messageService.setSubmitPudoPickupPersonAddress(true);
            } else {
                if(this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                    this.messageService.setSubmitPudoDropShipPersonAddress(true);
                }
                this.getPudoLocations();
            }
        }
        getPudoLocationMap(geoPoint: GeoPoint) {
            if (geoPoint && geoPoint.latitude && geoPoint.longitude) {
                if(environment.restrictGoogleMapNavigation){
                    return ApiUrlConstants.googleMapsUrl + geoPoint.latitude +
                    ',' + geoPoint.longitude;
                }
                else {
                 return null;
                }
            }
            return null;
        }

        selectPudoCollectionPoint(collectionPoint: CollectionPoint) {
            this.dropShipAddress = null;
            this.selectedPudoCollectionPoint = collectionPoint;
            if(this.orderFormGroup.value.deliveryPreference === ShippingType.DROPSHIP && this.shippingAddressInfoConfig.dropShipLocationsEnabled){
                this.getPudoDropShipPersonAddress(collectionPoint);
                this.dropLoactionSelected = true;
                this.getShipMethods();
             }
            this.dropLoactionSelected = false;
            this.calculateOrderTax();
        }
        getPudoDropAddress(address: Address, shippingMethod: ShippingMethod): any {
            if (this.shippingAddressInfoConfig && this.shippingAddressInfoConfig.dropShipLocationsEnabled &&
                this.orderFormGroup.value.deliveryPreference === DeliveryPreference.DROPSHIP) {
                const pudoCollectionPoint = this.selectedPudoCollectionPoint ? this.selectedPudoCollectionPoint : this.dropShipAddress ? this.dropShipAddress :address;

                const countryObj = this.getCountryDetailsByCountryIdOrCode(null, this.selectedIsoCountryCode);
                const stateObj = this.getStateDetailsByStateIdOrCode(null, this.pudoAddress.stateCode);
                const pudoDropShipAddress: any = {
                    addressLine1: this.selectedPudoCollectionPoint?(pudoCollectionPoint.street + ' ' + pudoCollectionPoint.houseNumber):
                     pudoCollectionPoint.addressLine1?pudoCollectionPoint.addressLine1:address.addressLine1 ,
                    addressLine2: this.selectedPudoCollectionPoint? pudoCollectionPoint.address2 : pudoCollectionPoint.addressLine2 ,
                    addressLine3: this.selectedPudoCollectionPoint ?pudoCollectionPoint.address3 : pudoCollectionPoint.addressLine3,
                    addressLine4: null,
                    city: pudoCollectionPoint.city || address.city,
                    state: pudoCollectionPoint.state || address.state,
                    stateCode: address.stateCode || pudoCollectionPoint.stateCode,
                    countryCode: address.countryCode,
                    country: countryObj.name,
                    county: null,
                    zip: pudoCollectionPoint.zipCode || address.zipCode,
                    company: null,
                    firstName :address.firstName,
                    lastName :address.lastName,
                    phoneNumer : address.phoneNumber,
                    email :address.email,
                    name: pudoCollectionPoint.name || address.name,
                    instruction: '',
                    optionName: DelivaryOptionType.Dropship,
                    pickUpCenterId: shippingMethod && shippingMethod.pickUpLocation &&
                    shippingMethod.pickUpLocation.pickUpCenterId ? shippingMethod.pickUpLocation.pickUpCenterId : null,
                    latitude: this.selectedPudoCollectionPoint ? pudoCollectionPoint.geoPoint.latitude + '':'',
                    longitude:this.selectedPudoCollectionPoint? pudoCollectionPoint.geoPoint.longitude + '':'',
                    countryId: countryObj.countryId,
                    stateId: stateObj.id,
                    businessInformation: [],
                    residential: false,
                    validAddress: false,
                    addressType: AddressType.PUDO,
                    postalCode: pudoCollectionPoint.postalCode || address.postalCode,
                    pudoNetwork: pudoCollectionPoint.network,
                    pudoExternalId: pudoCollectionPoint.externalId,
                    pudoIdentifier: pudoCollectionPoint.identifier
                };
                return pudoDropShipAddress;
            }
        }


        getMembergovernmentIdentificationsInfo(memberId: number) {
            if(memberId){
                this._customerService.getMembergovernment_identifications(memberId).subscribe(response=>{
                  if(response){
                    this.memberInfo.memberGovernmentIdentifications = response.memberGovernmentIdentificationModel;
                    this.memberInfo.vatDetailModel = response.vatDetailModel;
                  }
                  if(this.selectedIsoCountryCode){
                        const countryObj = this.countries.filter((x: any) => x.isocodeThree === this.selectedIsoCountryCode)[0];
                        this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
                    }
                });
            }
    
        }

    buildPayByLinkForm() {
        this.emailForm = this._formbuilder.group({
            payByLinkEmail: ['', [Validators.required]]
        });
    }

    emailCheck() {
        if(this.emailForm.controls['payByLinkEmail'].value !== '' && this.emailForm.controls['payByLinkEmail'].valid) {
            this.isPayByLinkValid = true;
        } else {
            this.isPayByLinkValid = false;
        }
    }

    
getDropShipPudoShippingMethods(shippingOptions: ShippingOptionsRequest, shippingMethods: ShippingMethod[], mappingRequired: boolean = true) {
    if (this.shippingAddressInfoConfig && (this.shippingAddressInfoConfig.pudoLocationsEnabled || this.isDropShipOptionExist)) {
        if ((shippingOptions && shippingOptions.toAddress && shippingOptions.toAddress.countryCode && this.storeInfo && this.storeInfo.homeIsocodeThree)) {
            if (this.storeInfo.homeIsocodeThree.toUpperCase() != shippingOptions.toAddress.countryCode.toUpperCase()) {
                shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
            }
        } else {
            shippingOptions.toAddress = this._enrollmentCommonService.getWarehouseAddress(this.storeInfo, this.selectedIsoCountryCode);
        }
        shippingOptions.shippingTypeId = ShippingType.DELIVERY;

        this._orderService.getShipmentService(shippingOptions).subscribe((response) => {
            if (response && response.shippingMethods && response.shippingMethods.length > 0) {
                // Testing Purpose .
                //response.shippingMethods[0].pudoEnabled = true;
                this.dropshipPudoShippingMethod = response.shippingMethods.find((x) => x.pudoEnabled);
                if (mappingRequired) {
                    if (this.dropshipPudoShippingMethod) {
                        this.dropshipPudoShippingMethod.pickUpLocation = shippingMethods[0].pickUpLocation;
                    }
                }
            }
        }, (error) => {
        });
    }
}

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/orders/order-edit.component.ts